// JavaScript source code
// GOOGLE SHEETS INTEGRATION
class GoogleSheetsIntegration {
	constructor() {
		this.webAppUrl =
			"https://script.google.com/macros/s/AKfycbwru2A0dbJ4lYu9URlcboI3mBn9hKKBllHrmMCeDfzj6VXWKv6q0lFQpmlYPY7IoJam/exec";
	}

	async saveOrderToGoogleSheets(orderData) {
		try {
			console.log("Sending order to Google Sheets:", orderData);

			// Try fetch first
			try {
				const response = await fetch(this.webAppUrl, {
					method: "POST",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					},
					body: new URLSearchParams({
						action: "saveOrder",
						data: JSON.stringify(orderData)
					})
				});

				console.log("Fetch request completed");
				return { success: true, message: "Order sent successfully" };
			} catch (fetchError) {
				console.log("Fetch failed, trying form method:", fetchError);

				// Fallback to your original form method but with better error handling
				return this.fallbackFormSubmission(orderData);
			}
		} catch (error) {
			console.error("Error saving to Google Sheets:", error);
			throw error;
		}
	}

	fallbackFormSubmission(orderData) {
		return new Promise((resolve) => {
			const form = document.createElement("form");
			form.method = "POST";
			form.action = this.webAppUrl;
			form.target = "hidden_iframe_" + Date.now();

			const actionField = document.createElement("input");
			actionField.name = "action";
			actionField.value = "saveOrder";
			form.appendChild(actionField);

			const dataField = document.createElement("input");
			dataField.name = "data";
			dataField.value = JSON.stringify(orderData);
			form.appendChild(dataField);

			const iframe = document.createElement("iframe");
			iframe.name = form.target;
			iframe.style.display = "none";
			document.body.appendChild(iframe);
			document.body.appendChild(form);

			form.submit();

			setTimeout(() => {
				document.body.removeChild(form);
				document.body.removeChild(iframe);
				resolve({ success: true, message: "Form submitted" });
			}, 2000);
		});
	}
}

class RailwayAPI {
    constructor() {
        this.baseUrl = 'https://skip-api-production.up.railway.app'; 
        this.apiKey = '44094cb90e1d4987a730ed361f733ee6';              
    }

    async saveSelection(orderData) {
        try {
            console.log('💾 Saving to Railway:', orderData.weekId);
			console.log('📋 Full payload:', orderData); 
            
            const response = await fetch(`${this.baseUrl}/meal-selection`, {  
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': this.apiKey 
                },
                body: JSON.stringify(orderData)
            });

            const result = await response.json();
            
            if (result.success) {
                console.log('✅ Railway save successful');
                return { success: true, data: result };
            } else {
                throw new Error('Railway save failed: ' + (result.message || 'Unknown error'));
            }
        } catch (error) {
            console.error('❌ Railway save error:', error);
            return { success: false, error: error.message };
        }
    }

    async loadSelections(customerId, weeks = 4) {
        try {
            console.log(`☁️ Loading from Railway: customer ${customerId}, ${weeks} weeks`);
            
            const response = await fetch(`${this.baseUrl}/meal-selection/${customerId}?weeks=${weeks}`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const result = await response.json();
            
            if (result.success) {
                console.log('✅ Railway load successful:', Object.keys(result.selections).length, 'weeks');
                return { success: true, selections: result.selections };
            } else {
                throw new Error('Railway load failed');
            }
        } catch (error) {
            console.error('❌ Railway load error:', error);
            return { success: false, error: error.message };
        }
    }

    async deleteSelection(customerId, weekId) {
        try {
            console.log(`🗑️ Deleting from Railway: customer ${customerId}, week ${weekId}`);
            
            const response = await fetch(
                `${this.baseUrl}/meal-selection/${customerId}/${weekId}`, 
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': this.apiKey 
                    }
                }
            );

            const result = await response.json();
            
            if (result.success) {
                console.log('✅ Railway delete successful');
                return { success: true, data: result };
            } else {
                throw new Error('Railway delete failed');
            }
        } catch (error) {
            console.error('❌ Railway delete error:', error);
            return { success: false, error: error.message };
        }
    }
}

class SyncLogger {
	constructor(customerId) {
		this.customerId = customerId;
		this.storageKey = `sync_logs_${customerId}`;
		this.maxLogs = 100; 
	}

	log(event, data = {}) {
		try {
			const logEntry = {
				timestamp: new Date().toISOString(),
				event: event,
				customerId: this.customerId,
				...data
			};

			// Console log for debugging
			const emoji = this.getEventEmoji(event);
			console.log(`${emoji} [SYNC LOG] ${event}:`, data);

			// Store in localStorage
			this.saveToStorage(logEntry);

			// Send critical events to Google Sheets for monitoring
			if (this.isCriticalEvent(event)) {
				this.sendToSheets(logEntry);
			}
		} catch (error) {
			console.error("Failed to log event:", error);
		}
	}

	getEventEmoji(event) {
		const emojiMap = {
			load_local_start: "📂",
			load_local_success: "✅",
			load_local_error: "❌",
			load_cloud_start: "☁️",
			load_cloud_success: "✅",
			load_cloud_error: "❌",
			load_cloud_timeout: "⏰",
			sync_merge_start: "🔀",
			sync_merge_success: "✅",
			sync_conflict_detected: "⚠️",
			save_local_start: "💾",
			save_local_success: "✅",
			save_local_error: "❌",
			save_cloud_start: "☁️",
			save_cloud_success: "✅",
			save_cloud_error: "❌",
			background_sync_start: "🔄",
			background_sync_success: "✅",
			background_sync_error: "❌",
			data_cleanup: "🧹",
			version_mismatch: "⚠️",
			storage_quota_exceeded: "💥"
		};
		return emojiMap[event] || "📝";
	}

	isCriticalEvent(event) {
		const criticalEvents = [
			"save_cloud_error",
			"load_cloud_error",
			"sync_conflict_detected",
			"storage_quota_exceeded",
			"data_cleanup"
		];
		return criticalEvents.includes(event);
	}

	saveToStorage(logEntry) {
		try {
			let logs = [];
			const existing = localStorage.getItem(this.storageKey);

			if (existing) {
				logs = JSON.parse(existing);
			}

			logs.push(logEntry);

			// Keep only the most recent logs
			if (logs.length > this.maxLogs) {
				logs = logs.slice(-this.maxLogs);
			}

			localStorage.setItem(this.storageKey, JSON.stringify(logs));
		} catch (error) {
			console.error("Failed to save log to storage:", error);
		}
	}

	async sendToSheets(logEntry) {
		try {
			// Send critical logs to Google Sheets for monitoring
			const payload = {
				action: "logSyncEvent",
				data: JSON.stringify(logEntry)
			};

			// Fire and forget - don't wait for response
			const form = document.createElement("form");
			form.method = "POST";
			form.action =
				"https://script.google.com/macros/s/AKfycbxJUyhzeGXvHY7ZyznEW8IVhREaScHIb2S0yNHK9xq2MNr0byx_96f_gkYfW8WWO1NM/exec";
			form.target = `log_iframe_${Date.now()}`;
			form.style.display = "none";

			Object.keys(payload).forEach((key) => {
				const input = document.createElement("input");
				input.type = "hidden";
				input.name = key;
				input.value = payload[key];
				form.appendChild(input);
			});

			const iframe = document.createElement("iframe");
			iframe.name = form.target;
			iframe.style.display = "none";

			document.body.appendChild(iframe);
			document.body.appendChild(form);
			form.submit();

			setTimeout(() => {
				if (document.body.contains(form)) document.body.removeChild(form);
				if (document.body.contains(iframe)) document.body.removeChild(iframe);
			}, 2000);
		} catch (error) {
			console.error("Failed to send log to sheets:", error);
		}
	}

	getLogs(filter = {}) {
		try {
			const logs = JSON.parse(localStorage.getItem(this.storageKey) || "[]");

			if (filter.event) {
				return logs.filter((log) => log.event === filter.event);
			}

			if (filter.startDate) {
				const startDate = new Date(filter.startDate);
				return logs.filter((log) => new Date(log.timestamp) >= startDate);
			}

			return logs;
		} catch (error) {
			console.error("Failed to get logs:", error);
			return [];
		}
	}

	exportLogs() {
		const logs = this.getLogs();
		const dataStr = JSON.stringify(logs, null, 2);
		const dataBlob = new Blob([dataStr], { type: "application/json" });

		const url = URL.createObjectURL(dataBlob);
		const link = document.createElement("a");
		link.href = url;
		link.download = `sync-logs-${this.customerId}-${
			new Date().toISOString().split("T")[0]
		}.json`;
		link.click();

		URL.revokeObjectURL(url);
	}

	clearLogs() {
		localStorage.removeItem(this.storageKey);
		console.log("🧹 Sync logs cleared");
	}
}

// Make logger available globally for debugging
window.SyncLogger = SyncLogger;

class SyncStatusManager {
	constructor() {
		this.indicator = null;
		this.currentStatus = null;
		this.hideTimeout = null;
	}

	init() {
		this.indicator = document.getElementById("sync-status-indicator");
		if (!this.indicator) {
			console.warn("Sync status indicator element not found");
		}
	}

	show(status, message, duration = 3000) {
		if (!this.indicator) return;

		// Clear any existing hide timeout
		if (this.hideTimeout) {
			clearTimeout(this.hideTimeout);
		}

		// Update status
		this.currentStatus = status;

		// Remove all status classes
		this.indicator.className = "sync-status-indicator";

		// Add new status class
		this.indicator.classList.add(`sync-status-indicator--${status}`);

		// Update text
		const textElement = this.indicator.querySelector(".sync-text");
		if (textElement) {
			textElement.textContent = message;
		}

		// Show indicator
		this.indicator.style.display = "block";

		// Auto-hide after duration (except for syncing state)
		if (status !== "syncing" && duration > 0) {
			this.hideTimeout = setTimeout(() => {
				this.hide();
			}, duration);
		}
	}

	hide() {
		if (!this.indicator) return;

		this.indicator.style.animation = "slideOutRight 0.3s ease-in";

		setTimeout(() => {
			this.indicator.style.display = "none";
			this.indicator.style.animation = "";
			this.currentStatus = null;
		}, 300);
	}

	showSyncing() {
		this.show("syncing", "Syncing your meals...", 0);
	}

	showSuccess(message = "Synced successfully") {
		this.show("success", message, 3000);
	}

	showError(message = "Sync failed - saved locally") {
		this.show("error", message, 5000);
	}

	showOffline() {
		this.show("offline", "Offline - will sync when connected", 5000);
	}

	getCurrentStatus() {
		return this.currentStatus;
	}
}

// CUSTOMER PORTAL
class CustomerPortal {
	constructor(mealSelector) {
		this.mealSelector = mealSelector;
		this.customerId = mealSelector.customer.id;
		this.customerEmail = mealSelector.customer.email;
		this.emailInProgress = false;
		this.emailHistoryHandler = null;
		this.refreshHandler = null;
		this.init();
	}

	init() {
		// Small delay to ensure meal selector is fully initialized
		setTimeout(() => {
			this.loadPortalData();
		}, 100);
		this.bindPortalEvents();
		console.log("Customer Portal initialized");
	}

	bindPortalEvents() {
		const emailBtn = document.getElementById("download-history");
		const clearBtn = document.getElementById("clear-data");

		console.log("📧 Binding events - email button found:", !!emailBtn);

		if (emailBtn) {
			if (this.emailHistoryHandler) {
				emailBtn.removeEventListener("click", this.emailHistoryHandler);
			}

			this.emailHistoryHandler = (e) => {
				e.preventDefault();
				e.stopPropagation();
				console.log("📧 EMAIL BUTTON CLICKED!");
				this.emailHistory();
			};
			emailBtn.addEventListener("click", this.emailHistoryHandler);
		}

		if (clearBtn) {
			clearBtn.style.display = "inline-flex";

			if (this.refreshHandler) {
				clearBtn.removeEventListener("click", this.refreshHandler);
			}

			this.refreshHandler = (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.refreshStaleData();
			};
			clearBtn.addEventListener("click", this.refreshHandler);
		}
		// Delegate click handler for cancel buttons (handles dynamically rendered cards)
		const historyContainer = document.getElementById(
			"customer-meal-history-portal"
		);
		if (historyContainer) {
			historyContainer.addEventListener("click", (e) => {
				const btn = e.target.closest(".cancel-delivery-btn");
				if (!btn || btn.disabled) return;

				const weekId = btn.dataset.weekId;
				const displayName = btn.dataset.display;
				this.cancelDelivery(weekId, displayName);
			});
		}
	}
	clearActiveSelections() {
		console.log("🔄 Clear active selections requested");

		// Get the currently selected week
		const selectedWeek = this.mealSelector.selectedWeek;

		if (!selectedWeek) {
			alert("Please select a delivery week first.");
			return;
		}

		// Don't allow clearing past deadline weeks
		if (selectedWeek.isDeadlinePassed) {
			alert(
				"Cannot clear - this delivery deadline has passed.\n\nYou can only clear selections for upcoming deliveries."
			);
			return;
		}

		const weekId = selectedWeek.id;

		// Check if there's anything to clear
		const currentQuantities = this.mealSelector.mealQuantities[weekId] || {};
		const hasMeals = Object.values(currentQuantities).some((qty) => qty > 0);
		const hasProteinBalls = Object.values(
			this.mealSelector.proteinBallSelections[weekId] || {}
		).some(sel => sel && sel !== "none");

		if (!hasMeals && !hasProteinBalls) {
			alert(
				"Nothing to clear - your selections are already empty for " +
					selectedWeek.display
			);
			return;
		}

		const confirmed = confirm(
			"Clear your current selections for " +
				selectedWeek.display +
				"?\n\n" +
				"✓ This will reset what you see on screen\n" +
				"✓ Your saved order will remain until you save new selections\n\n" +
				"Continue?"
		);

		if (!confirmed) return;

		// Clear UI only (doesn't touch localStorage or Google Sheets)
		this.mealSelector.mealQuantities[weekId] = {};
		this.mealSelector.mealOptions[weekId] = {};
		this.mealSelector.proteinBallSelections[weekId] = {};

		// Refresh display
		this.mealSelector.renderMeals();
		this.mealSelector.updateOrderSummary();

		// Scroll to top
		window.scrollTo({ top: 0, behavior: "smooth" });

		console.log("✅ UI cleared for", weekId);

		// Show success message
		setTimeout(() => {
			alert(
				"✅ Selections cleared for " +
					selectedWeek.display +
					"!\n\nYou can now start fresh with your meal choices."
			);
		}, 300);
	}
	loadPortalData() {
		try {
			console.log("Loading portal data...");

			const weeklySelections = this.mealSelector.weeklySelections || {};
			const mealQuantities = this.mealSelector.mealQuantities || {};
			const mealOptions = this.mealSelector.mealOptions || {};

			const portalData = {};

			Object.keys(weeklySelections).forEach((weekId) => {
				if (
					weeklySelections[weekId] &&
					(weeklySelections[weekId].meals || weeklySelections[weekId].proteinBalls)
				) {
					portalData[weekId] = weeklySelections[weekId];
				}
			});
			const availableWeeks = this.mealSelector.getAvailableWeeks();
			console.log("Available weeks from selector:", availableWeeks);

			// Process each available week instead of hardcoded weeks
			availableWeeks.forEach((week) => {
				const weekId = week.id;

				if (!portalData[weekId]) {
					const weekQuantities = mealQuantities[weekId] || {};
					const weekOptions = mealOptions[weekId] || {};

					const hasMeals = Object.values(weekQuantities).some((qty) => qty > 0);

					if (hasMeals) {
						const convertedData = this.convertSelectorDataToPortalFormat(
							{ [weekId]: { hasSelection: true } },
							{ [weekId]: weekQuantities },
							{ [weekId]: weekOptions },
							week // Pass the week object for date/display info
						);

						if (convertedData[weekId]) {
							portalData[weekId] = convertedData[weekId];
						}
					}
				}
			});

			if (Object.keys(portalData).length > 0) {
				console.log("🔍 Final portal data keys:", Object.keys(portalData));
				console.log("📊 About to call renderPortalStats with data:", portalData);
				this.renderPortalStats(portalData);
				this.renderMealHistory(portalData);
			} else {
				this.renderEmptyPortal();
			}
		} catch (error) {
			console.error("Error loading portal data:", error);
			this.renderEmptyPortal();
		}
	}

	// FILTER DATA TO ONLY INCLUDE UPCOMING WEEKS FOR STATS
	getUpcomingWeeksOnly(data) {
		const upcomingData = {};
		const availableWeeks = this.mealSelector.getAvailableWeeks();

		// Get list of week IDs that are NOT past deadline
		const upcomingWeekIds = availableWeeks
			.filter((week) => !week.isDeadlinePassed)
			.map((week) => week.id);

		// Only include data for upcoming weeks
		Object.entries(data).forEach(([weekId, weekData]) => {
			if (weekId === "lastUpdated" || weekId === "customerInfo") return;

			if (upcomingWeekIds.includes(weekId)) {
				upcomingData[weekId] = weekData;
			}
		});

		return upcomingData;
	}

	// UPDATE in CustomerPortal class - renderPortalStats method
	renderPortalStats(data) {
		console.log("📊 renderPortalStats called with data keys:", Object.keys(data));

		try {
			const subscriptionEl = document.getElementById("meal-subscription");
			const totalMealsEl = document.getElementById("total-meals");
			const extraChargesEl = document.getElementById("extra-charges");

			// Check if user has a subscription
			if (!this.mealSelector.mealPlan) {
				// No subscription case
				if (subscriptionEl) {
					subscriptionEl.textContent = "No Active Subscription";
					subscriptionEl.style.color = "#856404";
				}
				if (totalMealsEl) {
					totalMealsEl.textContent = "N/A";
				}
				if (extraChargesEl) {
					extraChargesEl.textContent = "N/A";
				}

				console.log("📊 No subscription - stats display updated");
				return;
			}

			// Original code for users WITH subscription continues...
			const upcomingWeeks = this.getUpcomingWeeksOnly(data);
			console.log(
				"📊 Upcoming weeks after filtering:",
				Object.keys(upcomingWeeks)
			);

			let totalMeals = 0;
			let totalAddOnCharges = 0;

			Object.entries(upcomingWeeks).forEach(([weekId, weekData]) => {
				console.log(`📊 Processing week ${weekId}:`, weekData);

				if (weekData.meals) {
					const weekMealCount = weekData.meals.reduce(
						(sum, meal) => sum + meal.quantity,
						0
					);
					totalMeals += weekMealCount;

					const calculatedAddOnCost = weekData.meals.reduce((sum, meal) => {
						return sum + (meal.totalAddOnCost || 0);
					}, 0);
					totalAddOnCharges += calculatedAddOnCost;

					console.log(
						`📊 Week ${weekId}: ${weekMealCount} meals, $${calculatedAddOnCost} add-ons`
					);
				}
				if (weekData.proteinBalls && weekData.proteinBalls.price > 0) {
					totalAddOnCharges += weekData.proteinBalls.price;
					console.log(
						`📊 Week ${weekId}: +$${weekData.proteinBalls.price} protein balls`
					);
				}
			});

			console.log(
				`📊 Final totals: ${totalMeals} meals, $${totalAddOnCharges} add-ons`
			);

			if (subscriptionEl) {
				subscriptionEl.textContent =
					this.mealSelector.mealPlan?.planName || "Not Subscribed";
				subscriptionEl.style.color = ""; // Reset color to default
			}
			if (totalMealsEl) {
				totalMealsEl.textContent = totalMeals;
			}
			if (extraChargesEl) {
				extraChargesEl.textContent = "$" + totalAddOnCharges.toFixed(2);
			}

			console.log("📊 Stats updated successfully");
		} catch (error) {
			console.error("📊 Error in renderPortalStats:", error);
		}
	}

	renderMealHistory(data) {
		console.log("🔍 renderMealHistory called with data keys:", Object.keys(data));

		const container = document.getElementById("customer-meal-history-portal");
		if (!container) {
			console.log("❌ Container not found: customer-meal-history-portal");
			return;
		}

		const orders = [];
		const now = new Date();

		Object.entries(data).forEach(([weekId, weekData]) => {
			if (weekId === "lastUpdated" || weekId === "customerInfo") return;

			console.log(`🔍 Processing weekId: ${weekId}`, weekData);

			const weekInfo = this.mealSelector.getWeekInfo(weekId);
			let deliveryDate;
			try {
				deliveryDate = new Date(weekData.deliveryDate);
				if (isNaN(deliveryDate.getTime())) {
					deliveryDate = new Date(weekInfo.date + "T00:00:00");
				}
			} catch (error) {
				deliveryDate = new Date(weekInfo.date + "T00:00:00");
			}

			let deliveryDisplay = weekData.deliveryDisplay;
			if (!deliveryDisplay) {
				if (weekInfo && weekInfo.display) {
					deliveryDisplay = weekInfo.display;
				} else {
					// Fallback: create display from weekId
					const parts = weekId.split("-");
					if (parts.length === 4) {
						const dayType = parts[0];
						const year = parts[1];
						const month = parts[2];
						const day = parts[3];

						const date = new Date(year, month - 1, day);
						const dayName = dayType.charAt(0).toUpperCase() + dayType.slice(1);
						const monthNames = [
							"January",
							"February",
							"March",
							"April",
							"May",
							"June",
							"July",
							"August",
							"September",
							"October",
							"November",
							"December"
						];
						const monthName = monthNames[date.getMonth()];
						const dayNum = date.getDate();

						deliveryDisplay = `${dayName} ${monthName} ${dayNum}`;
					}
				}
			}

			const hasMeals = weekData.meals && weekData.meals.length > 0;
			const hasProteinBalls =
				weekData.proteinBalls && weekData.proteinBalls.selectedOption !== "none";
			const hasAnySelection = hasMeals || hasProteinBalls;

			const order = {
				weekId,
				deliveryDate,
				deliveryDisplay: deliveryDisplay,
				submissionTime: weekData.submissionTime, // ✅ FIXED - use weekData.submissionTime
				meals: weekData.meals || [],
				proteinBalls: weekData.proteinBalls || null,
				proteinBallsArray: weekData.proteinBallsArray || null,
				totals: weekData.totals || {
					baseMeals: 0,
					totalAddOnCost: 0,
					addOnDetails: []
				},
				status: deliveryDate > now ? "upcoming" : "delivered",
				hasSelection: hasAnySelection
			};

			console.log(`🔍 Created order for ${weekId}:`, order);
			orders.push(order);
		});

		console.log("🔍 Total orders created:", orders.length);

		if (orders.length === 0) {
			console.log("🔍 No orders found, showing empty message");
			container.innerHTML = `
        <div style="text-align: center; padding: 3rem; color: #666;">
          <h3>No meal selections yet</h3>
          <p>Use the meal selector above to start customizing your weekly meals!</p>
        </div>
      `;
			return;
		}

		// Get available weeks to check deadline status
		const availableWeeks = this.mealSelector.getAvailableWeeks();
		console.log(
			"🔍 Available weeks from selector:",
			availableWeeks.map((w) => ({
				id: w.id,
				isDeadlinePassed: w.isDeadlinePassed
			}))
		);

		// Filter to only show upcoming orders (not past deadline)
		const upcomingOrders = orders.filter((order) => {
			const matchingWeek = availableWeeks.find((week) => week.id === order.weekId);
			const isUpcoming = matchingWeek && !matchingWeek.isDeadlinePassed;

			console.log(
				`🔍 Order ${
					order.weekId
				}: matchingWeek=${!!matchingWeek}, isDeadlinePassed=${
					matchingWeek?.isDeadlinePassed
				}, isUpcoming=${isUpcoming}`
			);

			return isUpcoming;
		});

		console.log(
			"🔍 Upcoming orders after filtering:",
			upcomingOrders.length,
			"out of",
			orders.length
		);

		// Sort: Chronological by date extracted from weekId (e.g. sunday-2026-05-10)
		upcomingOrders.sort((a, b) => {
			// Extract date string from weekId — format is 'sunday-YYYY-MM-DD' or 'wednesday-YYYY-MM-DD'
			const extractDate = (weekId) => {
				const parts = weekId.split('-');
				// parts[0] = 'sunday'/'wednesday', parts[1..3] = YYYY, MM, DD
				if (parts.length >= 4) return new Date(`${parts[1]}-${parts[2]}-${parts[3]}`);
				return new Date(0);
			};
			const dateA = extractDate(a.weekId);
			const dateB = extractDate(b.weekId);

			// Primary sort: chronological by date
			if (dateA.getTime() !== dateB.getTime()) {
				return dateA - dateB;
			}

			// Secondary sort: within same date, Sunday before Wednesday
			const aIsSunday = a.weekId.startsWith('sunday');
			const bIsSunday = b.weekId.startsWith('sunday');
			if (aIsSunday && !bIsSunday) return -1;
			if (!aIsSunday && bIsSunday) return 1;
			return 0;
		});

		let html = "";

		if (upcomingOrders.length > 0) {
			console.log(
				"🔍 Rendering upcoming orders:",
				upcomingOrders.map((o) => o.weekId)
			);
			html +=
				'<h4 style="color: #333; margin-bottom: 2rem; margin-top: 1rem;">🗓️ Upcoming Deliveries</h4>';
			html += upcomingOrders
				.map((order) => this.renderHistoryCard(order))
				.join("");
		} else {
			console.log("🔍 No upcoming orders, showing no deliveries message");
			html += `
        <div style="text-align: center; padding: 3rem; color: #666;">
          <h3>No upcoming customizable deliveries</h3>
          <p>All current meal selection deadlines have passed. Check back for future weeks!</p>
        </div>
      `;
		}

		console.log("🔍 Setting container HTML, length:", html.length);
		container.innerHTML = html;
	}
	renderHistoryCard(order) {
		if (!order.hasSelection) {
			return `
				<div class="history-card">
					<div class="history-header">
						<div class="delivery-date">${order.deliveryDisplay}</div>
						<div class="delivery-status status-chef-choice">Chef's Choice</div>
					</div>
					<div style="text-align: center; padding: 2rem; color: #666;">
						<p>👨‍🍳 No meal selection was made by the deadline.</p>
						<p>You received a curated selection from our chef.</p>
					</div>
				</div>
			`;
		}

		let submissionText = "Selected";
		try {
			if (order.submissionTime) {
				const date = new Date(order.submissionTime);
				if (!isNaN(date.getTime())) {
					const dateStr = date.toLocaleDateString();
					const timeStr = date.toLocaleTimeString([], {
						hour: "2-digit",
						minute: "2-digit"
					});
					submissionText = `Selected: ${dateStr} at ${timeStr}`;
				}
			}
		} catch (error) {
			submissionText = "Selected";
		}

		return `
			<div class="history-card" data-card-week-id="${order.weekId}">
				<div class="history-header">
					<div class="delivery-date">${order.deliveryDisplay}</div>
					<div class="delivery-status" style="font-size: 1.1rem; color: #666; font-weight: normal;">
						${submissionText}
					</div>
				</div>
				${this.renderMealsList(
					order.meals,
					order.totals,
					order.proteinBalls,
					order.weekId,
					order.proteinBallsArray
				)}
			</div>
		`;
	}
	
	async cancelDelivery(weekId, displayName) {
		// Double-check the week isn't past deadline before proceeding
		const availableWeeks = this.mealSelector.getAvailableWeeks();
		const matchingWeek = availableWeeks.find((w) => w.id === weekId);

		if (!matchingWeek || matchingWeek.isDeadlinePassed) {
			alert("This delivery's deadline has passed and can no longer be cancelled.");
			return;
		}

		const confirmed = confirm(
			`Cancel your ${displayName} delivery?\n\n` +
			`This will permanently delete all meal selections for this day only. ` +
			`Your other deliveries will not be affected.\n\n` +
			`This action cannot be undone.`
		);

		if (!confirmed) return;

		const btn = document.querySelector(
			`.cancel-delivery-btn[data-week-id="${weekId}"]`
		);

		try {
			if (btn) {
				btn.disabled = true;
				btn.textContent = "⏳ Cancelling...";
			}

			this.mealSelector.syncStatus.showSyncing();

			const result = await this.mealSelector.railwayAPI.deleteSelection(
				this.customerId,
				weekId
			);

			if (result.success) {
				console.log(`✅ Deleted delivery for ${weekId}`);

				// Clear from frontend state
				delete this.mealSelector.weeklySelections[weekId];
				delete this.mealSelector.mealQuantities[weekId];
				delete this.mealSelector.mealOptions[weekId];
				delete this.mealSelector.proteinBallSelections[weekId];

				// Remove the card from the DOM immediately (no full reload needed)
				const card = document.querySelector(
					`.history-card[data-card-week-id="${weekId}"]`
				);
				if (card) {
					card.style.transition = "opacity 0.3s ease";
					card.style.opacity = "0";
					setTimeout(() => card.remove(), 300);
				}

				// Re-sync localStorage
				await this.mealSelector.saveToLocalStorage({
					weekId: weekId,
					meals: [],
					proteinBalls: null,
					isReplacement: true,
					customerId: this.customerId,
					customerEmail: this.mealSelector.customer.email,
					customerName: this.mealSelector.customer.name,
					deliveryDate: matchingWeek.deliveryDate.toISOString(),
					deliveryDay: weekId.startsWith("sunday") ? "Sunday" : "Wednesday",
					submissionTime: new Date().toISOString()
				});

				// Refresh stats and week cards
				this.loadPortalData();
				this.mealSelector.renderWeeks();

				this.mealSelector.syncStatus.showSuccess(
					`${displayName} delivery cancelled`
				);

				// If the cancelled week is currently selected in the meal UI, reset it
				if (
					this.mealSelector.selectedWeek &&
					this.mealSelector.selectedWeek.id === weekId
				) {
					this.mealSelector.clearAllWorkingSelections();
					this.mealSelector.updateOrderSummary();
				}
			} else {
				throw new Error(result.error || "Delete failed");
			}
		} catch (error) {
			console.error("❌ Cancel delivery error:", error);
			this.mealSelector.syncStatus.showError("Cancellation failed");
			alert(
				"❌ Could not cancel this delivery. Please try again or contact support."
			);

			if (btn) {
				btn.disabled = false;
				btn.textContent = "🗑️ Cancel Delivery";
			}
		}
	}

	renderMealsList(meals, totals, proteinBalls = null, weekId = null, proteinBallsArray = null) {
		let html = `
    	<div class="billing-summary">
    	<h5 style="margin: 0 0 1rem 0; font-size: 1.4rem; color: #3D081B;">Complete Meal Selection</h5>`;

		const groupedMeals = {};

		meals.forEach((meal) => {
			const mealKey = meal.name;

			if (!groupedMeals[mealKey]) {
				groupedMeals[mealKey] = {
					name: meal.name,
					totalQuantity: 0,
					addOns: {},
					totalAddOnCost: 0
				};
			}

			groupedMeals[mealKey].totalQuantity += meal.quantity;

			// ✅ USE THE PARSED OPTION DETAILS FROM CLOUD
			const optionDetails = meal.optionDetails || meal.OptionDetails;
			if (optionDetails) {
				Object.values(optionDetails).forEach((option) => {
					if (option.isSelected) {
						const optionKey = option.label;

						if (!groupedMeals[mealKey].addOns[optionKey]) {
							groupedMeals[mealKey].addOns[optionKey] = {
								label: option.label,
								price: option.price || 0,
								quantity: 0,
								totalCost: 0
							};
						}

						groupedMeals[mealKey].addOns[optionKey].quantity += meal.quantity;
						groupedMeals[mealKey].addOns[optionKey].totalCost +=
							(option.price || 0) * meal.quantity;
					}
				});
			}
		});

		Object.values(groupedMeals).forEach((mealGroup) => {
			mealGroup.totalAddOnCost = Object.values(mealGroup.addOns).reduce(
				(sum, addOn) => sum + addOn.totalCost,
				0
			);
		});

		// Calculate meal add-on costs
		let mealAddOnCost = Object.values(groupedMeals).reduce(
			(sum, mealGroup) => sum + mealGroup.totalAddOnCost,
			0
		);

		Object.values(groupedMeals).forEach((mealGroup) => {
			const hasAddOns = Object.keys(mealGroup.addOns).length > 0;

			html += `
      <div class="billing-row">
      <span style="display: flex; flex-direction: column; align-items: flex-start;">
        <span style="font-weight: 600; font-size: 1.3rem;">${mealGroup.name} (×${mealGroup.totalQuantity})</span>`;

			if (hasAddOns) {
				Object.values(mealGroup.addOns).forEach((addOn) => {
					html += `
          <span style="font-size: 1.1rem; color: #666; font-style: italic; margin-top: 0.2rem; margin-left: 1rem;">
          • ${addOn.label}`;
					if (addOn.price > 0) {
						html += ` (+$${addOn.price.toFixed(2)} each × ${
							addOn.quantity
						} = $${addOn.totalCost.toFixed(2)})`;
					} else {
						html += ` (×${addOn.quantity})`;
					}
					html += `</span>`;
				});
			}

			html += `
        </span>
        <span style="font-weight: 600; color: #3D081B;">
          ${mealGroup.totalAddOnCost > 0 ? `+$${mealGroup.totalAddOnCost.toFixed(2)}`: ""}
        </span>
        </div>
      `;
		});

		// ✅ ADD PROTEIN BALLS - supports multiple protein ball types
		let proteinBallCost = 0;
		const pbList = proteinBallsArray && proteinBallsArray.length > 0
			? proteinBallsArray
			: (proteinBalls && proteinBalls.selectedOption && proteinBalls.selectedOption !== 'none' ? [proteinBalls] : []);

		pbList.forEach(pb => {
			const cost = pb.price || 0;
			proteinBallCost += cost;
			html += `
				<div class="billing-row">
				<span style="display: flex; flex-direction: column; align-items: flex-start;">
					<span style="font-weight: 600; font-size: 1.3rem;">${pb.name} </span>
					<span style="font-size: 1.1rem; color: #666; font-style: italic; margin-top: 0.2rem; margin-left: 1rem;">
					• ${pb.optionLabel}
					</span>
				</span>
				<span style="font-weight: 600; color: #3D081B;">
					${cost > 0 ? `+$${cost.toFixed(2)}` : ''}
				</span>
				</div>
    		`;
		});

		// ✅ CORRECT TOTAL INCLUDING PROTEIN BALLS
		const grandTotalAddOnCost = mealAddOnCost + proteinBallCost;

		if (grandTotalAddOnCost > 0) {
			html += `
			<div class="billing-row billing-total">
			<span><strong>Total Add-on Charges:</strong></span>
			<span><strong>$${grandTotalAddOnCost.toFixed(2)}</strong></span>
			</div>
			`;
		}

		if (weekId) {
			const availableWeeks = this.mealSelector.getAvailableWeeks();
			const matchingWeek = availableWeeks.find((w) => w.id === weekId);
			const canCancel = matchingWeek && !matchingWeek.isDeadlinePassed;

			if (canCancel) {
				html += `
					<div style="margin-top: 1.5rem; padding-top: 0.7rem; padding-bottom: 0.15rem; border-top: 1px solid #e1e3e5; text-align: right;">
						<button
							type="button"
							class="cancel-delivery-btn"
							data-week-id="${weekId}"
							data-display="${matchingWeek.display}"
							title="Delete all meal selections for ${matchingWeek.display}">
							Delete Selections
						</button>
					</div>
				`;
			}
		}

		html += "</div>";
		return html;
	}

	convertSelectorDataToPortalFormat(
		weeklySelections,
		mealQuantities,
		mealOptions,
		weekInfo = null
	) {
		const converted = {};

		// NEW: Use the actual available weeks instead of hardcoded ones
		const availableWeeks = this.mealSelector.getAvailableWeeks();

		availableWeeks.forEach((week) => {
			const weekId = week.id;
			const weekQuantities = mealQuantities[weekId] || {};
			const weekOptions = mealOptions[weekId] || {};
			const weekSelection = weeklySelections[weekId] || {};

			const hasMeals = Object.values(weekQuantities).some((qty) => qty > 0);

			if (hasMeals || weekSelection.hasSelection) {
				const meals = [];
				const mealDatabase = this.getMealDatabase();

				Object.entries(weekQuantities).forEach(([mealId, quantity]) => {
					if (quantity > 0) {
						const mealInfo = mealDatabase[mealId] || {
							name: "Unknown Meal",
							description: ""
						};
						const selectedOptions = weekOptions[mealId] || {};
						const optionDetails = {};
						let totalAddOnCost = 0;

						Object.entries(selectedOptions).forEach(([optionKey, isSelected]) => {
							if (isSelected && mealInfo.options && mealInfo.options[optionKey]) {
								const option = mealInfo.options[optionKey];
								optionDetails[optionKey] = {
									label: option.label,
									price: option.price || 0,
									isSelected: true
								};
								totalAddOnCost += (option.price || 0) * quantity;
							}
						});

						meals.push({
							id: mealId,
							name: mealInfo.name,
							description: mealInfo.description,
							quantity: quantity,
							selectedOptions: selectedOptions,
							optionDetails: optionDetails,
							totalAddOnCost: totalAddOnCost
						});
					}
				});

				if (meals.length > 0) {
					converted[weekId] = {
						deliveryDate: week.deliveryDate.toISOString(),
						deliveryDisplay: week.display,
						submissionTime: weekSelection.submissionTime || new Date().toISOString(),
						meals: meals,
						totals: {
							baseMeals: meals.reduce((sum, meal) => sum + meal.quantity, 0),
							totalAddOnCost: meals.reduce(
								(sum, meal) => sum + meal.totalAddOnCost,
								0
							),
							addOnDetails: meals
								.filter((meal) => meal.totalAddOnCost > 0)
								.map((meal) => ({
									mealName: meal.name.replace(/<[^>]*>/g, '').trim(),
									optionName: Object.values(meal.optionDetails)
										.filter((opt) => opt.isSelected && opt.price > 0)
										.map((opt) => opt.label)
										.join(", "),
									quantity: meal.quantity,
									unitPrice: meal.totalAddOnCost / meal.quantity,
									totalPrice: meal.totalAddOnCost
								}))
						}
					};
				}
			}
		});

		return converted;
	}

	getMealDatabase() {
		if (this.mealSelector.weeklyMenus) {
			const allMeals = {};
			Object.values(this.mealSelector.weeklyMenus).forEach((weekMeals) => {
				weekMeals.forEach((meal) => {
					allMeals[meal.id] = meal;
				});
			});
			return allMeals;
		}
		return {};
	}

	async emailHistory() {
		console.log("📧 emailHistory() called - timestamp:", Date.now());
		console.trace("📧 Call stack");

		const emailBtn = document.getElementById("download-history");
		if (!emailBtn) {
			console.error("Email button not found");
			return;
		}
		if (emailBtn.disabled || this.emailInProgress) {
			console.log("📧 Email already in progress, ignoring duplicate call");
			return;
		}
		// Set flag and disable button immediately
		this.emailInProgress = true;
		emailBtn.disabled = true;
		const originalText = emailBtn.textContent;
		emailBtn.textContent = "📧 Sending...";

		try {
			const weeklySelections = this.mealSelector.weeklySelections || {};
			// FILTER OUT OLD FORMAT ENTRIES and duplicates
			const currentSelections = {};
			Object.entries(weeklySelections).forEach(([weekId, weekData]) => {
				if (
					weekId === "lastUpdated" ||
					weekId === "customerInfo" ||
					weekId === "migrationTimestamp"
				)
					return;

				// SKIP OLD FORMAT ENTRIES (they should be cleaned up, but just in case)
				if (weekId.match(/^(sunday|wednesday)-[01]$/)) {
					console.log(`📧 Skipping old format entry: ${weekId}`);
					return;
				}

				// Only include if it has actual meal data
				if (weekData && (weekData.meals || weekData.proteinBalls)) {
					currentSelections[weekId] = weekData;
				}
			});

			console.log(
				"📧 Current selections for email:",
				Object.keys(currentSelections)
			);

			if (Object.keys(currentSelections).length === 0) {
				console.log("📧 No current meal selections found");
				alert("No meal history found to email.");
				return;
			}

			console.log("📧 Building email content with current selections");
			const emailContent = this.buildEmailContent(currentSelections);
			await this.sendHistoryEmail(emailContent);
		} catch (error) {
			console.error("❌ Email error:", error);
			alert("❌ Email sending failed. Please contact support.");
		} finally {
			// Always reset the button state
			this.emailInProgress = false;
			emailBtn.disabled = false;
			emailBtn.textContent = originalText;
		}
	}

	buildEmailContent(data) {
		const orders = [];
		const now = new Date();

		// Process the data same as renderMealHistory
		Object.entries(data).forEach(([weekId, weekData]) => {
			if (weekId === "lastUpdated" || weekId === "customerInfo") return;

			let deliveryDate;
			let deliveryDisplay = weekData.deliveryDisplay;

			const availableWeeks = this.mealSelector.getAvailableWeeks();
			const weekInfo = availableWeeks.find((week) => week.id === weekId);

			try {
				deliveryDate = new Date(weekData.deliveryDate);
				if (isNaN(deliveryDate.getTime())) {
					deliveryDate = weekInfo ? weekInfo.deliveryDate : new Date();
				}
			} catch (error) {
				deliveryDate = weekInfo ? weekInfo.deliveryDate : new Date();
			}

			if (!deliveryDisplay && weekInfo) {
				deliveryDisplay = weekInfo.display;
			}

			const hasMeals = weekData.meals && weekData.meals.length > 0;
			const hasProteinBalls =
				weekData.proteinBalls && weekData.proteinBalls.selectedOption !== "none";
			const hasAnySelection = hasMeals || hasProteinBalls;

			orders.push({
				weekId,
				deliveryDate,
				deliveryDisplay: deliveryDisplay || weekId,
				meals: weekData.meals || [],
				proteinBalls: weekData.proteinBalls || null,
				totals: weekData.totals || {
					baseMeals: 0,
					totalAddOnCost: 0,
					addOnDetails: []
				},
				status: deliveryDate > now ? "upcoming" : "delivered",
				hasSelection: hasAnySelection
			});
		});

		// Sort chronologically (same as display)
		orders.sort((a, b) => a.deliveryDate - b.deliveryDate);

		let emailHtml = `
		<style>
			/* Light mode logo (default) */
			.logo-light {
				display: block !important;
				max-width: 200px;
				height: auto;
				margin-bottom: 5px;
				border-radius: 5px;
				background-color: #ffffff;
				padding: 5px;
			}

			.logo-dark {
				display: none !important;
				max-width: 200px;
				height: auto;
				margin-bottom: 5px;
				border-radius: 5px;
				background-color: transparent;
				padding: 5px;
			}

			/* Dark mode - swap the logos */
			@media (prefers-color-scheme: dark) {
				.logo-light {
					display: none !important;
				}

				.logo-dark {
					display: block !important;
				}

				.email-content {
					background-color: transparent !important;
					color: #ffffff !important;
				}

				.logo-container {
					background-color: transparent !important;
					border-color: #444444 !important;
				}

				.logo-text {
					color: #ffffff !important;
				}
			}

			/* Outlook fallback */
			[data-ogsc] .logo-light {
				display: block !important;
			}

			[data-ogsc] .logo-dark {
				display: none !important;
			}
		</style>

		<div class="email-content" style="background-color: #ffffff; color: #333333; font-family: Arial, sans-serif; line-height: 1.6; max-width: 600px; margin: 0 auto; padding: 20px;">

			<p style="font-size: 16px; line-height: 1.5; color: #333333; margin: 0 0 15px 0;">Hello ${
				this.mealSelector.customer.firstName || "Valued Customer"
			},</p>
			<p style="font-size: 16px; line-height: 1.5; color: #333333; margin: 0 0 20px 0;">Here's a complete summary of your recent meal selections:</p>
			`;
		// Add upcoming deliveries
		const upcomingOrders = orders.filter((o) => o.status === "upcoming");
		if (upcomingOrders.length > 0) {
			emailHtml +=
				'<h3 style="color: #3D081B; margin: 20px 0 15px 0; font-size: 18px;">🗓️ Upcoming Deliveries</h3>';
			upcomingOrders.forEach((order) => {
				emailHtml += this.buildEmailOrderSection(order);
			});
		}

		// Add past deliveries
		const pastOrders = orders.filter((o) => o.status === "delivered");
		if (pastOrders.length > 0) {
			emailHtml +=
				'<h3 style="color: #3D081B; margin: 20px 0 15px 0; font-size: 18px;">📦 Past Deliveries</h3>';
			pastOrders.forEach((order) => {
				emailHtml += this.buildEmailOrderSection(order);
			});
		}

		emailHtml += `
		<br>
		<p style="color: #333333; margin: 20px 0; font-size: 16px;">Thank you for choosing Primal Balance Nutrition!</p>
		<p style="color: #333333; margin: 10px 0; font-size: 16px;">If you have any questions about your meal selections, please don't hesitate to <a href="mailto:support@primalbalancenutrition.com" style="color: #3D081B; text-decoration: none; font-weight: 600; border-bottom: 1px solid #3D081B;">contact us</a>.</p>
		<br>
		<p style="color: #333333; margin: 20px 0; font-size: 16px;">Best regards,<br>The Primal Balance Nutrition Team</p>

		<!-- Logo container with both light and dark versions -->
		<div style="background-color: #ffffff; padding: 25px; text-align: left; border-radius: 10px; margin: 20px 0; border: 2px solid #f0f0f0;">

			<!-- Light mode logo (default - always visible) -->
			<img src="https://cdn.shopify.com/s/files/1/0845/3564/0380/files/rollies_1.jpg" alt="Primal Balance Nutrition" style="max-width: 200px !important; width: 200px !important; height: auto !important; margin-bottom: 5px; border-radius: 5px; background-color: #ffffff; padding: 5px; display: block;">

			<!-- Dark mode logo (hidden by default, shown only in dark mode) -->
			<!--[if !mso]><!-->
			<div style="display: none;">
				<style>
					@media (prefers-color-scheme: dark) {
						.light-only {
							display: none !important;
						}

						.dark-only {
							display: block !important;
						}

						.logo-container-dark {
							background-color: transparent !important;
							border-color: #444 !important;
						}

						.logo-text-dark {
							color: #ffffff !important;
						}
					}
				</style>
				<img class="dark-only" src="https://www.primalbalancenutrition.com/cdn/shop/files/Green_Minimalist_Aesthetic_Fashion_Studio_Style_Guide_Brand_Board_1.png" alt="Primal Balance Nutrition" style="max-width: 200px !important; width: 200px !important; height: auto !important; margin-bottom: 5px; border-radius: 5px; padding: 5px; display: none;">
			</div>
			<!--<![endif]-->

			<p style="margin: 5px 0 0 0; color: #333333; font-size: 14px;">Fresh, Balanced, Delicious</p>
		</div>
		`;

		return emailHtml;
	}
	buildEmailOrderSection(order) {
		if (!order.hasSelection) {
			return `
		<div style="border: 1px solid #ddd; padding: 15px; margin: 10px 0; border-radius: 5px; background-color: #f9f9f9 !important; color: #333333 !important;">
			<h4 style="color: #3D081B !important; margin: 0 0 10px 0;">${order.deliveryDisplay}</h4>
			<p style="color: #333333 !important; margin: 5px 0;">👨‍🍳 Chef's Choice - No specific meals were selected for this delivery.</p>
		</div>
		`;
		}

		let html = `
		<div style="border: 1px solid #ddd; padding: 15px; margin: 10px 0; border-radius: 5px; background-color: #f9f9f9 !important; color: #333333 !important;">
			<h4 style="color: #3D081B !important; margin: 0 0 10px 0;">${order.deliveryDisplay}</h4>
			<h5 style="color: #333333 !important; margin: 0 0 10px 0;">Complete Meal Selection:</h5>
			`;

		// Group meals by name (same logic as display)
		const groupedMeals = {};

		(order.meals || []).forEach((meal) => {
			const mealKey = meal.name;

			if (!groupedMeals[mealKey]) {
				groupedMeals[mealKey] = {
					name: meal.name,
					totalQuantity: 0,
					addOns: {},
					totalAddOnCost: 0
				};
			}

			groupedMeals[mealKey].totalQuantity += meal.quantity;

			if (meal.optionDetails) {
				Object.values(meal.optionDetails).forEach((option) => {
					if (option.isSelected) {
						const optionKey = option.label;

						if (!groupedMeals[mealKey].addOns[optionKey]) {
							groupedMeals[mealKey].addOns[optionKey] = {
								label: option.label,
								price: option.price || 0,
								quantity: 0,
								totalCost: 0
							};
						}

						groupedMeals[mealKey].addOns[optionKey].quantity += meal.quantity;
						groupedMeals[mealKey].addOns[optionKey].totalCost +=
							(option.price || 0) * meal.quantity;
					}
				});
			}
		});

		Object.values(groupedMeals).forEach((mealGroup) => {
			mealGroup.totalAddOnCost = Object.values(mealGroup.addOns).reduce(
				(sum, addOn) => sum + addOn.totalCost,
				0
			);
		});

		// Display each meal with inline styles
		Object.values(groupedMeals).forEach((mealGroup) => {
			html += `<div style="margin: 10px 0; padding: 10px; background-color: #ffffff !important; border-radius: 5px; border: 1px solid #e0e0e0; color: #333333 !important;">`;
			html += `<strong style="color: #3D081B !important;">${mealGroup.name} (×${mealGroup.totalQuantity})</strong>`;

			if (Object.keys(mealGroup.addOns).length > 0) {
				html += `<ul style="margin: 5px 0 0 20px; color: #333333 !important; padding-left: 0;">`;
				Object.values(mealGroup.addOns).forEach((addOn) => {
					html += `<li style="color: #333333 !important; margin: 2px 0;">${addOn.label}`;
					if (addOn.price > 0) {
						html += ` (+${addOn.price.toFixed(2)} each × ${
							addOn.quantity
						} = ${addOn.totalCost.toFixed(2)})`;
					} else {
						html += ` (×${addOn.quantity})`;
					}
					html += `</li>`;
				});
				html += `</ul>`;
			}
			html += `</div>`;
		});

		// ADDED: Include protein balls in email with inline styles
		let proteinBallCost = 0;
		if (
			order.proteinBalls &&
			order.proteinBalls.selectedOption &&
			order.proteinBalls.selectedOption !== "none"
		) {
			proteinBallCost = order.proteinBalls.price || 0;

			html += `<div style="margin: 10px 0; padding: 10px; background-color: #ffffff !important; border-radius: 5px; border: 1px solid #e0e0e0; color: #333333 !important;">`;
			html += `<strong style="color: #3D081B !important;">${order.proteinBalls.name} </strong>`; /*🍪🍫*/
			html += `<ul style="margin: 5px 0 0 20px; color: #333333 !important; padding-left: 0;">`;
			html += `<li style="color: #333333 !important; margin: 2px 0;">${order.proteinBalls.optionLabel}`;
			if (proteinBallCost > 0) {
				html += ` (+${proteinBallCost.toFixed(2)})`;
			}
			html += `</li>`;
			html += `</ul>`;
			html += `</div>`;
		}
		const mealAddOnCost = Object.values(groupedMeals).reduce(
			(sum, mealGroup) => sum + mealGroup.totalAddOnCost,
			0
		);
		const totalAddOnCost = mealAddOnCost + proteinBallCost;

		if (totalAddOnCost > 0) {
			html += `<div style="margin-top: 15px; padding: 10px; background-color: #e8f5e8 !important; font-weight: bold; border-radius: 5px; color: #333333 !important;">`;
			html += `Total Add-on Charges: ${totalAddOnCost.toFixed(2)}`;
			html += `</div>`;
		}

		html += `</div>`;
		return html;
	}

	async sendHistoryEmail(emailContent) {
		const emailData = {
			action: "sendEmail",
			data: {
				to: this.customerEmail,
				customerName:
					this.mealSelector.customer.firstName || this.mealSelector.customer.name,
				subject: "Your Meal History - Primal Balance Nutrition",
				htmlContent: emailContent,
				timestamp: new Date().toISOString()
			}
		};

		return new Promise((resolve, reject) => {
			try {
				console.log("📧 Sending email with data:", emailData);

				if (!this.mealSelector.googleSheets) {
					this.mealSelector.googleSheets = new GoogleSheetsIntegration();
				}

				const form = document.createElement("form");
				form.method = "POST";
				form.action = this.mealSelector.googleSheets.webAppUrl;
				form.target = "email_iframe_" + Date.now();
				form.style.display = "none";

				const actionField = document.createElement("input");
				actionField.type = "hidden";
				actionField.name = "action";
				actionField.value = "sendEmail";
				form.appendChild(actionField);

				const dataField = document.createElement("input");
				dataField.type = "hidden";
				dataField.name = "data";
				dataField.value = JSON.stringify(emailData.data);
				form.appendChild(dataField);

				const iframe = document.createElement("iframe");
				iframe.name = form.target;
				iframe.style.display = "none";

				document.body.appendChild(iframe);
				document.body.appendChild(form);

				// Submit form ONCE
				form.submit();
				console.log("✅ Email form submitted");

				// Show success message after delay
				setTimeout(() => {
					alert(
						"📧 Your meal history has been emailed to " +
							this.customerEmail +
							"!\n\nPlease check your inbox in a few minutes."
					);
					resolve(); // Resolve the promise
				}, 2000);

				// Cleanup
				setTimeout(() => {
					if (document.body.contains(form)) document.body.removeChild(form);
					if (document.body.contains(iframe)) document.body.removeChild(iframe);
				}, 5000);
			} catch (error) {
				console.error("❌ Email send failed:", error);
				reject(error);
			}
		});
	}

	clearLocalData() {
		if (
			confirm(
				"⚠️ This will clear all your local meal selection data. This cannot be undone. Are you sure?"
			)
		) {
			const storageKey = `meal_selections_${this.customerId}`;
			localStorage.removeItem(storageKey);
			alert("🗑️ Local data cleared. The page will refresh.");
			window.location.reload();
		}
	}

	refreshStaleData() {
		if (this.refreshInProgress) {
			return;
		}
		this.refreshInProgress = true;

		if (
			confirm(
				"Clear active selections? This will clear any unsaved selections for upcoming deliveries but keep your saved meals from past deadlines."
			)
		) {
			// Get available weeks to determine which are still active
			const availableWeeks = this.mealSelector.getAvailableWeeks();
			const activeWeekIds = availableWeeks
				.filter((week) => !week.isDeadlinePassed)
				.map((week) => week.id);

			console.log("Active (clearable) weeks:", activeWeekIds);
			console.log("Preserving past deadline weeks");

			// Clear working selections for ALL weeks (this affects the current UI)
			this.mealSelector.mealQuantities = {};
			this.mealSelector.mealOptions = {};
			this.mealSelector.proteinBallSelections = {};

			// Clear saved selections ONLY for active weeks (preserve past deadline saves)
			activeWeekIds.forEach((weekId) => {
				if (this.mealSelector.weeklySelections[weekId]) {
					console.log(`Clearing saved selection for active week: ${weekId}`);
					delete this.mealSelector.weeklySelections[weekId];
				}
			});

			// Update localStorage with the filtered data
			const storageKey = `meal_selections_${this.mealSelector.customer.id}`;
			const currentData = JSON.parse(localStorage.getItem(storageKey) || "{}");

			// Remove active weeks from localStorage too
			activeWeekIds.forEach((weekId) => {
				if (currentData[weekId]) {
					delete currentData[weekId];
				}
			});

			currentData.lastUpdated = new Date().toISOString();
			localStorage.setItem(storageKey, JSON.stringify(currentData));

			// Refresh displays
			this.mealSelector.renderWeeks();
			this.loadPortalData();

			alert("Active selections cleared successfully.");
		}

		this.refreshInProgress = false;
	}

	renderEmptyPortal() {
		const subscriptionEl = document.getElementById("meal-subscription");
		const totalMealsEl = document.getElementById("total-meals");
		const extraChargesEl = document.getElementById("extra-charges");

		if (subscriptionEl) {
			subscriptionEl.textContent =
				this.mealSelector.mealPlan?.planName || "No Active Subscription";
		}
		if (totalMealsEl) {
			totalMealsEl.textContent = "0";
		}
		if (extraChargesEl) {
			extraChargesEl.textContent = "$0.00";
		}

		const container = document.getElementById("customer-meal-history-portal");
		if (container) {
			container.innerHTML = `
                <div style="text-align: center; padding: 3rem; color: #666;">
                <h3>No meal selections yet</h3>
                <p>Use the meal selector above to start customizing your weekly meals!</p>
                </div>
                `;
		}
	}
}

// MAIN WEEKLY MEAL SELECTOR CLASS - ***** only need to update these dates/times *****
class WeeklyMealSelector {
	
	constructor() {
		this.dataVersion = "2026-04-20";

		this.weekConfig = {
			version: this.dataVersion,
			availableWeeks: [
				{
					id: "2026-05-24",
                        sundayDate: "2026-05-24",
                        wednesdayDate: "2026-05-27",
                        sundayDisplay: "Sunday May 24",
                        wednesdayDisplay: "Wednesday May 27",
                        deadline: "2026-05-19T16:00:00",
                        deadlineDisplay: "Tue 5/19 at 4:00 PM"
				},
				{
					id: "2026-05-03",
					sundayDate: "2026-05-03",
					wednesdayDate: "2026-05-06",
					sundayDisplay: "Sunday May 03",
					wednesdayDisplay: "Wednesday May 06",
					deadline: "2026-04-28T16:00:00",
					deadlineDisplay: "Tue 4/28 at 4:00 PM"
				},
				{
                        id: "2026-05-10",
                        sundayDate: "2026-05-10",
                        wednesdayDate: "2026-05-13",
                        sundayDisplay: "Sunday May 10",
                        wednesdayDisplay: "Wednesday May 13",
                        deadline: "2026-05-05T16:00:00",
                        deadlineDisplay: "Tue 5/5 at 4:00 PM"
                },
                {
                        id: "2026-05-17",
                        sundayDate: "2026-05-17",
                        wednesdayDate: "2026-05-20",
                        sundayDisplay: "Sunday May 17",
                        wednesdayDisplay: "Wednesday May 20",
                        deadline: "2026-05-12T16:00:00",
                        deadlineDisplay: "Tue 5/12 at 4:00 PM"
                }
			]
		};

		this.timezone = {
			name: "Pacific",
			utcOffset: -8, // PST
			dstOffset: -7 // PDT
		};
		this.customer = window.customerData || {};

		// Core state management
		this.selectedWeek = null;
		this.weeklySelections = {};
		this.mealQuantities = {};
		this.mealOptions = {};
		this.proteinBallSelections = {};

		// For guests, create a temporary ID and basic info
		if (this.customer.isGuest) {
			console.log("Guest user detected - showing read-only interface");
			this.customer.id = this.customer.id || "guest_" + Date.now();
			this.customer.email = this.customer.email || "guest@temp.com";
			this.customer.name = "Guest";
			this.customer.tags = [];
		}

		this.weeklyMenus = this.initializeMenus();
		this.mealPlan = this.getMealPlanFromCustomer();
		// Detect if user is a non-subscriber
		this.isNonSubscriber = this.checkIfNonSubscriber();

		if (this.isNonSubscriber) {
			this.enableNonSubscriberMode();
		}

		this.planPricing = {
			//extraMealPrice: 16.5,
			minimumOrderWarning: 4
		};
		console.log("Customer meal plan detected:", this.mealPlan);

		this.googleSheets = new GoogleSheetsIntegration();
		this.railwayAPI = new RailwayAPI();
		this.syncLogger = new SyncLogger(this.customer.id);
		this.syncStatus = new SyncStatusManager();

		// Initialize sync status indicator
		setTimeout(() => {
			this.syncStatus.init();
		}, 100);

		window.addEventListener("online", () => {
			console.log("📶 Back online - ready to sync");
			this.syncStatus.showSuccess("Back online!");
		});

		window.addEventListener("offline", () => {
			console.log("📵 Offline mode - will sync when connected");
			this.syncStatus.showOffline();
		});

		this.forceMobileCleanup();

		// Make init async-aware
		this.init().catch(error => {
			console.error('❌ Init error:', error);
			// Ensure UI still renders even if init fails
			this.renderWeeks();
			this.bindEvents();
		});
		this.debouncedUpdateSummary = this.debounce(
			this.updateOrderSummary.bind(this),
			150
		);
		if (
			!this.customer.isGuest &&
			!localStorage.getItem(`cleanup_completed_${this.customer.id}`)
		) {
			this.performLegacyDataCleanup();
			localStorage.setItem(`cleanup_completed_${this.customer.id}`, "true");
		}
	}

	performLegacyDataCleanup() {
		try {
			console.log("Performing automatic legacy data cleanup...");

			const storageKey = `meal_selections_${this.customer.id}`;
			const data = JSON.parse(localStorage.getItem(storageKey) || "{}");

			// Check if cleanup is needed
			const hasLegacyData = Object.keys(data).some(
				(key) =>
					key.match(/^(sunday|wednesday)-[01]$/) || key === "migrationTimestamp"
			);

			if (!hasLegacyData) {
				console.log("No legacy data found, cleanup not needed");
				return;
			}

			console.log("Legacy data detected, cleaning up...");

			const cleanData = {};

			// Keep metadata
			if (data.lastUpdated) cleanData.lastUpdated = data.lastUpdated;
			if (data.customerInfo) cleanData.customerInfo = data.customerInfo;
			
			Object.entries(data).forEach(([key, value]) => {
				if (
					key !== "lastUpdated" &&
					key !== "customerInfo" &&
					key !== "migrationTimestamp" &&
					!key.match(/^(sunday|wednesday)-[01]$/) &&
					!cleanData[key]
				) {
					cleanData[key] = value;
				}
			});

			// Save cleaned data
			cleanData.lastUpdated = new Date().toISOString();
			cleanData.cleanupPerformed = new Date().toISOString();
			localStorage.setItem(storageKey, JSON.stringify(cleanData));

			this.loadExistingSelections();

			console.log("Legacy data cleanup completed successfully");
		} catch (error) {
			console.error("Error during legacy data cleanup:", error);
		}
	}
	// Helper method for display names
	getDisplayForDate(dateStr) {
		const date = new Date(dateStr);
		const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
		const monthName = date.toLocaleDateString("en-US", { month: "long" });
		const dayNum = date.getDate();
		return `${dayName} ${monthName} ${dayNum}`;
	}

	getWeekInfo(weekId) {
		const parts = weekId.split("-");
		const dayType = parts[0];
		const dateStr = parts.slice(1).join("-");

		let weekConfig = this.weekConfig.availableWeeks.find((week) => {
			return week.sundayDate === dateStr || week.wednesdayDate === dateStr;
		});

		if (!weekConfig) {
			console.warn(`Week config not found for ${weekId}`);
			return {
				date: dateStr,
				display: `${dayType} ${dateStr}`,
				deadline: { date: new Date().toISOString(), displayText: "Unknown" },
				weekNumber: 0
			};
		}

		const date =
			dayType === "sunday" ? weekConfig.sundayDate : weekConfig.wednesdayDate;
		const display =
			dayType === "sunday" ? weekConfig.sundayDisplay : weekConfig.wednesdayDisplay;

		return {
			date: date,
			display: display,
			deadline: {
				date: weekConfig.deadline,
				displayText: weekConfig.deadlineDisplay
			},
			weekNumber: 0
		};
	}

	debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

	initDOMCache() {
		this.domCache = {
			weekGrid: document.querySelector("[data-week-grid]"),
			mealSection: document.querySelector("[data-meal-section]"),
			mealsGrid: document.querySelector("[data-meals-grid]"),
			summaryContent: document.querySelector("[data-order-summary]"),
			totalSection: document.querySelector("[data-order-total]"),
			totalCount: document.querySelector("[data-total-count]"),
			saveBtn: document.querySelector("[data-save-order]"),
			weekTitle: document.querySelector("[data-week-title]"),
			deadlineNotice: document.querySelector("[data-deadline-notice]")
		};
	}
	isProteinBallMeal(mealId) {
		return mealId.startsWith("prb");
	}
	initializeMenus() {
		return {
			"sunday-2026-05-10": [
                {
                        id: "ckn137",
                        name: "Pumpkin Coconut Curry",
                        description: "A rich, fragrant pumpkin coconut curry simmered with tender butternut squash, sautéed zucchini, and Rosie's Organic Chicken Breast. Slow-cooked in our house-made blend of coriander, cumin, cinnamon, and curry spices. Served over a fluffy bed of organic white jasmine rice. (P:46g F:14g C:50g)= 510 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/ChickenCurry-800.jpg?v=1768796394",
                        shopifyHandle: "ckn137",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                vegan: { label: "Vegan (sub tofu)" }
                        }
                },
                {
                        id: "ckn133",
                        name: "Peruvian Braised Chicken",
                        description: "with smashed Yukon gold baby potatoes, roasted garlic olive oil asparagus, Rosie's organic chicken breast, and topped with our house made Peruvian sauce (P:43g F:20g C:45g)= 532 calories<h4>**contains eggs, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Peruvian-Chicken-800.jpg?v=1756357023",
                        shopifyHandle: "ckn133",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 },
                                vegan: { label: "Vegan (sub garbanzo beans)" }
                        }
                },
                {
                        id: "bef120",
                        name: "Hot Honey Grass-Fed Beef Bowl",
                        description: "with roasted yams, garlic olive oil asparagus, Cape Grim grass-fed/finished beef, and topped with our house made hot honey sauce and avocado (P:42g F:25g C:45g)= 573 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/HotHoney-BeefBowl-800.jpg?v=1769587709",
                        shopifyHandle: "bef120",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 },
                                vegan: { label: "Vegan (sub blackened tempeh)" }
                        }
                },
                {
                        id: "prk107",
                        name: "Coffee Rubbed Braised Pork",
                        description: "White quinoa, carrots, chickpeas, cucumber, red bell pepper, red onion, parsley, garlic, Healthy On You coffee rub spice blend, pork shoulder, raw local honey, rosemary white wine sauce, maple butternut squash (P: 44g F: 34g C: 45g) = 660 calories<h4>**contains pork**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/coffeeRubbedPork.jpg?v=1777402919",
                        shopifyHandle: "prk107",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "trk103",
                        name: "Honey Ginger Turkey Bowl",
                        description: "with white jasmine rice, garlic green beans, orange cauliflower, Diestel organic turkey, and topped with our house made honey ginger sauce (P:50g F:20g C:40g)= 540 calories<h4>**contains coconut, sesame**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/HoneyGingerTurkeyBowl-800.jpg?v=1757070988",
                        shopifyHandle: "trk103",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 },
                                vegan: { label: "Vegan (sub tofu)" }
                        }
                },
                {
                        id: "ckn144",
                        name: "Mediterranean Chicken Bowl",
                        description: "With brown rice, lentils, pickled onions, cucumber, tomato, red onion, garlic, Rosie’s chicken thighs, harissa spice blend, house-made yogurt dill sauce (P: 45g F: 28g C: 52g) = 660 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/MediterraneanChickenBowl.jpg?v=1777403555",
                        shopifyHandle: "ckn144",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 }
                        }
                },
                {
                        id: "fsh117",
                        name: "Mint Chimichurri Salmon",
                        description: "with baby gold potatoes, asparagus, Sky steelhead, and topped with our mint chimichurri sauce (P: 38g F: 24g C: 38g) = 520 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/ChimichurriSalmonPlated.jpg?v=1777405144",
                        shopifyHandle: "fsh117",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk113",
                        name: "Mediterranean Breakfast Bowl",
                        description: "Golden quinoa layered with sautéed baby green kale, blistered cherry tomatoes, and briny green olives, topped with three San Diego pastured poached eggs and herb sage chicken sausage. Finished with our house-made mint chimichurri for a fresh, vibrant, and savory kick in every bite (P:33g F:23g C:33g)= 471 calories<h4>**contains eggs**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/mediterranianBowl-800.jpg?v=1772384289",
                        shopifyHandle: "brk113",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk120",
                        name: "Pesto Breakfast Bowl",
                        description: "with roasted gold baby potatoes, sauté kale, blistered cherry tomatoes, Italian chicken sausage, 2 poached San Diego pastured eggs, and topped with our house made pesto sauce (P:38g F:25g C:42g)= 545 calories<h4>**contains pumpkin seeds, eggs, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Pesto-Breakfast-Bowl-800.jpg?v=1759135543",
                        shopifyHandle: "brk120",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "prb101",
                        name: "Birthday Cake Protein Balls",
                        description: "with Enjoy Life white chocolate chips, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:12g F:10g C:15g)= 200 calories per two balls<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/birthdayCake-ProteinBalls-800.jpg?v=1760241997",
                        shopifyHandle: "prb101",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                },
                {
                        id: "prb109",
                        name: "Pumpkin Protein Balls w/ white chocolate chips",
                        description: "with Enjoy Life white chocolate chips, pumpkin spice, sugar free pumpkin pure, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:12g F:10g C:15g)= 200 calories per two balls<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/pumpkin-whiteChocolateChip-800.jpg?v=1764574403",
                        shopifyHandle: "prb109",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                }
        	],
        	"wednesday-2026-05-13": [
                {
                        id: "prk102",
                        name: "Carnitas Pork Bowl",
                        description: "with white jasmine rice, fresh corn, chipotle black beans, roasted zucchini, braised pork shoulder, and topped with our cilantro lime crema sauce (P:50g F:30g C:45g)= 650 calories<h4>**contains eggs, coconut, pork**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/carnitasBowl-800.jpg?v=1766586779",
                        shopifyHandle: "prk102",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "ckn134",
                        name: "Pesto Chicken Pasta",
                        description: "with Jovial gluten free pasta, sauté green kale, blistered cherry tomatoes, Rosie's organic chicken breast, and topped with our house made pesto sauce (P:41g F:15g C:35g)= 489 calories<h4>**contains Pumpkin seeds, basil**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/pesto-ChickenPasta-800.jpg?v=1769944441",
                        shopifyHandle: "ckn134",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 }
                        }
                },
                {
                        id: "ckn126",
                        name: "Jamaican Jerk Chicken Thighs",
                        description: "with fire roasted yams, roasted cauliflower, and Jamaican jerk Rosie's organic chicken thighs (P:41g F:15g C:46g) = 483 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Jamacian-ChickenThighs-800.jpg?v=1759753687",
                        shopifyHandle: "ckn126",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "bef111",
                        name: "Grass-Fed Beef Fajita Bowl",
                        description: "Cape Grim grass-fed and finished ground beef simmered in our house made red sauce with organic white jasmine rice, black beans, sautéed yellow onions, and red bell peppers. Topped with our house made avocado crema sauce. (P:42g F:25g C:45g)= 573 calories<h4>**contains eggs, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Beef-fajitaBowl-800.jpg?v=1765185922",
                        shopifyHandle: "bef111",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 },
                                vegan: { label: "Vegan (sub blackened tempeh)" }
                        }
                },
                {
                        id: "ckn111",
                        name: "Chicken Marsala",
                        description: "with garlic olive oil spaghetti squash, roasted broccoli and cauliflower medley, and our Rosie's organic chicken breast pan seared then glazed in our house made marsala sauce (P:43g F:22g C:32g)= 506 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/ChickenMarsala-800.jpg?v=1762153315",
                        shopifyHandle: "ckn111",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "fsh106",
                        name: "Herb-Crusted Wild-Caught Snapper",
                        description: "Wild-caught red snapper from Pure Fish, crusted in our fresh herb blend of thyme, parsley, rosemary, and basil, pan-seared and served with our house-made herb sauce. Plated alongside roasted purple sweet potatoes and herb-seasoned cauliflower for a clean, balanced, and flavorful meal. (P:37g F:12g C:43g) = 424 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Snapper.jpg?v=1772382512",
                        shopifyHandle: "fsh106",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk109",
                        name: "Grass-Fed Beef Breakfast Burrito",
                        description: "wrapped in a Coyota burrito wrap filled with sweet onions, red bell peppers, pastured San Diego eggs, grass-fed and finished beef, and topped with our house made dairy free chipotle crema sauce (P:40g F:25g C:40g)= 545 calories<h4>**contains eggs, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Beef-BreakfastBurrito-800.jpg?v=1762156633",
                        shopifyHandle: "brk109",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk105",
                        name: "Chipotle Breakfast Scramble",
                        description: "with Mary's chicken breast, pastured San Diego eggs, red bell peppers, sweet onions, gold potatoes on the side, and our house made honey chipotle sauce on the side (P:42g F:20g C:35g)= 488 calories<h4>**contains eggs, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/ChipotleScramble-800.jpg?v=1762777882",
                        shopifyHandle: "brk105",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "prb101",
                        name: "Birthday Cake Protein Balls",
                        description: "with Enjoy Life white chocolate chips, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:12g F:10g C:15g)= 200 calories per two balls<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/birthdayCake-ProteinBalls-800.jpg?v=1760241997",
                        shopifyHandle: "prb101",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                },
                {
                        id: "prb109",
                        name: "Pumpkin Protein Balls w/ white chocolate chips",
                        description: "with Enjoy Life white chocolate chips, pumpkin spice, sugar free pumpkin pure, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:12g F:10g C:15g)= 200 calories per two balls<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/pumpkin-whiteChocolateChip-800.jpg?v=1764574403",
                        shopifyHandle: "prb109",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                }
        	],
        	"sunday-2026-05-17": [
                {
                        id: "ckn101",
                        name: "Barbecue Chicken Meatballs",
                        description: "Roasted sweet potatoes and garlic-olive-oil zucchini served with Rosie's Organic chicken meatballs, all topped with our rich house-made barbecue sauce (P:43g F:22g C:43g)= 542 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/BBQ-ChickenMeatballs-800.jpg?v=1764574543",
                        shopifyHandle: "ckn101",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 },
                                vegan: { label: "Vegan (sub BBQ tofu)" }
                        }
                },
                {
                        id: "ckn125",
                        name: "Indian Butter Chicken",
                        description: "with white jasmine rice, sauté red bell peppers, sauté sweet onions, peas, roasted garlic olive oil carrots, Smart chicken breast, and cooked in our house made dairy free Indian butter sauce (P:42g F:20g C:50g)= 548 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Indian-chx-800.jpg?v=1766585693",
                        shopifyHandle: "ckn125",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 }
                        }
                },
                {
                        id: "bef122",
                        name: "Maple Dijon Grass-Fed Beef Bowl",
                        description: "with roasted sweet potatoes, garlic olive oil, broccoli, blistered cherry tomatoes, Cape Grim grass-fed/finished beef, and topped with our house made maple Dijon dressing (P:45g F:20g C:40g)= 520 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/maplebeefbowl-800.jpg?v=1759134531",
                        shopifyHandle: "bef122",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 }
                        }
                },
                {
                        id: "bef107",
                        name: "Grass-Fed Braised Brisket Bourguignon",
                        description: "with roasted gold potatoes, roasted carrots, onions, peas, and our organic grass-fed/finished New Zealand skirt steak slow cooked for 12 hours in house made Bourguignon sauce (P:38g F:22g C:45g)= 530 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/balsamicBeefShortRib-800.jpg?v=1764922559",
                        shopifyHandle: "bef107",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "trk105",
                        name: "Leah’s Turkey Burgers",
                        description: "with sweet potatoes, roasted zucchini, sauté onions, Diestel organic turkey burger, and topped with our house made creamy herb dressing (P:38g F:25g C:40g)= 537 calories<h4>**contains coconut, eggs**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Leahs-Turkey-Burger-800.jpg",
                        shopifyHandle: "trk105",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 },
                                vegan: { label: "Vegan (sub garbanzo beans)" }
                        }
                },
                {
                        id: "ckn124",
                        name: "Herb Crusted Chicken",
                        description: "Rosie's organic chicken breast served with a medley of roasted organic yams, asparagus, and roma tomatoes, seasoned with rosemary, dill, basil, oregano, garlic powder, and smoked paprika. Finished with a vibrant garlic herb sauce (P:43g F:14g C:42g)= 466 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Herb-crusted-chicken-800_54cb6e01-ca25-4bd6-af89-5c42394f1100.jpg?v=1759131545",
                        shopifyHandle: "ckn124",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 },
                                vegan: { label: "Vegan (sub herb tempeh)" }
                        }
                },
                {
                        id: "fsh101",
                        name: "Asian-Seared Wild-Caught Tuna",
                        description: "with golden quinoa, grilled asparagus, wild caught albacore tuna from Purefish, and topped with our house made sweet ponzu sauce (P:35g F:15g C:40g)= 435 calories<h4>**contains sesame, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/SesameTuna-600.jpg?v=1774493637",
                        shopifyHandle: "fsh101",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk130",
                        name: "Sweet Potato Chorizo Hash",
                        description: "with roasted sweet potatoes, sauté red bell peppers, sweet onions, mushrooms, Beelers non-gmo pork chorizo, 2 pastured San Diego poached eggs, and topped with our dairy free avocado crema sauce (P:32g F:32g C:40g)= 576 calories<h4>**contains eggs, pork, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Sweet-potato-chorizo-hash-800.jpg?v=1759135714",
                        shopifyHandle: "brk130",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk129",
                        name: "Sweet & Savory Breakfast Burrito",
                        description: "wrapped in a Coyotas burrito wrap stuffed with pastured San Diego eggs, red bell peppers, onions, house made maple chicken sausage, and our honey chipotle mayo sauce (P:34g F:30g C:45g)= 586 calories<h4>**contains eggs, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/savory-sweet-breakfast-burrito-800.jpg?v=1757080782",
                        shopifyHandle: "brk129",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "prb109",
                        name: "Pumpkin Protein Balls w/ white chocolate chips",
                        description: "with Enjoy Life white chocolate chips, pumpkin spice, sugar free pumpkin pure, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:12g F:10g C:15g)= 200 calories per two balls<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/pumpkin-whiteChocolateChip-800.jpg?v=1764574403",
                        shopifyHandle: "prb109",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                },
                {
                        id: "prb112",
                        name: "Strawberries & Cream Protein Balls",
                        description: "Bob’s Red Mill gluten-free oats, Medjool dates, coconut flakes, coconut oil, SunButter unsweetened sunflower seed butter, pure maple syrup, vanilla extract, kosher diamond salt, strawberries, Enjoy Life white chocolate chips (P:4g F:10g C:24g)= per two balls 200 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/StrawberriesAndCreamProteinBalls.jpg?v=1777406480",
                        shopifyHandle: "prb112",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                }
        	],
        	"wednesday-2026-05-20": [
                {
                        id: "trk111",
                        name: "Thai Turkey Bowl",
                        description: "with white jasmine rice, roasted yellow squash, sauté garlic zucchini, Diestel organic turkey, and topped with our house made pad Thai sauce (P:45g F:17g C:45g) = 513 calories<h4>**contains coconut, sesame, sunflower seeds**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/ThaiTurkey-800.jpg?v=1760826666",
                        shopifyHandle: "trk111",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 }
                        }
                },
                {
                        id: "ckn121",
                        name: "Hannah's Tahini Chicken Salad",
                        description: "with roasted sweet potatoes, sauté garlic olive oil kale, cherry tomatoes, dried cherries, fresh sprouts, Smart Chicken breast sliced, fresh avocado slices, and topped with our house made tahini dressing (P:42g F:22g C:42g)=534 calories<h4>**contains sesame**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Hannahs-salad-800.jpg",
                        shopifyHandle: "ckn121",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 }
                        }
                },
                {
                        id: "ckn129",
                        name: "Maple Chicken Burger",
                        description: "Roasted sweet potatoes, grilled asparagus, blistered cherry tomatoes, and an herbed Rosie's organic chicken burger topped with Niman Ranch pork bacon and a drizzle of balsamic glaze. (P:42g F:15g C:45g)= 483 calories<h4>**contains pork**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/MapleChickenBurger-800_55a27663-700d-4ef7-b981-182b6fd61b93.jpg?v=1767451992",
                        shopifyHandle: "ckn129",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "bef103",
                        name: "BBQ Grass-Fed Beef Meatloaf",
                        description: "stuffed with sweet onions, spinach, and grass-fed/finished beef. Served with carrot fries and topped with our house made BBQ sauce (P:35g F:25g C:50g)= 565 calories<h4>**contains eggs**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Beef-meatloaf-800.jpg?v=1756102378",
                        shopifyHandle: "bef103",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "bef118",
                        name: "Green Goddess Grass-Fed Beef Bowl",
                        description: "with Japanese yams, garlic olive oil asparagus, organic grass-fed New Zealand beef, blistered cherry tomatoes, and topped with our house made green goddess dressing (P:45g F:20g C:40g)= 520 calories<h4>**contains coconut, eggs**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/GreenGoddessBeefBowl-800.jpg?v=1757650741",
                        shopifyHandle: "bef118",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                extraSauceOnSide: { label: "Extra sauce on side", price: 2 },
                                vegan: { label: "Vegan (sub garbanzo beans)" }
                        }
                },
                {
                        id: "fsh103",
                        name: "Cajun Wild Isles Salmon",
                        description: "with jasmine brown rice and roasted cauliflower (P:35g F:20g C:42g)= 565 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/CajunSalmon-800.jpg",
                        shopifyHandle: "fsh103",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk106",
                        name: "Chocolate Chip Pancakes",
                        description: "with pork bacon, 2 pastured San Diego eggs, and fresh maple syrup on the side (P:30g F:15g C:55g)= 573 calories<h4>**contains pork, eggs, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/ChocolateChip-pancakes-800.jpg?v=1758348615",
                        shopifyHandle: "brk106"
                },
                {
                        id: "brk108",
                        name: "Garlic Tomato Breakfast Bowl",
                        description: "with baby red potatoes, sauté arugula, sauté sweet onions, house made Italian chicken sausage, 2 poached San Diego pastured eggs, and topped with our house made tomato basil marinara sauce (P:28g F:20g C:35g)= 432 calories<h4>**contains eggs**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/GarlicTomato-breakfastBowl-800.jpg?v=1761473306",
                        shopifyHandle: "brk108",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "prb109",
                        name: "Pumpkin Protein Balls w/ white chocolate chips",
                        description: "with Enjoy Life white chocolate chips, pumpkin spice, sugar free pumpkin pure, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:12g F:10g C:15g)= 200 calories per two balls<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/pumpkin-whiteChocolateChip-800.jpg?v=1764574403",
                        shopifyHandle: "prb109",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                },
                {
                        id: "prb112",
                        name: "Strawberries & Cream Protein Balls",
                        description: "Bob’s Red Mill gluten-free oats, Medjool dates, coconut flakes, coconut oil, SunButter unsweetened sunflower seed butter, pure maple syrup, vanilla extract, kosher diamond salt, strawberries, Enjoy Life white chocolate chips (P:4g F:10g C:24g)= per two balls 200 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/StrawberriesAndCreamProteinBalls.jpg?v=1777406480",
                        shopifyHandle: "prb112",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                }
        	],
			"sunday-2026-05-03": [
				{
					id: "meal-1",
					name: "Chorizo Meatballs",
					description:
						"with Spanish rice, sauté sweet onions, red bell peppers, sauté mushrooms, Chorizo pork meatballs, and topped with our house made avocado crema sauce (P:35g F:40g C:40g)= 660 calories<h4>**contains coconut, eggs, pork**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Chorizo-Meatballs.jpg?v=1772382437",
					shopifyHandle: "chorizo-meatballs",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						lowCarb: { label: "Low carb (extra veggies)", price: 2.0 },
						extraSauceOnSide: { label: "Extra sauce on side", price: 2.0 },
						vegan: { label: "Vegan (sub chorizo tempeh)"}
					}
				},
				{
					id: "meal-2",
					name: "Thai Basil Green Curry Turkey Bowl",
					description:
						"with white jasmine rice, sauté garlic olive oil garbanzo beans, carrots, sweet onions, peas, Diestel organic turkey, and topped with our house made Thai basil green curry sauce (P:42g F:20g C:45g)= 528 calories<h4>**contains coconut**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Thai-basil-green-curry-800.jpg?v=1757077367",
					shopifyHandle: "thai-curry-turkey-bowl",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						lowCarb: { label: "Low carb (extra veggies)", price: 2.0 },
						vegan: { label: "Vegan (sub garlic tofu)"}
					}
				},
				{
					id: "meal-3",
					name: "Harissa Honey Chicken",
					description:
						"Fire-roasted yams, sweet cherry tomatoes, red onions, and garlic olive oil asparagus served with Rosie's organic chicken thighs, marinated in our house-made harissa blend. Finished with a refreshing tzatziki on top (P:43g F:30g C:46g)= 626 calories<h4>**contains coconut **</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Harissa-honey-chx-800.jpg?v=1765961586",
					shopifyHandle: "harissa-chicken",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						lowCarb: { label: "Low carb (extra veggies)", price: 2.0 },
						extraSauceOnSide: { label: "Extra sauce on side", price: 2.0 },
						vegan: { label: "Vegan (sub garlic garbanzo beans)"}
					}
				},
				{
					id: "meal-4",
					name: "Chimichurri Grass-Fed Skirt Steak",
					description:
						"with gold baby potatoes, roasted broccolini, Roam grass-fed/finished regenerative farmed steak, and topped with our house made chimichurri sauce (P:42g F:20g C:45g)= 423 calories",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/ChimichurriSteak-800.jpg?v=1762783545",
					shopifyHandle: "chimichurri-steak",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						extraSauceOnSide: { label: "Extra sauce on side", price: 2.0 }
					}
				},
				{
					id: "meal-5",
					name: "Chicken Fried Rice",
					description:
						"with our house made fried rice, peas, carrots, sweet onions, Rosie's chicken breast, and cooked in our house made honey ginger sauce (P:45g F:15g C:45g)= 540 calories<h4>**contains coconut, eggs, sesame**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Lemongrass-chicken-thighs-800.jpg?v=1757651000",
					shopifyHandle: "chicken-fried-rice",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						vegan: { label: "Vegan (sub garlic tofu)"}
					}
				},
				{
					id: "meal-6",
					name: "BBQ Grass-Fed Bison Burger",
					description:
						"with roasted Japanese yam fries, sauté zucchini, sauté sweet onions, grass-fed/finished bison burger, and topped with our house made BBQ sauce (P:45g F:20g C:40g)= 520 calories",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/BBQ-bisonBurger.jpg?v=1758346710",
					shopifyHandle: "bison-burger",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						lowCarb: { label: "Low carb (extra veggies)", price: 2.0 }
					}
				},
				{
					id: "meal-7",
					name: "Thai Wild Isles Salmon",
					description:
						"with gluten free rice noodles, roasted broccoli, sauté red bell peppers, wild isles salmon from Purefish, and topped with our house made Thai sauce (P:34g F:23g C:50g)= 543 calories<h4>**contains coconut, sesame**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Thai-salmon-800.jpg?v=1759133957",
					shopifyHandle: "thai-salmon",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						lowCarb: { label: "Low carb (extra veggies)", price: 2.0 },
						extraSauceOnSide: { label: "Extra sauce on side", price: 2.0 },
						vegan: { label: "Vegan (sub garlic tofu)"}
					}
				},
				{
					id: "meal-8",
					name: "Breakfast Stuffed Sweet Potato",
					description:
						"with saute onions, pork bacon, and, pastured San Diego eggs. Topped with our house made avocado sauce, scallions, and everything but the bagel seasoning (P:32g F:25g C:35g)= 481 calories<h4>**contains eggs, pork, sesame**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/StuffedSweetPotato-800.jpg?v=1766025084",
					shopifyHandle: "breakfast-stuffed-sweet-potato",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 }
					}
				},
				{
					id: "meal-9",
					name: "Strawberry Protein Pancakes",
					description:
						"with turkey bacon, (2) over easy eggs, maple syrup on the side, and topped with coconut flakes (P:40g F:15g C:60g)= 535 calories<h4>**contains eggs, coconut**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/RaspberryPancakes-800.jpg?v=1759752099",
					shopifyHandle: "strawberry-pancakes",
				},
				{
					id: "meal-101",
					name: "Tiramisu Overnight Protein Oats ",
					description:
						"topped with So Delicious coconut whipped cream and fresh cacao nibs (P:30g F:15g C:50g)= 455 calories<h4>**contains coconut**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/TiramisuOvernightOats-800.jpg?v=1761472925",
					shopifyHandle: "tiramisu-overnight-oats",
				},
				{
					id: "meal-30",
					name: "Cherry Garcia Protein Balls",
					description:
						"with Enjoy Life dark chocolate chips, fresh blended cherries, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:12g F:10g C:15g)= 200 calories per two balls<h4>**contains coconut**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/CherryGarcia-ProteinBalls-800.jpg?v=1757657599",
					shopifyHandle: "protein-balls",
					options: {
						fifteenBalls: { label: "15 Balls", price: 25.0 },
						thirtyBalls: { label: "30 Balls", price: 45.0 }
					}
				}
			],
			"wednesday-2026-05-06": [
				{
					id: "meal-11",
					name: "Creamy Garlic Chicken",
					description:
						"Roasted spaghetti squash, zucchini, and yellow squash served with Rosie's Organic chicken breast, pan-seared and coated in our velvety house-made creamy garlic sauce. (P:43g F:20g C:30g)= 472 calories<h4>**contains coconut**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/CreamyGarlicChicken-700.jpg?v=1764553559",
					shopifyHandle: "creamy-garlic-chicken",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						lowCarb: { label: "Low carb (extra veggies)", price: 2.0 },
						vegan: { label: "Vegan (sub garlic tempeh)"}
					}
				},
				{
					id: "meal-12",
					name: "Lemongrass Chicken Thighs",
					description:
						"Lemon Grass Chicken Thighs with jasmine brown rice, roasted carrots, garlic broccoli, snap peas, Rosie's organic chicken thighs, and cooked in our house made lemon grass sauce (P:39g F:18g C:45g)= 498 calories<h4>**contains coconut, sesame**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Lemongrass-chicken-thighs-800.jpg?v=1757651000",
					shopifyHandle: "lemongrass-chicken",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						lowCarb: { label: "Low carb (extra veggies)", price: 2.0 },
						extraSauceOnSide: { label: "Extra sauce on side", price: 2.0 },
						vegan: { label: "Vegan (sub garlic tofu)"}
					}
				},
				{
					id: "meal-15",
					name: "Chicken Fajitas",
					description:
						"with jasmine white rice, chipotle black beans, sauté red bell peppers, sauté sweet onions, Rosie's organic chicken breast, and slow cooked in our house made red sauce. Topped with house made avocado chipotle aioli (P:45g F:20g C:33g)= 492 calories<h4>**contains eggs, coconut**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/ChickenFajitas-800.jpg?v=1760222900",
					shopifyHandle: "chicken-fajitas",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						lowCarb: { label: "Low carb (extra veggies)", price: 2.0 },
						extraSauceOnSide: { label: "Extra sauce on side", price: 2.0 },
						vegan: { label: "Vegan (sub crispy fajita tempeh)"}
					}
				},
				{
					id: "meal-13",
					name: "Spicy Grass-Fed Lamb Meatballs",
					description:
						"Roasted butternut squash, grilled asparagus, blistered cherry tomatoes, sautéed red onions, and Atkins Ranch grass-fed/finished lamb meatballs topped with our vibrant house-made green goddess dressing (P:46g F:32g C:45g)= 652 calories<h4>**contains eggs, coconut**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/SpicyLambMeatballs-800.jpg?v=1764581688",
					shopifyHandle: "lamb-meatballs",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
						vegan: { label: "Vegan (sub spicy garbanzo beans)"}
					}
				},
				{
					id: "meal-14",
					name: "Portuguese Grass-Fed Beef Short Rib",
					description:
						"with roasted yams, garlic spinach, sweet onions, sauté mushrooms, cherry tomatoes, and Cape Grim grass-fed/finished beef short rib slow cooked for 12-hours in our house made red wine cherry reduction (P:40g F:30g C:42g)= 598 calories",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Portuguese-shortRib-800.jpg?v=1756033398",
					shopifyHandle: "prtuguese-short-rib",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 }
					}
				},
				{
					id: "meal-16",
					name: "Maple Glazed Wild Isles Salmon",
					description:
						"with roasted butternut squash, saute green kale, mushrooms, blistered cherry tomatoes, Purefish wild isles salmon, and glazed in our house made maple Dijon glaze (P:35g F:22g C:30g)= 458 calories",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Maple-glazed-salmon-800.jpg?v=1757072689",
					shopifyHandle: "maple-salmon",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 }
					}
				},
				{
					id: "meal-17",
					name: "Pesto and Poached Eggs",
					description:
						"with crispy gold potatoes, garlic olive oil sauté spinach, sundried tomatoes, fresh olives, 3 pastured San Diego eggs, and topped with our house made pesto sauce (P:26g F:25g C:35g)= 469 calories<h4>**contains pumpkin seeds, eggs**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/PestoPoachedEggs-800.jpg?v=1764923456",
					shopifyHandle: "pesto-eggs",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
					}
				},
				{
					id: "meal-18",
					name: "Herbed Omelette",
					description:
						"A fluffy, herb-infused omelet made with fresh parsley, basil, and thyme, stuffed with Niman Ranch pork bacon, blistered cherry tomatoes, sautéed mushrooms, and garlic olive oil spinach. Served with a refreshing medley of fresh berries on the side for a perfectly balanced breakfast (P:30g F:22g C:25g)=434 calories<h4>**contains pork, eggs**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/HerbedOmelette-800.jpg?v=1760241720",
					shopifyHandle: "herbed-omelette",
					options: {
						extraProtein: { label: "Extra protein", price: 3.0 },
					}
				},
				{
					id: "meal-30",
					name: "Cherry Garcia Protein Balls",
					description:
						"with Enjoy Life dark chocolate chips, fresh blended cherries, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:12g F:10g C:15g)= 200 calories per two balls<h4>**contains coconut**</h4>",
					image:
						"https://cdn.shopify.com/s/files/1/0845/3564/0380/files/CherryGarcia-ProteinBalls-800.jpg?v=1757657599",
					shopifyHandle: "protein-balls",
					options: {
						fifteenBalls: { label: "15 Balls", price: 25.0 },
						thirtyBalls: { label: "30 Balls", price: 45.0 }
					}
				}
			],
			"sunday-2026-05-24": [
                {
                        id: "ckn145",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Kale White Bean Chicken Salad",
                        description: "Tender herb-crusted chicken thighs served over a vibrant kale salad with white beans, roasted sweet potatoes, avocado, and crunchy seeds, finished with a bright lemon dijon dressing (P: 42g F: 34g C: 38g)= 620 calories<h4>**contains hemp seeds, pumpkin seeds**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/KaleWhiteBeanSalad-800.jpg?v=1778407231",
                        shopifyHandle: "ckn145",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                noSauce: { label: "No sauce", price: 0 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 },
                                vegan: { label: "Vegan (sub herbed tempeh)" }
                        }
                },
                {
                        id: "ckn147",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>No Parm Chicken",
                        description: "Lightly coated chicken breast simmered in a rich, slow-cooked tomato sauce with garlic, basil, and oregano, served over tender spaghetti squash with roasted broccoli for a wholesome, comforting, and lighter take on a classic (P: 46g F: 18g C: 28g)= 460 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/CreamyGarlicChicken-700.jpg?v=1764553559",
                        shopifyHandle: "ckn147",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 }
                        }
                },
                {
                        id: "ckn102",
                        name: "Blackened Chicken Thighs",
                        description: "with cinnamon maple yams, roasted cauliflower, and grilled blackened Rosie's organic chicken thighs (P:41g F:15g C:46g) = 483 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/BlackenedChicken-800.jpg?v=1778407765",
                        shopifyHandle: "ckn102",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                vegan: { label: "Vegan (sub blackened garbanzo beans)" }
                        }
                },
                {
                        id: "trk109",
                        name: "Sweet Sesame Ginger Turkey Bowl",
                        description: "with golden quinoa, sauté sweet onions, sauté cabbage, red bell peppers, Diestel organic turkey, and topped with our house made sweet sesame ginger sauce (P:50g F:20g C:40g)= 540 calories<h4>**contains coconut, sesame**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Sesame-turkey-bowl-800.jpg?v=1766589137",
                        shopifyHandle: "trk109",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                noSauce: { label: "No sauce", price: 0 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 },
                                vegan: { label: "Vegan (sub tofu)" }
                        }
                },
                {
                        id: "prk104",
                        name: "Salsa Verde Pork Shoulder Bowl",
                        description: "with white jasmine rice, gem lettuce, sweet onions, sauté red bell peppers, asapragus, Beeler's non-gmo pork shoulder braised for 8 hours, and topped with our creamy house made salsa verde sauce (P:40g F:25g C:42g)= 553 calories<h4>**contains Pork**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/SalsaVerdePorkBowl-800.jpg?v=1769943259",
                        shopifyHandle: "prk104",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                noSauce: { label: "No sauce", price: 0 }
                        }
                },
                {
                        id: "bef132",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Grass-Fed Beef Short Rib & Butternut Squash Rissoto",
                        description: "Slow-braised grass-fed beef short rib served over a creamy butternut squash risotto infused with rosemary, sage, and white wine, paired with roasted brussel sprouts for a rich, comforting, and elevated dish (P: 46g F: 30g C: 44g)= 640 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/SteakAndButternut-800.jpg?v=1778408662",
                        shopifyHandle: "bef132",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 }
                        }
                },
                {
                        id: "fsh118",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Hot Honey Salmon",
                        description: "Sweet and spicy glazed steelhead salmon served over roasted sweet potatoes and a lemon vinaigrette–dressed kale salad, topped crunchy seeds for a bold, balanced bite. (P: 38g F: 26g C: 40g)= 560 calories<h4>**contains coconut, hemp seeds, pumpkin seeds**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/HotHoneySalmon-800.jpg?v=1778408841",
                        shopifyHandle: "fsh118",
                        options: {
                                noSauce: { label: "No sauce", price: 0 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 },
                                vegan: { label: "Vegan (sub hot honey tempeh)" }
                        }
                },
                {
                        id: "brk138",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>California Breakfast Burrito",
                        description: "Pastured eggs and crispy bacon with golden potatoes and fresh pico de gallo in a Coyotas gluten free burrito wrap for a bright, satisfying, and classic California-style breakfast. (P: 30g F: 28g C: 44g)= 520 calories<h4>**contains eggs, pork, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/CaliforniaBurrito-800.jpg?v=1778409782",
                        shopifyHandle: "brk138",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk137",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Protein Scramble",
                        description: "Fluffy pastured eggs scrambled with crispy bacon, served with roasted yams and fresh scallions, seasoned simply with garlic and spices for a hearty, balanced, and satisfying. (P: 28g F: 25g C: 40g)= 497 calories<h4>**contains eggs, pork**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/proteinScramble-800.jpg?v=1778409853",
                        shopifyHandle: "brk137",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk136",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Strawberries & Cream Overnight Oats",
                        description: "Creamy overnight oats soaked in coconut milk with chia and flax seeds, layered with fresh strawberries and lightly sweetened with maple syrup, finished with a rich coconut yogurt for a smooth, naturally sweet, and satisfying start to your day (P: 14g F: 18g C: 48g)= 420 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/strawberriesAndCream-800.jpg?v=1778409694",
                        shopifyHandle: "brk136"
                },
                {
                        id: "prb107",
                        name: "Primal Protein Balls",
                        description: "with Enjoy Life dark chocolate chips, cinnamon, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:30g F:30g C:70g)= 670 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/PrimalProteinBalls.jpg?v=1756101853",
                        shopifyHandle: "prb107",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                }
        ],
        "wednesday-2026-05-27": [
                {
                        id: "bef131",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Fennel Crusted Grass-Fed Steak",
                        description: "Grilled grass-fed steak crusted with fennel and rosemary, served alongside roasted purple potatoes, asparagus, and blistered cherry tomatoes. Finished with a rich, herb-forward béarnaise-style sauce for a bold and satisfying dish (P: 48g F: 32g C: 32g)= 620 calories<h4>**contains eggs, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/fennelSteak-800.jpg?v=1778410671",
                        shopifyHandle: "bef131",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                noSauce: { label: "No sauce", price: 0 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 },
                                vegan: { label: "Vegan (sub fennel-crusted tempeh)" }
                        }
                },
                {
                        id: "ckn146",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Lentil Curry Chicken Dal",
                        description: "Slow-simmered lentils infused with aromatic curry spices, coconut milk, and ginger, paired with tender chicken breast and served over fluffy jasmine rice for a rich, satisfying, and comforting meal (P: 45g F: 18g C: 58g)= 620 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/lentilChicken-800.jpg?v=1778410737",
                        shopifyHandle: "ckn146",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                noSauce: { label: "No sauce", price: 0 },
                                vegan: { label: "Vegan (sub tofu)" }
                        }
                },
                {
                        id: "ckn148",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Lemon Not So Butter Chicken",
                        description: "Lightly coated Rosie’s chicken breast simmered in a bright lemon garlic sauce with white wine and a touch of natural sweetness, served with roasted butternut squash, asparagus, and cherry tomatoes for a fresh, vibrant, and comforting dish (P: 45g F: 16g C: 34g)= 480 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/LemonNotSoButterChicken-800.jpg?v=1778410599",
                        shopifyHandle: "ckn148",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 }
                        }
                },
                {
                        id: "lmb106",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Mediterranean Grass-Fed Lamb Bowl",
                        description: "Rosemary and thyme seasoned grass-fed ground lamb served over hearty brown rice with crisp cucumbers, pickled red onions, cherry tomatoes, and zucchini, finished with a creamy hummus tahini dressing for a fresh, savory, and satisfying Mediterranean-inspired bowl (P: 42g F: 32g C: 48g)= 640 calories<h4>**contains sesame, coconut, eggs**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/medLambBowl-800.jpg?v=1778410496",
                        shopifyHandle: "lmb106",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                noSauce: { label: "No sauce", price: 0 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 },
                                vegan: { label: "Vegan (sub mediterranean garbanzo beans)" }
                        }
                },
                {
                        id: "ckn135",
                        name: "Pesto Chicken Thighs",
                        description: "with roasted butternut squash, sauté kale, sauté mushrooms, blistered cherry tomatoes, Rosie's chicken thighs, and topped with our house made pesto sauce (P:41g F:25g C:35g)= 529 calories<h4>**contains Pumpkin seeds**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Pesto-chicken-thighs-800.jpg?v=1756102965",
                        shopifyHandle: "ckn135",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 },
                                vegan: { label: "Vegan (sub tofu)" }
                        }
                },
                {
                        id: "fsh116",
                        name: "Wild Isles Salmon Piccata",
                        description: "with creamy garlic olive oil risotto, garlic broccoli, blistered cherry tomatoes, wild isles salmon from Purefish, and topped with our house made lemon white wine piccata sauce (P:37g F:20g C:40g)= 488 calories",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/Salmon-Piccata-800.jpg?v=1756356349",
                        shopifyHandle: "fsh116",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 },
                                lowCarb: { label: "Low carb (extra veggies)", price: 2 },
                                noSauce: { label: "No sauce", price: 0 },
                                extraSauce: { label: "Extra sauce (on top)", price: 2 }
                        }
                },
                {
                        id: "brk139",
                        name: "<span style=\"display:inline-block;background:#3D081B;color:#ffffff;font-size:10px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;padding:2px 9px;border-radius:20px;margin-right:6px;vertical-align:middle;\">New</span>Breakfast Hash",
                        description: "Crispy shredded potatoes sautéed with peppers, onions, and mushrooms, topped with 3 over medium pastured eggs and bacon, and topped with a creamy avocado crema for a hearty, savory, and satisfying breakfast (P: 32g F: 30g C: 34g)= 540 calories<h4>**contains eggs, pork, coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/BreakfastHash-800.jpg?v=1778410424",
                        shopifyHandle: "brk139",
                        options: {
                                extraProtein: { label: "Extra protein", price: 3 }
                        }
                },
                {
                        id: "brk123",
                        name: "Pumpkin Spice Overnight Oats",
                        description: "with chia seeds, fresh coconut milk, Organifi complete vanilla vegan protein powder, cinnamon, no sugar pumpkin pure, local raw San Diego honey, sunflower seed butter, banana slices, and topped with coconut flakes (P:37g F:26g C:30g)=502 calories<h4>**contains coconut, pumpkin seeds**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/PumpkinOvernightOats-800.jpg?v=1757076923",
                        shopifyHandle: "brk123"
                },
                {
                        id: "prb107",
                        name: "Primal Protein Balls",
                        description: "with Enjoy Life dark chocolate chips, cinnamon, Organifi complete vanilla vegan protein powder, maple syrup, sunflower butter, coconut flakes, gluten free oats, coconut oil, and love! (P:30g F:30g C:70g)= 670 calories<h4>**contains coconut**</h4>",
                        image: "https://cdn.shopify.com/s/files/1/0845/3564/0380/files/PrimalProteinBalls.jpg?v=1756101853",
                        shopifyHandle: "prb107",
                        options: {
                                fifteenBalls: { label: "15 Balls", price: 25 },
                                thirtyBalls: { label: "30 Balls", price: 45 }
                        }
                }
        	]
		};
	}
	scrollToMealSection() {
		const mealSection = document.querySelector("[data-meal-section]");
		if (mealSection) {
			// Small delay to ensure content is rendered
			setTimeout(() => {
				mealSection.scrollIntoView({
					behavior: "smooth",
					block: "start"
				});
			}, 100);
		}
	}
	getMealPlanFromCustomer() {
		const customerTags = this.customer.tags || [];
		console.log("Customer tags found:", customerTags);

		// Check for special tag first
		const hasSpecialTag = customerTags.some(
			(tag) => tag.toLowerCase() === "special"
		);

		// Check for VIP
		if (customerTags.some((tag) => tag.toLowerCase() === "vip")) {
			console.log("✅ VIP customer detected");
			return {
				mealsPerWeek: 999,
				planName: "VIP",
				allowsOverage: true,
				requiresMinimum: false,
				isActive: true,
				isVIP: true,
				hasSpecialTag: hasSpecialTag
			};
		}

		// PRIORITY 1: Check for custom "meal plan" tags first
		const mealPlanTag = customerTags.find(
			(tag) => tag.toLowerCase().includes("meal plan") && /\d+/.test(tag) // Contains a number
		);

		if (mealPlanTag) {
			console.log("✅ Custom meal plan tag found:", mealPlanTag);

			// Extract the number from the meal plan tag
			const match = mealPlanTag.match(/(\d+)/);
			if (match) {
				const mealCount = parseInt(match[1]);
				console.log("✅ Using custom meal plan:", mealCount, "meals");

				return {
					mealsPerWeek: mealCount,
					planName: `${mealCount} Meal Plan`,
					allowsOverage: true,
					requiresMinimum: !hasSpecialTag,
					isActive: true,
					isCustomPlan: true, // Flag to indicate this came from custom tag
					hasSpecialTag: hasSpecialTag,
					sourceTag: mealPlanTag // Store the original tag for debugging
				};
			}
		}

		// FALLBACK: Use original "meals per week" logic if no custom meal plan tag
		console.log(
			"No custom meal plan tag found, checking legacy 'meals per week' tags"
		);

		let totalMeals = 0;
		let planComponents = [];

		customerTags.forEach((tag) => {
			const lowerTag = tag.toLowerCase();
			if (lowerTag.includes("meals per week")) {
				const match = lowerTag.match(/(\d+)\s+meals?\s+per\s+week/);
				if (match) {
					const mealCount = parseInt(match[1]);
					totalMeals += mealCount;
					planComponents.push(`${mealCount}`);
				}
			}
		});

		if (totalMeals > 0) {
			console.log("✅ Using legacy meals per week tags, total:", totalMeals);

			const plan = {
				mealsPerWeek: totalMeals,
				planName: `${totalMeals} Meals Per Week`,
				planComponents: planComponents,
				allowsOverage: true,
				requiresMinimum: !hasSpecialTag,
				isActive: true,
				isCombined: planComponents.length > 1,
				isLegacyPlan: true, // Flag to indicate this came from old tags
				hasSpecialTag: hasSpecialTag
			};

			return plan;
		}

		console.log("❌ No meal plan found");
		return null;
	}
	hasWednesdayOnlyTag() {
		const customerTags = this.customer.tags || [];
		return customerTags.some((tag) => tag.toLowerCase() === "wednesday");
	}

	hasVIPTag() {
		return this.mealPlan && this.mealPlan.isVIP;
	}
	isRestrictedPlan() {
		return this.mealPlan && this.mealPlan.mealsPerWeek <= 8;
	}

	// Add method to check if Thursday can be saved
	canSaveWednesday(baseDate) {
		// If no meal plan, VIP, large plan (10+), or special tag - no restrictions
		if (
			!this.mealPlan ||
			this.mealPlan.mealsPerWeek >= 10 ||
			this.mealPlan.isVIP ||
			this.mealPlan.hasSpecialTag
		) {
			return { allowed: true, reason: "" };
		}

		// Rest of the existing logic for regular customers with 8 or fewer meals...
		if (this.mealPlan.mealsPerWeek <= 8) {
			// Use calculateWeeklyTotal to get the correct Monday count
			const weeklyTotal = this.calculateWeeklyTotal(baseDate);
			const sundayMealCount = weeklyTotal.sunday;

			if (sundayMealCount < this.mealPlan.mealsPerWeek) {
				const needed = this.mealPlan.mealsPerWeek - sundayMealCount;
				return {
					allowed: false,
					reason: `You must select ${this.mealPlan.mealsPerWeek} meals from Sunday before adding Wednesday meals.`,
					detailedReason: `Your ${
						this.mealPlan.planName
					} requires selecting your core meals from Sunday first.\n\nCurrent Sunday selection: ${sundayMealCount} meals\nNeeded: ${needed} more meal${
						needed > 1 ? "s" : ""
					} from Sunday\n\nWednesday meals are available as add-ons after meeting your Sunday requirement.`,
					sundayMealsNeeded: needed,
					sundayMealsSaved: sundayMealCount
				};
			}
		}

		return { allowed: true, reason: "" };
	}

	async init() {
		/*
		if (window.maintenanceMode) {
			this.enableMaintenanceMode();
			return;
		}*/
		this.performStartupCleanup();
		
		// ✅ NEW: Load from Railway first (if not guest)
		if (!this.customer.isGuest) {
			console.log('📥 Loading selections from Railway...');
			const railwayResult = await this.loadFromRailway();
			
			if (railwayResult.success && Object.keys(railwayResult.selections || {}).length > 0) {
				console.log('✅ Loaded from Railway successfully');
			} else {
				console.log('⚠️ Railway load failed or empty, falling back to existing methods');
				this.loadExistingSelections(); // Your existing localStorage/Sheets load
			}
		} else {
			// Guest users still use existing method
			this.loadExistingSelections();
		}
		
		this.renderWeeks();
		this.bindEvents();

		// Add page visibility change handler
		document.addEventListener("visibilitychange", () => {
			this.handlePageVisibilityChange();
		});

		console.log(
			"Weekly Meal Selector initialized for customer:",
			this.customer.name
		);

		if (this.isNonSubscriber) {
			setTimeout(() => {
				this.autoSelectSundayMenu();
			}, 100);
		}
		this.customerPortal = new CustomerPortal(this);
	}
	enableMaintenanceMode() {
		// Hide the portal stats and history sections
		const portalStats = document.getElementById('portal-stats');
		if (portalStats) portalStats.style.display = 'none';
		
		const portalHistory = document.getElementById('customer-meal-history-portal');
		if (portalHistory) portalHistory.style.display = 'none';

		const portalActions = document.querySelector('.portal-actions');
		if (portalActions) portalActions.style.display = 'none';

		// Hide the week selection and meal section
		const weekSelection = document.querySelector('.week-selection');
		if (weekSelection) weekSelection.style.display = 'none';

		const mealSection = document.querySelector('[data-meal-section]');
		if (mealSection) mealSection.style.display = 'none';

		// Show maintenance banner in place of everything
		const welcomeCard = document.querySelector('.customer-welcome');
		if (welcomeCard) {
			const banner = document.createElement('div');
			banner.style.cssText = `
				background: #fff3cd;
				border: 2px solid #ffc107;
				border-radius: 12px;
				padding: 40px;
				text-align: center;
				margin: 40px auto;
				max-width: 700px;
			`;
			banner.innerHTML = `
				<div style="font-size: 48px; margin-bottom: 20px;">🔧</div>
				<h2 style="color: #856404; margin-bottom: 15px;">
					Meal Selection Temporarily Unavailable
				</h2>
				<p style="color: #856404; font-size: 16px; line-height: 1.6; margin-bottom: 15px;">
					We're making some exciting updates! 
					You'll be able to select your meals starting 
					<strong>Friday April 17th at 8:00 AM</strong>.
				</p>
				<p style="color: #856404; font-size: 14px; line-height: 1.6; margin-bottom: 20px;">
					In the meantime, feel free to browse our menu below to plan your selections ahead of time.
				</p>
				<p style="color: #856404; font-size: 14px;">
					Questions? <a href="/pages/contact" style="color: #856404; font-weight: bold;">
					Contact us
					</a> and we'll be happy to help.
				</p>
			`;
			welcomeCard.insertAdjacentElement('afterend', banner);
		}

		// Still render the menu so they can browse
		// Use non-subscriber mode which shows meals without any selection controls
		this.isNonSubscriber = true;
		this.weeklyMenus = this.initializeMenus();
		this.renderWeeks();
		
		// Auto-select the first available week so menu is immediately visible
		const weeks = this.getAvailableWeeks().filter(w => !w.isDeadlinePassed);
		if (weeks.length > 0) {
			this.selectWeek(weeks[0]);
		}
	}
	forceMobileCleanup() {
		const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent
		);
		const isSmallScreen = window.innerWidth <= 768;

		if (isMobile || isSmallScreen) {
			console.log("Mobile device detected - forcing data cleanup");

			// Clear ALL working selections on mobile
			this.mealQuantities = {};
			this.mealOptions = {};
			this.proteinBallSelections = {};

			// Add mobile-specific cleanup
			this.clearMobileCache();

			// Show mobile warning if data seems stale
			this.checkMobileDataFreshness();
		}
	}

	clearStaleData() {
		try {
			const storageKey = `meal_selections_${this.customer.id}`;
			const data = JSON.parse(localStorage.getItem(storageKey) || "{}");

			// Check if data has version info
			const storedVersion = data.dataVersion || data.version;
			const currentVersion = this.dataVersion;

			console.log(
				`Data version check: stored="${storedVersion}", current="${currentVersion}"`
			);

			if (!storedVersion || storedVersion !== currentVersion) {
				console.log(
					"🧹 CLEARING STALE DATA - Version mismatch or no version found"
				);

				// Keep only the essentials, clear everything else
				const cleanData = {
					dataVersion: currentVersion,
					lastUpdated: new Date().toISOString(),
					customerInfo: data.customerInfo || {
						id: this.customer.id,
						name: this.customer.name,
						email: this.customer.email
					},
					cleanupReason: storedVersion
						? `Version upgrade: ${storedVersion} -> ${currentVersion}`
						: "No version found"
				};

				localStorage.setItem(storageKey, JSON.stringify(cleanData));
				this.weeklySelections = {};
			}
		} catch (error) {
			console.error("Error checking data version:", error);
			// If localStorage is corrupted, clear it
			this.clearCorruptedStorage();
		}
	}

	detectStaleWeeks() {
		const now = new Date();
		const availableWeekIds = this.getAvailableWeeks().map((w) => w.id);
		const storedWeekIds = Object.keys(this.weeklySelections || {});

		let hasStaleWeeks = false;
		const staleWeeks = [];

		storedWeekIds.forEach((weekId) => {
			if (
				weekId === "lastUpdated" ||
				weekId === "customerInfo" ||
				weekId === "dataVersion"
			)
				return;

			// If stored week is not in current available weeks, it's stale
			if (!availableWeekIds.includes(weekId)) {
				console.log(`Stale week detected: ${weekId}`);
				staleWeeks.push(weekId);
				hasStaleWeeks = true;
			}
		});

		if (hasStaleWeeks) {
			console.log(`Found ${staleWeeks.length} stale weeks:`, staleWeeks);
			this.handleStaleWeeks(staleWeeks);
		}

		return { hasStaleWeeks, staleWeeks };
	}

	clearMobileCache() {
		try {
			// Clear session storage too (mobile browsers sometimes sync these)
			sessionStorage.clear();

			// Clear any temporary data
			const tempKeys = [];
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (
					key &&
					(key.includes("temp_") ||
						key.includes("cache_") ||
						key.includes("old_meal_"))
				) {
					tempKeys.push(key);
				}
			}

			tempKeys.forEach((key) => localStorage.removeItem(key));
			console.log(`Cleared ${tempKeys.length} temporary cache items`);
		} catch (error) {
			console.error("Error clearing mobile cache:", error);
		}
	}

	checkMobileDataFreshness() {
		try {
			const storageKey = `meal_selections_${this.customer.id}`;
			const data = JSON.parse(localStorage.getItem(storageKey) || "{}");
			const lastUpdated = data.lastUpdated;

			if (lastUpdated) {
				const daysSinceUpdate =
					(new Date() - new Date(lastUpdated)) / (1000 * 60 * 60 * 24);

				if (daysSinceUpdate > 7) {
					console.log(`Mobile data is ${daysSinceUpdate.toFixed(1)} days old`);
				}
			}
		} catch (error) {
			console.error("Error checking data freshness:", error);
		}
	}

	handleStaleWeeks(staleWeeks) {
		const storageKey = `meal_selections_${this.customer.id}`;
		const data = JSON.parse(localStorage.getItem(storageKey) || "{}");

		// Archive stale weeks instead of deleting (for reference)
		const archivedWeeks = data.archivedWeeks || {};

		staleWeeks.forEach((weekId) => {
			if (data[weekId]) {
				archivedWeeks[weekId] = {
					...data[weekId],
					archivedAt: new Date().toISOString(),
					reason: "Week no longer available"
				};
				delete data[weekId];

				// Also remove from memory
				if (this.weeklySelections[weekId]) {
					delete this.weeklySelections[weekId];
				}
			}
		});

		data.archivedWeeks = archivedWeeks;
		data.lastCleanup = new Date().toISOString();
		data.dataVersion = this.dataVersion;

		localStorage.setItem(storageKey, JSON.stringify(data));

		console.log(`Archived ${staleWeeks.length} stale weeks`);
	}

	clearCorruptedStorage() {
		try {
			const storageKey = `meal_selections_${this.customer.id}`;
			localStorage.removeItem(storageKey);

			// Create fresh storage
			const freshData = {
				dataVersion: this.dataVersion,
				lastUpdated: new Date().toISOString(),
				customerInfo: {
					id: this.customer.id,
					name: this.customer.name,
					email: this.customer.email
				},
				cleanupReason: "Corrupted data cleared"
			};

			localStorage.setItem(storageKey, JSON.stringify(freshData));

			console.log("Cleared corrupted storage and created fresh data");
		} catch (error) {
			console.error("Could not clear corrupted storage:", error);
			alert(
				"Storage error detected. Please clear your browser data and try again."
			);
		}
	}

	// 9. AUTOMATIC CLEANUP ON LOAD
	performStartupCleanup() {
		console.log("Performing startup cleanup...");

		// Clear any working selections that might be stale
		this.mealQuantities = {};
		this.mealOptions = {};
		this.proteinBallSelections = {};

		// Detect stale weeks
		this.detectStaleWeeks();

		// Ensure UI starts clean
		setTimeout(() => {
			this.enforceCleanUIState();
		}, 100);

		console.log("Startup cleanup completed");
	}

	// 10. VERSION UPDATER (call this when you update menus)
	updateDataVersion(newVersion, reason = "Menu updated") {
		this.dataVersion = newVersion;

		const storageKey = `meal_selections_${this.customer.id}`;
		try {
			const data = JSON.parse(localStorage.getItem(storageKey) || "{}");

			// Mark old version for cleanup
			if (data.dataVersion && data.dataVersion !== newVersion) {
				data.previousVersion = data.dataVersion;
				data.upgradeReason = reason;
				data.upgradedAt = new Date().toISOString();
			}

			data.dataVersion = newVersion;
			data.lastUpdated = new Date().toISOString();

			localStorage.setItem(storageKey, JSON.stringify(data));
			console.log(`Data version updated to ${newVersion}: ${reason}`);
		} catch (error) {
			console.error("Error updating data version:", error);
		}
	}

	checkIfNonSubscriber() {
		// Check multiple conditions for non-subscriber status:

		// 1. Guest users
		if (this.customer.isGuest) {
			console.log("Non-subscriber detected: Guest user");
			return true;
		}

		// 2. No customer object (not logged in)
		if (!this.customer || !this.customer.id) {
			console.log("Non-subscriber detected: No customer data");
			return true;
		}

		// 3. Check for subscription tags
		const subscriptionTags = ["meals per week", "vip", "VIP"];

		const hasSubscriptionTag =
			this.customer.tags &&
			this.customer.tags.some((tag) =>
				subscriptionTags.some((subTag) =>
					tag.toLowerCase().includes(subTag.toLowerCase())
				)
			);

		if (!hasSubscriptionTag) {
			console.log("Non-subscriber detected: No subscription tags found");
			return true;
		}

		// 4. Check if meal plan exists
		if (!this.mealPlan || !this.mealPlan.planName) {
			console.log("Non-subscriber detected: No meal plan found");
			return true;
		}

		return false;
	}

	bindEvents() {
		// Save button (replacement mode)
		const saveBtn = document.querySelector("[data-save-order]");
		if (saveBtn) {
			saveBtn.addEventListener("click", () => this.saveWeeklyOrder(false));
		}
		
		// Add to existing button (addition mode) 
		const addBtn = document.querySelector("[data-add-to-meals]");
		if (addBtn) {
			addBtn.addEventListener("click", () => this.saveWeeklyOrder(true));
		}
		
		// Clear selections button
		const clearBtn = document.querySelector('[data-clear-selections]');
		if (clearBtn) {
			clearBtn.addEventListener('click', () => this.clearAllSelections());
		}
	}

	enableNonSubscriberMode() {
		console.log("Enabling non-subscriber mode...");

		// Add class to body for CSS targeting
		document.body.classList.add("non-subscriber-mode");

		// Update the welcome message
		this.updateWelcomeForNonSubscriber();

		// Disable interactive elements
		this.disableInteractiveElements();

		// Automatically select and show Monday menu
		this.autoSelectSundayMenu();

		// Add subscribe CTA after meals are loaded
		setTimeout(() => {
			this.addSubscribeCTA();
			this.addViewOnlyBanner();
			this.hideDeadlineNotice();
		}, 500);
	}

	autoSelectSundayMenu() {
		console.log("Auto-selecting Sunday menu for non-subscriber...");

		const deliveries = this.getAvailableWeeks();

		// Find the earliest available Sunday and Wednesday
		const sundayDeliveries = deliveries.filter(
			(d) => d.id.includes("sunday") && !d.isDeadlinePassed
		);
		const wednesdayDeliveries = deliveries.filter(
			(d) => d.id.includes("wednesday") && !d.isDeadlinePassed
		);

		const earliestSunday = sundayDeliveries.sort(
			(a, b) => a.deliveryDate - b.deliveryDate
		)[0];
		const earliestWednesday = wednesdayDeliveries.sort(
			(a, b) => a.deliveryDate - b.deliveryDate
		)[0];

		console.log("Earliest Sunday delivery:", earliestSunday?.id);
		console.log("Earliest Wednesday delivery:", earliestWednesday?.id);

		if (earliestSunday) {
			this.selectWeek(earliestSunday);

			// For non-subscribers, also append Wednesday menu
			if (earliestWednesday && this.isNonSubscriber) {
				setTimeout(() => {
					this.appendWednesdayMenu(earliestWednesday);
				}, 100);
			}
		}

		const mealSection = document.querySelector("[data-meal-section]");
		if (mealSection) {
			mealSection.style.display = "block";
		}
	}
	appendWednesdayMenu(wednesdayDelivery) {
		const mealsGrid = document.querySelector("[data-meals-grid]");
		if (!mealsGrid) return;

		const wednesdayMeals = this.weeklyMenus[wednesdayDelivery.id] || [];

		// Add Wednesday title
		const wednesdayTitle = document.createElement("h2");
		wednesdayTitle.className = "wednesday-menu-title";
		wednesdayTitle.style.cssText = `
			grid-column: 1 / -1;
			text-align: center;
			margin: 3rem 0 2rem 0;
			font-size: 2rem;
			color: #3D081B;
			padding-top: 2rem;
			border-top: 2px solid #e1e3e5;
		`;
		wednesdayTitle.textContent = `${wednesdayDelivery.display} Menu`;

		mealsGrid.appendChild(wednesdayTitle);

		// Add Wednesday meals
		wednesdayMeals.forEach((meal) => {
			const mealElement = document.createElement("div");
			mealElement.innerHTML = this.renderMealCard(meal, wednesdayDelivery.id);
			mealsGrid.appendChild(mealElement.firstElementChild);
		});
	}
	hideDeadlineNotice() {
		// Hide the deadline notice for non-subscribers
		const deadlineNotice = document.querySelector(
			".deadline-notice, [data-deadline-notice]"
		);
		if (deadlineNotice) {
			deadlineNotice.style.display = "none";
		}
	}

	updateWelcomeForNonSubscriber() {
		const welcomeEl = document.querySelector(".customer-welcome h2");
		const statusEl = document.querySelector(".subscription-status");

		if (welcomeEl) {
			if (this.customer.isGuest) {
				welcomeEl.textContent = "Welcome! Browse Our Weekly Menu";
			} else {
				welcomeEl.textContent = `Welcome, ${this.customer.firstName}! Subscribe to Start Ordering`;
			}
		}

		if (statusEl) {
			statusEl.innerHTML = `
				<span class="badge" style="background: #ffc107; color: #333;">● Browsing Mode</span>
				<span class="caption-with-letter-spacing">No Active Subscription</span>
			`;
		}
	}

	disableInteractiveElements() {
		// Disable meal quantity controls
		const quantityControls = document.querySelectorAll(".quantity-controls");
		quantityControls.forEach((control) => {
			control.style.display = "none";
		});

		// Hide meal options
		const mealOptions = document.querySelectorAll(
			".meal-options, .addon-options-wrapper"
		);
		mealOptions.forEach((option) => {
			option.style.display = "none";
		});

		// Hide order summary
		const orderSummary = document.querySelector(".order-summary");
		if (orderSummary) {
			orderSummary.style.display = "none";
		}

		// Hide save button
		const saveBtn = document.querySelector("[data-save-order]");
		if (saveBtn) {
			saveBtn.style.display = "none";
		}

		// Make week cards less interactive
		const weekCards = document.querySelectorAll(".week-card");
		weekCards.forEach((card) => {
			card.style.cursor = "default";
		});
	}

	addViewOnlyBanner() {
		const mealSelection = document.querySelector(".meal-selection__header");
		if (mealSelection && !document.querySelector(".view-only-banner")) {
			const banner = document.createElement("div");
			banner.className = "view-only-banner";
			banner.innerHTML = `
				<p class="view-only-banner-text">
					👀 You're viewing our menu in browse mode. 
					<a href="https://www.primalbalancenutrition.com/pages/subscribe" class="view-only-banner-link">
						Subscribe now
					</a> 
					to customize your meals and place orders.
				</p>
			`;
			mealSelection.appendChild(banner);
		}
	}

	addSubscribeCTA() {
		const mealsContainer = document.querySelector(".meals-container");
		if (mealsContainer && !document.querySelector(".subscribe-cta-section")) {
			const ctaSection = document.createElement("div");
			ctaSection.className = "subscribe-cta-section";
			ctaSection.innerHTML = `
				<h2 class="subscribe-cta-title">Ready to eat healthy and feel good?</h2>

				<p class="subscribe-cta-subtitle">
					Fresh (never frozen) free-range, grass-fed, organic meals
				</p>

				<ul class="subscribe-cta-benefits" role="list">
					<li class="subscribe-benefit">Seed Oil Free</li>
					<li class="subscribe-benefit">Gluten Free</li>
					<li class="subscribe-benefit">Dairy Free</li>
					<li class="subscribe-benefit">Soy Free</li>
					<li class="subscribe-benefit">Nut Free</li>
					<li class="subscribe-benefit">Shellfish Free</li>
					<li class="subscribe-benefit">Plastic-Free</li>
				</ul>

				<p class="subscribe-cta-note">
					No compromises, just real food
				</p>

				<a href="https://www.primalbalancenutrition.com/pages/subscribe" class="subscribe-cta-button">
					View Meal Plans
				</a>
			`;

			// Insert after the meals container
			mealsContainer.parentNode.insertBefore(
				ctaSection,
				mealsContainer.nextSibling
			);
		}
	}

	getAvailableWeeks() {
		const deliveries = [];
		const now = new Date();

		this.weekConfig.availableWeeks.forEach((week) => {
		
			const deadlineString = week.deadline;
			let deadline;

			if (deadlineString.includes("T") && 
				!deadlineString.includes("Z") &&
				!deadlineString.includes("+") && 
				!deadlineString.includes("-")) {

				const tempDate = new Date(deadlineString);
				const pacificOffset = this.getPacificTimeOffset(tempDate);
				deadline = new Date(tempDate.getTime() - pacificOffset);
			} else {
				deadline = new Date(deadlineString);
			}

			const isDeadlinePassed = now > deadline;
			const millisecondsLeft = Math.max(0, deadline - now);
			const hoursLeft = Math.max(0, Math.ceil(millisecondsLeft / (1000 * 60 * 60)));
			const isUrgent = hoursLeft <= 48 && !isDeadlinePassed;

			let deadlineText;
			if (isDeadlinePassed) {
				deadlineText = `Deadline was ${week.deadlineDisplay}`;
			} else if (hoursLeft <= 24) {
				deadlineText = `Only ${hoursLeft} hours left to customize!`;
			} else {
				const daysLeft = Math.floor(hoursLeft / 24);
				const remainingHours = hoursLeft % 24;
				if (daysLeft > 0) {
					deadlineText = `${daysLeft}d ${remainingHours}h left - Deadline: ${week.deadlineDisplay}`;
				} else {
					deadlineText = `${hoursLeft}h left - Deadline: ${week.deadlineDisplay}`;
				}
			}

			// Sunday delivery
			deliveries.push({
				id: `sunday-${week.sundayDate}`,
				deliveryDate: new Date(week.sundayDate),
				display: week.sundayDisplay,
				dayName: "Sunday",
				deadline: deadline,
				deadlineText: deadlineText,
				deadlineDisplay: week.deadlineDisplay, 
				isDeadlinePassed: isDeadlinePassed,
				hoursLeft: hoursLeft,
				isUrgent: isUrgent,
				hasSelection: this.hasExistingSelection(`sunday-${week.sundayDate}`),
				weekGroup: week.id
			});

			// Wednesday delivery
			deliveries.push({
				id: `wednesday-${week.wednesdayDate}`,
				deliveryDate: new Date(week.wednesdayDate),
				display: week.wednesdayDisplay,
				dayName: "Wednesday",
				deadline: deadline,
				deadlineText: deadlineText,
				deadlineDisplay: week.deadlineDisplay, 
				isDeadlinePassed: isDeadlinePassed,
				hoursLeft: hoursLeft,
				isUrgent: isUrgent,
				hasSelection: this.hasExistingSelection(`wednesday-${week.wednesdayDate}`),
				weekGroup: week.id
			});
		});

		return deliveries.sort((a, b) => {
			// Primary: Active (not past deadline) before past deadline
			if (a.isDeadlinePassed !== b.isDeadlinePassed) {
				return a.isDeadlinePassed ? 1 : -1;
			}

			// Active weeks: chronological — soonest delivery first (3/23 before 3/30)
			if (!a.isDeadlinePassed) {
				if (a.weekGroup !== b.weekGroup) {
					return a.weekGroup.localeCompare(b.weekGroup); // ascending = soonest first
				}
				// Within same week: Sunday before Wednesday
				return a.dayName === "Sunday" ? -1 : 1;
			}

			// Past deadline weeks: most recent first
			if (a.weekGroup !== b.weekGroup) {
				return b.weekGroup.localeCompare(a.weekGroup);
			}
			return a.dayName === "Sunday" ? -1 : 1;
		});
	}

	isWednesdayUnlocked(weekGroup) {
		// 10+ meal plans, VIP, special, or Wednesday-only: always unlocked
		if (
			!this.mealPlan ||
			this.mealPlan.mealsPerWeek >= 10 ||
			this.mealPlan.isVIP ||
			this.mealPlan.hasSpecialTag ||
			this.hasWednesdayOnlyTag()
		) {
			return true;
		}
		// Restricted plan (<10): Wednesday unlocked only after Sunday is saved
		const sundayWeekId = `sunday-${weekGroup}`;
		return this.hasExistingSelection(sundayWeekId);
	}

	getExtraMealPrice() {
		if (!this.mealPlan) return this.extraMealPricing.default;
		const planSize = this.mealPlan.mealsPerWeek;
		return this.extraMealPricing[planSize] ?? this.extraMealPricing.default;
	}

	// Helper method to get Pacific Time offset
	getPacificTimeOffset(date) {
		// Create a date in Pacific Time
		const utc = date.getTime() + date.getTimezoneOffset() * 60000;

		// Pacific Time is UTC-8 (PST) or UTC-7 (PDT)
		// Check if it's during Daylight Saving Time
		const year = date.getFullYear();

		// DST in 2025: March 9 - November 2
		const dstStart = new Date(year, 2, 9); // March 9
		const dstEnd = new Date(year, 10, 2); // November 2

		// Find the second Sunday in March
		dstStart.setDate(9 + ((7 - dstStart.getDay()) % 7));
		// Find the first Sunday in November
		dstEnd.setDate(1 + ((7 - dstEnd.getDay()) % 7));

		const isDST = date >= dstStart && date < dstEnd;
		const pacificOffset = isDST ? 7 * 60 * 60 * 1000 : 8 * 60 * 60 * 1000; // 7 or 8 hours in milliseconds

		return pacificOffset;
	}

	renderWeeks() {
		const weekGrid = document.querySelector("[data-week-grid]");
		if (!weekGrid) {
			console.error("Week grid element not found!");
			return;
		}

		let deliveries = this.getAvailableWeeks();

		// Filter for Wednesday-only customers
		if (this.hasWednesdayOnlyTag() && !this.hasVIPTag()) {
			// VIP overrides Wednesday restriction
			console.log(
				"Wednesday-only customer detected - filtering to Wednesday deliveries"
			);
			deliveries = deliveries.filter((d) => d.id.includes("wednesday"));
		}
		// Filter out past deadline weeks for guests and non-subscribers
		if (this.customer.isGuest || !this.mealPlan) {
			console.log("Guest or non-subscriber - hiding past deadline weeks");
			deliveries = deliveries.filter((d) => !d.isDeadlinePassed);
		}
		console.log("Rendering weeks:", deliveries);

		const weekCards = deliveries.map((delivery) => {

			// ── Wednesday gating for restricted plans (<10 meals) ──────────────────
			const isRestrictedWednesday =
				delivery.id.includes("wednesday") &&
				this.mealPlan &&
				this.mealPlan.mealsPerWeek < 10 &&
				!this.mealPlan.isVIP &&
				!this.mealPlan.hasSpecialTag &&
				!this.hasWednesdayOnlyTag();

			if (isRestrictedWednesday && delivery.isDeadlinePassed === false) {
				const wednesdayUnlocked = this.isWednesdayUnlocked(delivery.weekGroup);

				if (!wednesdayUnlocked) {
					// Show a locked "teaser" card — Sunday must be saved first
					return `<div class="week-card week-card--wednesday-locked" data-week-id="${delivery.id}" title="Save your Sunday meals first to unlock Wednesday extras">
						<div class="week-date" style="font-size:1.3rem; color:#856404; font-weight:700;">➕ Optional Extra Meals</div>
						<div class="week-date">${delivery.display}</div>
						<div class="week-status" style="color:#856404;">🔒 Save Sunday order first</div>
						<div class="week-deadline">Wednesday add-ons unlock after your Sunday selections are saved</div>
					</div>`;
				}

				// Unlocked — show with clear "extra / add-on" language
				const extraStatusText = delivery.hasSelection
					? "✓ Extra Meals Selected"
					: "Want more meals this week? Extra meals will be added to your bill.";
				const extraStatusClass = delivery.hasSelection
					? "week-status--selected"
					: "week-status--extra";

				return `<div class="week-card week-card--extra ${
					this.selectedWeek && this.selectedWeek.id === delivery.id ? "week-card--selected" : ""
				}" data-week-id="${delivery.id}">
					<div class="week-date" style="font-size:1.2rem; color:#856404; font-weight:700; margin-bottom:0.3rem;">➕ EXTRA MEALS — NOT IN PLAN</div>
					<div class="week-date">${delivery.display}</div>
					<div class="week-status ${extraStatusClass}">${extraStatusText}</div>
					<div class="week-deadline">Deadline: ${delivery.deadlineDisplay}</div>
				</div>`;
			}
			// ── End Thursday gating ───────────────────────────────────────────────

			const selectedClass =
				this.selectedWeek && this.selectedWeek.id === delivery.id
					? "week-card--selected"
					: "";
			const pastClass = delivery.isDeadlinePassed ? "week-card--past" : "";

			let statusText;
			let statusClass;
			let deadlineDisplayText;

			if (delivery.id === "thursday-2025-12-25") {
				statusText = `<span style="color: #2d7a2d; font-weight: 600;">Merry Christmas 🎄</span><br><span style="font-weight: 600;">&</span><br><span style="color: #1e5a9e; font-weight: 600;">Happy Hanukkah 🕎</span>`;
				statusClass = "week-status--holiday";
				deadlineDisplayText = "";
			} else {
				statusText = delivery.hasSelection
					? "✓ Meals Selected"
					: delivery.isDeadlinePassed
					? "👨‍🍳 No meals selected"
					: "Click to Customize";
				statusClass = delivery.hasSelection
					? "week-status--selected"
					: "week-status--chef-choice";

				deadlineDisplayText = delivery.isDeadlinePassed
					? `Deadline was ${delivery.deadlineDisplay}`
					: `Deadline: ${delivery.deadlineDisplay}`;
			}

			return `<div class="week-card ${selectedClass} ${pastClass}" data-week-id="${delivery.id}">
				<div class="week-date">${delivery.display}</div>
				<div class="week-status ${statusClass}">${statusText}</div>
				<div class="week-deadline">${deadlineDisplayText}</div>
			</div>`;
		});

		// Format "Week of Month Day" from YYYY-MM-DD
		const weekLabel = (dateStr) => {
			const [y, m, day] = dateStr.split('-').map(Number);
			const date = new Date(y, m - 1, day);
			return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
		};

		// Inject "Week of..." label before each new week group.
		// grid-column: 1 / -1 spans both columns on desktop, full width on mobile.
		let lastGroup = null;
		let html = '';
		weekCards.forEach((cardHtml, i) => {
			const delivery = deliveries[i];
			if (delivery.weekGroup !== lastGroup) {
				const isPast = deliveries
					.filter(d => d.weekGroup === delivery.weekGroup)
					.every(d => d.isDeadlinePassed);
				const pastTag = isPast ? ' <span class="week-group-past-tag">Past</span>' : '';
				html += '<div class="week-group-label' + (isPast ? ' week-group-label--past' : '') + '" style="grid-column: 1 / -1;">Week of ' + weekLabel(delivery.weekGroup) + pastTag + '</div>';
				lastGroup = delivery.weekGroup;
			}
			html += cardHtml;
		});

		weekGrid.innerHTML = html;

		// Add event listeners for week selection
		weekGrid.querySelectorAll(".week-card").forEach((card) => {
			card.addEventListener("click", () => {
				const deliveryId = card.dataset.weekId;

				// Disable clicking on Christmas day
				if (deliveryId === "thursday-2025-12-25") {
					return; // Do nothing
				}

				const delivery = deliveries.find((d) => d.id === deliveryId);
				this.selectWeek(delivery);
			});
		});
	}

	selectWeek(delivery) {
		this.selectedWeek = delivery;
		this.renderWeeks();
		this.showMealSelection();
		this.scrollToMealSection();
	}

	showMealSelection() {
		const mealSection = document.querySelector("[data-meal-section]");
		if (!mealSection) return;

		mealSection.style.display = "block";

		this.updateWeekTitle();
		this.updateDeadlineNotice();

		if (this.selectedWeek.isDeadlinePassed) {
			console.log("📦 Showing past delivery - NOT clearing working state");
			this.renderPastDelivery();
		} else {
			console.log("📝 Showing active week - ensuring clean working state");
			this.ensureCleanWorkingState();
			this.renderMeals();
		}

		this.updateOrderSummary();
	}

	ensureCleanWorkingState() {
		const weekId = this.selectedWeek && this.selectedWeek.id;
		if (!weekId) return;

		// Reset working data to empty/default state
		this.mealQuantities[weekId] = {};
		this.mealOptions[weekId] = {};

		if (!this.proteinBallSelections[weekId]) {
			this.proteinBallSelections[weekId] = {};
		}
		// Protein ball selections keyed by meal ID, no pre-seeding needed

		console.log(`🧹 Ensured clean working state for ${weekId}`);
	}

	updateWeekTitle() {
		const weekTitle = document.querySelector("[data-week-title]");
		if (weekTitle) {
			if (this.selectedWeek.isDeadlinePassed) {
				weekTitle.textContent = this.selectedWeek.display + " - Final Selection";
			} else {
				weekTitle.textContent = this.selectedWeek.display;
			}
		}
	}

	updateDeadlineNotice() {
		const deadlineNotice = document.querySelector("[data-deadline-notice]");
		if (deadlineNotice) {
			if (this.selectedWeek.isDeadlinePassed) {
				deadlineNotice.className = "deadline-notice deadline-notice--past";
				if (this.selectedWeek.hasSelection) {
					deadlineNotice.innerHTML =
						"✅ Selection deadline has passed. Below is your final meal selection.";
				} else {
					deadlineNotice.innerHTML =
						"📅 Selection deadline has passed.";
				}
			} else {
				deadlineNotice.className =
					"deadline-notice" +
					(this.selectedWeek.isUrgent ? " deadline-notice--urgent" : "");
				deadlineNotice.innerHTML = this.selectedWeek.deadlineText;
			}
		}
	}

	renderPastDelivery() {
		const mealsGrid = document.querySelector("[data-meals-grid]");
		if (!mealsGrid) return;

		const savedSelection = this.weeklySelections[this.selectedWeek.id];

		// Check if they have a saved selection with actual meals
		if (
			savedSelection &&
			savedSelection.meals &&
			savedSelection.meals.length > 0
		) {
			console.log(
				`📦 Rendering past selection for ${this.selectedWeek.id}:`,
				savedSelection
			);

			// Get the menu for this week
			const meals = this.weeklyMenus[this.selectedWeek.id];

			if (!meals || meals.length === 0) {
				console.error(`❌ No menu found for ${this.selectedWeek.id}`);
				console.log("Available menu keys:", Object.keys(this.weeklyMenus));
				mealsGrid.innerHTML =
					'<p style="text-align: center; padding: 2rem; color: #e74c3c;">Error: Menu data not found. Please contact support.</p>';
				return;
			}

			console.log(
				`📋 Found menu with ${meals.length} meals for ${this.selectedWeek.id}`
			);

			// Create maps of saved data to pass to render methods
			const savedQuantities = {};
			const savedOptions = {};

			savedSelection.meals.forEach((meal) => {
				savedQuantities[meal.id] = meal.quantity;
				savedOptions[meal.id] = meal.optionDetails || {}; 
			});

			console.log("📊 Saved quantities:", savedQuantities);
			console.log("📊 Saved options:", savedOptions);

			// Render meal cards, passing the saved data directly
			const mealCards = meals
				.map((meal) => {
					const rendered = this.renderPastMealCardWithData(
						meal,
						savedQuantities,
						savedOptions
					);
					if (rendered) {
						console.log(`✅ Rendered card for meal ${meal.id} (${meal.name})`);
					} else {
						console.log(
							`⏭️ Skipped meal ${meal.id} (${meal.name}) - quantity: ${
								savedQuantities[meal.id] || 0
							}`
						);
					}
					return rendered;
				})
				.filter((html) => html !== "");

			console.log(
				`📦 Generated ${mealCards.length} meal cards (before protein balls)`
			);

			// Handle protein balls
			if (
				savedSelection.proteinBalls &&
				savedSelection.proteinBalls.selectedOption !== "none"
			) {
				const proteinBallMeal = meals.find((m) => this.isProteinBallMeal(m.id));
				if (proteinBallMeal) {
					const pbCard = this.renderPastProteinBallCard(
						proteinBallMeal,
						savedSelection.proteinBalls
					);
					if (pbCard) {
						mealCards.push(pbCard);
						console.log("✅ Added protein balls card");
					}
				}
			}

			if (mealCards.length === 0) {
				console.error(`❌ No meal cards rendered for ${this.selectedWeek.id}`);
				console.log("Saved meals data:", savedSelection.meals);
				mealsGrid.innerHTML = this.renderChefsChoiceMessage();
			} else {
				mealsGrid.innerHTML = mealCards.join("");
				console.log(`✅ Rendered ${mealCards.length} meal cards for past delivery`);
			}
		} else {
			// No selection was made - show Chef's Choice
			console.log(
				`👨‍🍳 No selection for ${this.selectedWeek.id}, showing Chef's Choice`
			);
			mealsGrid.innerHTML = this.renderChefsChoiceMessage();
		}
	}

	renderPastMealCardWithData(meal, savedQuantities, savedOptions) {
		const quantity = savedQuantities[meal.id] || 0;

		// Skip protein balls here (handled separately)
		if (this.isProteinBallMeal(meal.id)) {
			return "";
		}

		// For regular meals - must have quantity > 0
		if (!quantity || quantity === 0) {
			return ""; // Don't render meals that weren't ordered
		}

		// Render the full meal card with image and all details
		return `<div class="meal-card meal-card--past">
        <img src="${meal.image}" alt="${
			meal.name
		}" class="meal-image" loading="lazy">
        <div class="meal-info">
            <h3 class="meal-name">${meal.name}</h3>
            <div class="meal-description-wrapper">
                <p class="meal-description">${meal.description}</p>
            </div>
            <div class="meal-bottom-content">
                ${meal.options ? this.renderPastMealOptionsWithData(meal, savedOptions[meal.id] || {}) : ""}
                <div class="quantity-display-past">
                    <span class="quantity-selected">Selected: ${quantity} portion${
			quantity > 1 ? "s" : ""
		}</span>
                </div>
            </div>
        </div>
    </div>`;
	}

	renderPastMealOptionsWithData(meal, selectedOptions) {
		if (!meal.options) return "";

		const selectedOptionsList = [];

		Object.entries(meal.options).forEach(([key, option]) => {
			if (selectedOptions[key] && selectedOptions[key].isSelected) {
				selectedOptionsList.push(option.label);
			}
		});

		if (selectedOptionsList.length === 0) {
			return "";
		}

		return `<div class="meal-options meal-options--past">
        <div class="options-title">Your Customizations:</div>
        <div class="options-list">
            ${selectedOptionsList.map((option) => `<div class="option-selected">✓ ${option}</div>`).join("")}
        </div>
    </div>`;
	}

	renderPastProteinBallCard(meal, proteinBallData) {
		const optionDetails = meal.options[proteinBallData.selectedOption];

		if (!optionDetails) {
			return "";
		}

		return `<div class="meal-card meal-card--past meal-card--addon">
        <img src="${meal.image}" alt="${meal.name.replace(/<[^>]*>/g, '')}" class="meal-image" loading="lazy"/>
        <div class="meal-info">
            <h3 class="meal-name">${meal.name}</h3>
            <div class="meal-description-wrapper">
                <p class="meal-description">${meal.description}</p>
            </div>
            <div class="meal-bottom-content">
                <div class="meal-options meal-options--past">
                    <div class="options-title">Your Selection:</div>
                    <div class="option-selected">✓ ${optionDetails.label}</div>
                </div>
            </div>
        </div>
    </div>`;
	}
	renderPastMealCard(meal) {
		const quantity = this.getMealQuantity(meal.id);
		const isProteinBalls = this.isProteinBallMeal(meal.id);

		// Handle protein balls
		if (isProteinBalls) {
			const selectedOption = this.getProteinBallSelection(meal.id);
			if (!selectedOption || selectedOption === "none") {
				return ""; // Don't render if not selected
			}

			const optionDetails = meal.options[selectedOption];
			if (!optionDetails) {
				return "";
			}

			return `<div class="meal-card meal-card--past meal-card--addon">
				<img src="${meal.image}" alt="${meal.name.replace(/<[^>]*>/g, '')}" class="meal-image" loading="lazy"/>
				<div class="meal-info">
					<h3 class="meal-name">${meal.name}</h3>
					<div class="meal-description-wrapper">
						<p class="meal-description">${meal.description}</p>
					</div>
					<div class="meal-bottom-content">
						<div class="meal-options meal-options--past">
							<div class="options-title">Your Selection:</div>
							<div class="option-selected">✓ ${optionDetails.label}</div>
						</div>
					</div>
				</div>
			</div>`;
		}

		// For regular meals - must have quantity > 0
		if (!quantity || quantity === 0) {
			return ""; // Don't render meals that weren't ordered
		}

		// Render the full meal card with image and all details
		return `<div class="meal-card meal-card--past">
			<img src="${meal.image}" alt="${meal.name.replace(/<[^>]*>/g, '')}" class="meal-image" loading="lazy"/>
			<div class="meal-info">
				<h3 class="meal-name">${meal.name}</h3>
				<div class="meal-description-wrapper">
					<p class="meal-description">${meal.description}</p>
				</div>
				<div class="meal-bottom-content">
					${meal.options ? this.renderPastMealOptions(meal) : ""}
					<div class="quantity-display-past">
						<span class="quantity-selected">Selected: ${quantity} portion${quantity > 1 ? "s" : ""}</span>
					</div>
				</div>
			</div>
		</div>`;
	}

	renderPastMealOptions(meal) {
		if (!meal.options) return "";

		const selectedOptions = [];

		Object.entries(meal.options).forEach(([key, option]) => {
			if (this.getMealOption(meal.id, key)) {
				selectedOptions.push(option.label);
			}
		});

		if (selectedOptions.length === 0) {
			return "";
		}

		return `<div class="meal-options meal-options--past">
			<div class="options-title">Your Customizations:</div>
			  <div class="options-list">
				${selectedOptions
					.map((option) => `<div class="option-selected">✓ ${option}</div>`)
					.join("")}
			  </div>
		</div>`;
	}

	renderChefsChoiceMessage() {
		const hasAnyHistoricalSelections =
			Object.keys(this.weeklySelections).length > 0;

		if (!hasAnyHistoricalSelections) {
			// New customer message
			return `<div class="chefs-choice-message">
			<div class="chefs-choice-card">
				<div class="chefs-choice-icon">👨‍🍳</div>
				<h3 class="chefs-choice-title">Selection Deadline Has Passed</h3>
				<p class="chefs-choice-description">
				The customization deadline for this ${this.selectedWeek.dayName} delivery has already passed. 
				However, you can still customize upcoming deliveries that haven't reached their deadlines yet!
				</p>
				<div class="chefs-choice-note">
				<strong>Next Steps:</strong> Check the other delivery dates to find weeks you can still customize. 
				Future deliveries can be customized until Wednesday at 4:00 PM.
				</div>
			</div>
			</div>`;
		}
		return `<div class="chefs-choice-message">
		  <div class="chefs-choice-card">
			<div class="chefs-choice-icon">👨‍🍳</div>
			<h3 class="chefs-choice-title">No meals selected</h3>
			<p class="chefs-choice-description">
			  The customization deadline for this ${this.selectedWeek.dayName} delivery has already passed.
			  Unless requested to skip you'll receive a surprise selection of our most popular dishes!
			</p>
			<div class="chefs-choice-note">
			  <strong>Note: </strong>Meal plans of less than 10 will not receive a Chef's choice delivery on Thursdays. 
			  <br/>Don't forget to customize your future deliveries before the deadline to choose your preferred meals.
			</div>
		  </div>
		</div>`;
	}

	renderMeals() {
		const mealsGrid = document.querySelector("[data-meals-grid]");
		if (!mealsGrid) return;

		// Use the selected week ID to get the right menu
		const meals = this.weeklyMenus[this.selectedWeek.id] || [];

		if (meals.length === 0) {
			console.warn(`No meals found for ${this.selectedWeek.id}`);
			// Fallback: try to find meals for this date in the old format
			const fallbackMeals = this.findFallbackMeals(this.selectedWeek.id);
			if (fallbackMeals.length > 0) {
				mealsGrid.innerHTML = fallbackMeals
					.map((meal) => this.renderMealCard(meal, this.selectedWeek.id))
					.join("");
			} else {
				mealsGrid.innerHTML = "<p>No meals available for this delivery date.</p>";
			}
		} else {
			mealsGrid.innerHTML = meals
				.map((meal) => this.renderMealCard(meal, this.selectedWeek.id))
				.join("");
		}

		this.bindMealEvents();
		setTimeout(() => {
			this.enforceCleanUIState();
		}, 50);
	}
	findFallbackMeals(weekId) {
		// Try to find meals in old format as fallback
		const dayType = weekId.split("-")[0];
		const oldKeys = Object.keys(this.weeklyMenus).filter((key) =>
			key.includes(dayType)
		);

		if (oldKeys.length > 0) {
			return this.weeklyMenus[oldKeys[0]] || [];
		}
		return [];
	}

	enforceCleanUIState() {
		// Reset all quantity displays to 0
		document.querySelectorAll("[data-quantity]").forEach((quantityDisplay) => {
			quantityDisplay.textContent = "0";
		});

		// Uncheck all meal option checkboxes
		document.querySelectorAll("[data-meal-option]").forEach((checkbox) => {
			checkbox.checked = false;
		});

		// Set protein balls to "none" option
		document.querySelectorAll("[data-protein-ball]").forEach((radio) => {
			if (radio.value === "none") {
				radio.checked = true;
			} else {
				radio.checked = false;
			}
		});

		// Disable all decrease buttons (since quantities are 0)
		document.querySelectorAll('[data-action="decrease"]').forEach((btn) => {
			btn.disabled = true;
		});

		console.log("🧹 Enforced clean UI state - all controls reset");
	}
	renderMealCard(meal, weekId) {
		if (this.isNonSubscriber) {
			// Simple version for non-subscribers (doesn't need weekId)
			const mealCard = document.createElement("div");
			mealCard.className = "meal-card meal-card--view-only";
			mealCard.dataset.mealId = meal.id;

			mealCard.innerHTML = `
			<img src="${meal.image}" alt="${meal.name.replace(/<[^>]*>/g, '')}" class="meal-image" loading="lazy"/>
			<div class="meal-info">
				<h3 class="meal-name">${meal.name}</h3>
				<p class="meal-description">${meal.description}</p>
			</div>
			`;

			return mealCard.outerHTML; 
		} else {
			//const quantity = this.getMealQuantity(meal.id);
			const isProteinBalls = this.isProteinBallMeal(meal.id);
			const quantity = this.mealQuantities[weekId]?.[meal.id] || 0;
			const selectedOptions = this.mealOptions[weekId]?.[meal.id] || {};

			return `<div class="meal-card ${
				isProteinBalls ? "meal-card--addon" : ""
			}" data-meal-id="${meal.id}">
				<img src="${meal.image}" 
				alt="${meal.name.replace(/<[^>]*>/g, '')}"
				class="meal-image" 
				loading="lazy"
				width="400" 
				height="400"
				onload="this.style.opacity='1'"
				onerror="this.src='https://via.placeholder.com/400x400/f5f5f5/666?text=Image+Not+Available'"
				data-loading="true">
				<div class="meal-info">
					<h3 class="meal-name">${meal.name}</h3>
					<p class="meal-description">${meal.description}</p>
					${
						isProteinBalls
							? this.renderProteinBallOptions(meal)
							: meal.options
							? this.renderMealOptions(meal)
							: '<div class="meal-spacer"></div>'
					}
					${isProteinBalls ? "" : this.renderQuantityControls(meal.id, quantity)}
				</div>
			</div>`;
		}
	}

	renderProteinBallOptions(meal) {
		if (!meal.options) return "";

		const weekId = this.selectedWeek && this.selectedWeek.id;
		const selectedOption = this.getProteinBallSelection(meal.id);

		return `<div class="addon-options-wrapper">
          <div class="addon-options">
            <div class="options-title">Choose Your Protein Ball Option:</div>
            <div class="options-grid">
				${Object.entries(meal.options)
					.map(
						([key, option]) => `<label class="option-radio">
                  <input type="radio" 
                        name="protein-balls-${weekId}-${meal.id}"
                        value="${key}"
                        data-protein-ball="${meal.id}" 
                        data-option-key="${key}"${
							selectedOption === key ? " checked" : ""
						}>
                  <span class="option-label">${option.label}</span>
                  <span class="option-price">$${option.price.toFixed(2)}</span>
                </label>`
					)
					.join("")}
				<label class="option-radio">
                <input type="radio" 
                      name="protein-balls-${weekId}-${meal.id}"
                      value="none"
                      data-protein-ball="${meal.id}" 
                      data-option-key="none"${!selectedOption || selectedOption === "none" ? " checked": ""}>
                <span class="option-label">No Protein Balls</span>
                <span class="option-price">$0.00</span>
              </label>
            </div>
          </div>
        </div>`;
	}

	getProteinBallSelection(mealId) {
		const weekId = this.selectedWeek && this.selectedWeek.id;
		if (!weekId) return "none";

		return (
			(this.proteinBallSelections &&
				this.proteinBallSelections[weekId] &&
				this.proteinBallSelections[weekId][mealId]) ||
			"none"
		);
	}

	updateProteinBallSelection(mealId, optionKey) {
		const weekId = this.selectedWeek && this.selectedWeek.id;
		if (!weekId) return;

		if (!this.proteinBallSelections) {
			this.proteinBallSelections = {};
		}

		if (!this.proteinBallSelections[weekId]) {
			this.proteinBallSelections[weekId] = {};
		}

		this.proteinBallSelections[weekId][mealId] = optionKey;
	}

	renderMealOptions(meal) {
		if (!meal.options) return "";

		return `<div class="meal-options-wrapper">
        <div class="meal-options">
          <div class="options-title">Customize Your Meal:</div>
          <div class="options-grid">
            ${Object.entries(meal.options).map(([key, option]) => `<label class="option-checkbox">
                <input type="checkbox" data-meal-option="${meal.id}" data-option-key="${key}"${this.getMealOption(meal.id, key) ? " checked" : ""}>
                <span class="option-label">${option.label}</span>
                ${option.price > 0? `<span class="option-price">+${option.price.toFixed(2)}</span>`: ""}
              </label>`).join("")}
          </div>
        </div>
      </div>`;
	}

	renderQuantityControls(mealId, quantity) {
		return `<div class="quantity-controls">
        <div class="quantity-selector">
          <button type="button" class="quantity-btn" data-action="decrease" data-meal="${mealId}"${
			quantity <= 0 ? " disabled" : ""
		}>−</button>
          <span class="quantity-display" data-quantity="${mealId}">${quantity}</span>
          <button type="button" class="quantity-btn" data-action="increase" data-meal="${mealId}">+</button>
        </div>
      </div>`;
	}

	bindMealEvents() {
		// Quantity controls (only for regular meals)
		document.querySelectorAll("[data-action]").forEach((btn) => {
			btn.addEventListener("click", () => {
				const mealId = btn.dataset.meal;
				const action = btn.dataset.action;

				if (action === "increase") {
					this.increaseMealQuantity(mealId);
				} else if (action === "decrease") {
					this.decreaseMealQuantity(mealId);
				}
			});
		});

		// Meal options (for regular meals)
		document.querySelectorAll("[data-meal-option]").forEach((checkbox) => {
			checkbox.addEventListener("change", () => {
				const mealId = checkbox.dataset.mealOption;
				const optionKey = checkbox.dataset.optionKey;
				this.updateMealOption(mealId, optionKey, checkbox.checked);
				this.updateOrderSummary();
			});
		});

		// Protein ball radio buttons
		document.querySelectorAll("[data-protein-ball]").forEach((radio) => {
			radio.addEventListener("change", () => {
				if (radio.checked) {
					const mealId = radio.dataset.proteinBall;
					const optionKey = radio.dataset.optionKey;
					this.updateProteinBallSelection(mealId, optionKey);
					this.updateOrderSummary();
				}
			});
		});
	}

	// QUANTITY MANAGEMENT
	increaseMealQuantity(mealId) {
		const weekId = this.selectedWeek.id;
		if (!this.mealQuantities[weekId]) {
			this.mealQuantities[weekId] = {};
		}

		this.mealQuantities[weekId][mealId] =
			(this.mealQuantities[weekId][mealId] || 0) + 1;
		this.updateMealDisplay(mealId);
		this.updateOrderSummary();
	}

	decreaseMealQuantity(mealId) {
		const weekId = this.selectedWeek.id;
		if (!this.mealQuantities[weekId]) return;

		const currentQty = this.mealQuantities[weekId][mealId] || 0;
		if (currentQty > 0) {
			this.mealQuantities[weekId][mealId] = currentQty - 1;
			this.updateMealDisplay(mealId);
			this.updateOrderSummary();
		}
	}

	updateMealDisplay(mealId) {
		const quantity = this.getMealQuantity(mealId);
		const quantityDisplay = document.querySelector(`[data-quantity="${mealId}"]`);
		const decreaseBtn = document.querySelector(
			`[data-action="decrease"][data-meal="${mealId}"]`
		);

		if (quantityDisplay) {
			quantityDisplay.textContent = quantity;
		}

		if (decreaseBtn) {
			decreaseBtn.disabled = quantity <= 0;
		}

		const optionsTitle = document.querySelector(
			`[data-meal-id="${mealId}"] .options-title`
		);
		if (optionsTitle) {
			optionsTitle.textContent = "Customize Your Meal:";
		}

		this.updateOrderSummary();
	}

	// DATA HELPER METHODS
	getMealQuantity(mealId) {
		const weekId = this.selectedWeek && this.selectedWeek.id;
		if (!weekId) return 0;
		return (
			(this.mealQuantities[weekId] && this.mealQuantities[weekId][mealId]) || 0
		);
	}

	getMealOption(mealId, optionKey) {
		const weekId = this.selectedWeek && this.selectedWeek.id;
		if (!weekId) return false;
		return (
			(this.mealOptions[weekId] &&
				this.mealOptions[weekId][mealId] &&
				this.mealOptions[weekId][mealId][optionKey]) ||
			false
		);
	}

	updateMealOption(mealId, optionKey, isSelected) {
		const weekId = this.selectedWeek && this.selectedWeek.id;
		if (!weekId) return;

		if (!this.mealOptions[weekId]) {
			this.mealOptions[weekId] = {};
		}

		if (!this.mealOptions[weekId][mealId]) {
			this.mealOptions[weekId][mealId] = {};
		}

		this.mealOptions[weekId][mealId][optionKey] = isSelected;
	}

	hasExistingSelection(weekId) {
		// Check if weeklySelections has this weekId
		if (!this.weeklySelections[weekId]) {
			console.log(
				`hasExistingSelection(${weekId}): false - no entry in weeklySelections`
			);
			return false;
		}

		const selection = this.weeklySelections[weekId];

		// Check if hasSelection flag is set
		if (selection.hasSelection === false) {
			console.log(
				`hasExistingSelection(${weekId}): false - hasSelection flag is false`
			);
			return false;
		}

		// Check if there are actual meals
		const hasMeals = selection.meals && selection.meals.length > 0;
		const hasProteinBalls =
			selection.proteinBalls &&
			selection.proteinBalls.selectedOption &&
			selection.proteinBalls.selectedOption !== "none";

		const result = hasMeals || hasProteinBalls;

		console.log(
			`hasExistingSelection(${weekId}): ${result} (meals: ${hasMeals}, proteinBalls: ${hasProteinBalls})`
		);

		return result;
	}

	updateOrderSummary() {
		const summaryContent = document.querySelector("[data-order-summary]");
		const totalSection = document.querySelector("[data-order-total]");
		const totalCount = document.querySelector("[data-total-count]");
		const saveBtn = document.querySelector("[data-save-order]");

		if (!summaryContent || !totalSection || !saveBtn) return;

		const weekId = this.selectedWeek && this.selectedWeek.id;

		// Clear existing add button when switching days
		this.clearExistingAddButton(saveBtn);

		if (this.selectedWeek && this.selectedWeek.isDeadlinePassed) {
			this.hideSummaryForPastDeadline(summaryContent, totalSection, saveBtn);
			return;
		}

		if (!weekId) {
			this.showEmptySummary(summaryContent, totalSection, saveBtn);
			return;
		}

		const summaryData = this.calculateSummaryData(weekId);

		// Check if we have any selection (meals OR protein balls)
		const proteinBallMeals = (this.weeklyMenus[weekId] || [])
			.filter(m => this.isProteinBallMeal(m.id));
		const hasProteinBalls = proteinBallMeals.some(m => {
			const sel = this.proteinBallSelections[weekId]?.[m.id];
			return sel && sel !== "none";
		});
		const hasMeals = summaryData.totalMeals > 0;
		const hasAnySelection = hasMeals || hasProteinBalls;

		if (hasAnySelection) {
			this.showActiveSummary(
				summaryContent,
				totalSection,
				totalCount,
				summaryData,
				hasProteinBalls
			);
		} else {
			this.showEmptySummary(summaryContent, totalSection, saveBtn);
		}
	}
	addNewWeek(newWeekConfig) {
		// Add the new week to available weeks
		this.weekConfig.availableWeeks.push(newWeekConfig);

		// Remove weeks older than 8 weeks to prevent unlimited growth
		const eightWeeksAgo = new Date();
		eightWeeksAgo.setDate(eightWeeksAgo.getDate() - 56);

		this.weekConfig.availableWeeks = this.weekConfig.availableWeeks.filter(
			(week) => {
				return new Date(week.mondayDate) > eightWeeksAgo;
			}
		);

		// Refresh the UI
		this.renderWeeks();

		// Update portal if it exists
		if (this.customerPortal) {
			this.customerPortal.loadPortalData();
		}

		console.log(`New week added: ${newWeekConfig.id}`);
		return true;
	}

	clearExistingAddButton(saveBtn) {
		const buttonContainer = saveBtn.parentElement;
		const existingAddBtn = buttonContainer.querySelector("[data-add-to-meals]");
		if (existingAddBtn) {
			existingAddBtn.remove();
		}
	}

	hideSummaryForPastDeadline(summaryContent, totalSection, saveBtn) {
		summaryContent.innerHTML = "";
		totalSection.style.display = "none";
		saveBtn.style.display = "none";
	}

	showEmptySummary(summaryContent, totalSection, saveBtn) {
		summaryContent.innerHTML =
			'<p class="body">Select meals to see your order summary</p>';
		totalSection.style.display = "none";
		this.renderSaveButtons(0, false, null, false); // Pass all 4 parameters
	}

	calculateSummaryData(weekId) {
		const selectedMeals = this.mealQuantities[weekId];
		const meals = this.weeklyMenus[weekId];

		// SAFETY CHECK: If no meals found, return empty data
		if (!meals || meals.length === 0) {
			console.warn(
				`No meals found for ${weekId}. Available menu keys:`,
				Object.keys(this.weeklyMenus)
			);
			return {
				totalMeals: 0,
				totalAddOnCost: 0,
				summaryHtml: "",
				planAnalysis: this.analyzeMealPlan(0, weekId)
			};
		}

		let totalMeals = 0;
		let totalAddOnCost = 0;
		let summaryHtml = "";

		// Regular meals
		for (const [mealId, quantity] of Object.entries(selectedMeals || {})) {
			if (quantity > 0 && !this.isProteinBallMeal(mealId)) {
				const meal = meals.find((m) => m.id === mealId);
				if (meal) {
					totalMeals += quantity;

					const mealSummary = this.renderMealSummaryItem(meal, quantity, weekId);
					summaryHtml += mealSummary.html;
					totalAddOnCost += mealSummary.addOnCost;
				} else {
					console.warn(`Meal ${mealId} not found in menu for ${weekId}`);
				}
			}
		}

		// Add protein balls to summary if selected
		const proteinBallSummary = this.renderProteinBallSummary(weekId);
		if (proteinBallSummary.html) {
			summaryHtml += proteinBallSummary.html;
			totalAddOnCost += proteinBallSummary.addOnCost;
		}

		return {
			totalMeals,
			totalAddOnCost,
			summaryHtml,
			planAnalysis: this.analyzeMealPlan(totalMeals, weekId)
		};
	}
	renderProteinBallSummary(weekId) {
		const meals = this.weeklyMenus[weekId] || [];
		const proteinBallMeals = meals.filter(m => this.isProteinBallMeal(m.id));

		let html = "";
		let totalAddOnCost = 0;

		proteinBallMeals.forEach(meal => {
			const selectedOption = this.proteinBallSelections[weekId]?.[meal.id];
			if (!selectedOption || selectedOption === "none") return;
			if (!meal.options?.[selectedOption]) return;

			const option = meal.options[selectedOption];
			const cost = option.price || 0;
			totalAddOnCost += cost;

			html += `<div class="summary-item summary-item--addon">
				<div class="summary-item-main">
					<span class="meal-name-summary">${meal.name}</span>
					<span class="meal-quantity">Add-on</span>
					${cost > 0 ? `<span class="meal-addon-cost"> &nbsp;+$${cost.toFixed(2)}</span>` : ""}
				</div>
				<div class="summary-item-options">
					<span class="option-desc">${option.label}</span>
				</div>
			</div>`;
		});

		return { html, addOnCost: totalAddOnCost };
	}
	renderMealSummaryItem(meal, quantity, weekId) {
		let addOnCost = 0;
		const selectedOptions =
			(this.mealOptions[weekId] && this.mealOptions[weekId][meal.id]) || {};
		const addOnDescriptions = [];

		if (meal.options) {
			Object.entries(selectedOptions).forEach(([optionKey, isSelected]) => {
				if (isSelected && meal.options[optionKey]) {
					const optionPrice = meal.options[optionKey].price || 0;
					if (optionPrice > 0) {
						addOnCost += optionPrice * quantity;
						addOnDescriptions.push(
							meal.options[optionKey].label +
								" (+$" +
								optionPrice.toFixed(2) +
								" each)"
						);
					} else {
						addOnDescriptions.push(meal.options[optionKey].label);
					}
				}
			});
		}

		const html = `<div class="summary-item">
		<div class="summary-item-main">
			<span class="meal-name-summary">${meal.name}</span>
			<span class="meal-quantity">×${quantity}</span>
			${
				addOnCost > 0
					? ` <span class="meal-addon-cost"> &nbsp;(+${addOnCost.toFixed(2)})</span>`
					: ""
			}
		</div>
			${
				addOnDescriptions.length > 0
					? `<div class="summary-item-options">
			${addOnDescriptions
				.map((desc) => `<span class="option-desc">${desc}</span>`)
				.join("")}</div>`
					: ""
			}
		</div>`;

		return { html, addOnCost };
	}

	showActiveSummary(
		summaryContent,
		totalSection,
		totalCount,
		summaryData,
		hasProteinBalls = false
	) {
		summaryContent.innerHTML = summaryData.summaryHtml;
		totalSection.style.display = "block";
		totalCount.textContent = summaryData.totalMeals;

		const hasExisting = this.hasExistingSelection(this.selectedWeek.id);

		// Pass hasProteinBalls info to save button rendering
		this.renderSaveButtons(
			summaryData.totalMeals,
			hasExisting,
			summaryData.planAnalysis,
			hasProteinBalls
		);
		this.displayMealBreakdown(summaryData.planAnalysis);
	}

	analyzeMealPlan(totalMeals, weekId) {
		// If no meal plan, return special analysis
		if (!this.mealPlan) {
			return {
				totalMeals: totalMeals,
				weeklyTotal: 0,
				planMeals: 0,
				isUnder: false,
				isOver: false,
				extraMeals: 0,
				missingMeals: 0,
				extraCost: 0,
				warnings: ["No active subscription"],
				blockSave: true,
				blockReason: "Subscription required to save meals",
				weekBreakdown: { sunday: 0, wednesday: 0, total: 0 },
				noSubscription: true
			};
		}
		const parts = weekId.split("-");
		let weekIdentifier;

		if (parts.length === 4) {
			weekIdentifier = `${parts[1]}-${parts[2]}-${parts[3]}`;
		} else {
			weekIdentifier = weekId;
		}

		const weeklyTotal = this.calculateWeeklyTotal(weekIdentifier);
		console.log(
			"analyzeMealPlan - weekId:",
			weekId,
			"weekIdentifier:",
			weekIdentifier,
			"totals:",
			weeklyTotal
		);

		const analysis = {
			totalMeals: totalMeals,
			weeklyTotal: weeklyTotal.total,
			planMeals: this.mealPlan.mealsPerWeek,
			isUnder: false,
			isOver: false,
			extraMeals: 0,
			missingMeals: 0,
			extraCost: 0,
			warnings: [],
			blockSave: false,
			blockReason: "",
			weekBreakdown: weeklyTotal,
			hasSpecialTag: this.mealPlan.hasSpecialTag
		};

		// Special tag and VIP users get the old flexible behavior
		if (this.mealPlan.hasSpecialTag || this.mealPlan.isVIP) {
			if (weeklyTotal.total < this.mealPlan.mealsPerWeek) {
				analysis.isUnder = true;
				analysis.missingMeals = this.mealPlan.mealsPerWeek - weeklyTotal.total;
				analysis.warnings.push(
					`⭐ Special Member: Weekly total ${weeklyTotal.total} meals (${analysis.missingMeals} under your ${this.mealPlan.planName})`
				);
			} else if (weeklyTotal.total > this.mealPlan.mealsPerWeek) {
				analysis.isOver = true;
				analysis.extraMeals = weeklyTotal.total - this.mealPlan.mealsPerWeek;
				analysis.warnings.push(
					`⭐ Special Member: Weekly total ${weeklyTotal.total} meals (${analysis.extraMeals} extra meals)`
				);
			}
			return analysis;
		}

		// Regular customers get strict enforcement
		let projectedTotal = weeklyTotal.total;
		if (weekId.includes("sunday")) {
			projectedTotal = weeklyTotal.wednesday + totalMeals;
		} else if (weekId.includes("wednesday")) {
			projectedTotal = weeklyTotal.sunday + totalMeals;
		}

		// Minimum order warning
		if (totalMeals < this.planPricing.minimumOrderWarning && totalMeals > 0) {
			analysis.warnings.push(
				`ℹ️ Note: Minimum for delivery is ${this.planPricing.minimumOrderWarning} meals, but you can save partial selections to build your order with different customizations.`
			);
		}

		if (projectedTotal < this.mealPlan.mealsPerWeek) {
			analysis.isUnder = true;
			analysis.missingMeals = this.mealPlan.mealsPerWeek - projectedTotal;
			analysis.warnings.push(
				`Subscription requirement: ${this.mealPlan.mealsPerWeek} meals (${analysis.missingMeals} still needed)`
			);
		} else if (projectedTotal >= this.mealPlan.mealsPerWeek) {
			analysis.warnings.push(
				`Meeting subscription: ${projectedTotal} meals selected`
			);
		}
		return analysis;

		if (weeklyTotal.total < this.mealPlan.mealsPerWeek) {
			analysis.isUnder = true;
			analysis.missingMeals = this.mealPlan.mealsPerWeek - weeklyTotal.total;
			analysis.warnings.push(
				`Weekly total: ${weeklyTotal.total} meals (${analysis.missingMeals} under your ${this.mealPlan.planName})`
			);
		} else if (weeklyTotal.total > this.mealPlan.mealsPerWeek) {
			analysis.isOver = true;
			analysis.extraMeals = weeklyTotal.total - this.mealPlan.mealsPerWeek;
			// analysis.extraCost = analysis.extraMeals * this.planPricing.extraMealPrice;

			if (this.mealPlan.allowsOverage) {
				analysis.warnings.push(
					`Weekly total: ${weeklyTotal.total} meals (${analysis.extraMeals} extra meals above your subscription)`
				);
			} else {
				analysis.warnings.push(
					`Weekly total: ${weeklyTotal.total} meals exceeds your ${this.mealPlan.planName} by ${analysis.extraMeals}`
				);
				analysis.blockSave = true;
				analysis.blockReason = `Remove ${analysis.extraMeals} meals from this week`;
			}
		} else {
			analysis.warnings.push(
				`Weekly total: ${weeklyTotal.total} meals (perfect match for your ${this.mealPlan.planName}!)`
			);
		}
		return analysis;
	}

	calculateWeeklyTotal(weekIdentifier) {
		console.log("calculateWeeklyTotal called with:", weekIdentifier);

		let sundayId, wednesdayId;

		// Handle the new date-based identifier format
		if (
			typeof weekIdentifier === "string" &&
			weekIdentifier.match(/\d{4}-\d{2}-\d{2}/)
		) {
			console.log("Processing date-based identifier:", weekIdentifier);

			// Parse the date to determine if it's Sunday or Wednesday
			const parts = weekIdentifier.split("-");
			const year = parseInt(parts[0]);
			const month = parseInt(parts[1]) - 1; // Month is 0-indexed in Date
			const day = parseInt(parts[2]);

			const inputDate = new Date(year, month, day);
			const dayOfWeek = inputDate.getDay(); // 0 = Sunday, 3 = Wednesday

			console.log("Input date:", inputDate, "Day of week:", dayOfWeek);

			if (dayOfWeek === 0) {
				// Sunday
				sundayId = `sunday-${weekIdentifier}`;
				// Find Wednesday: 3 days later
				const wednesdayDate = new Date(inputDate);
				wednesdayDate.setDate(inputDate.getDate() + 3);
				const wednesdayYear = wednesdayDate.getFullYear();
				const wednesdayMonth = String(wednesdayDate.getMonth() + 1).padStart(2, "0");
				const wednesdayDay = String(wednesdayDate.getDate()).padStart(2, "0");
				wednesdayId = `wednesday-${wednesdayYear}-${wednesdayMonth}-${wednesdayDay}`;
			} else if (dayOfWeek === 3) {
				// Wednesday
				wednesdayId = `wednesday-${weekIdentifier}`;
				// Find Sunday: 3 days earlier
				const sundayDate = new Date(inputDate);
				sundayDate.setDate(inputDate.getDate() - 3);
				const sundayYear = sundayDate.getFullYear();
				const sundayMonth = String(sundayDate.getMonth() + 1).padStart(2, "0");
				const sundayDay = String(sundayDate.getDate()).padStart(2, "0");
				sundayId = `sunday-${sundayYear}-${sundayMonth}-${sundayDay}`;
			} else {
				// For other days, find the Sunday of that week
				const daysFromSunday = inputDate.getDay();
				const sundayDate = new Date(inputDate);
				sundayDate.setDate(inputDate.getDate() - daysFromSunday);

				const wednesdayDate = new Date(sundayDate);
				wednesdayDate.setDate(sundayDate.getDate() + 3);

				const sundayYear = sundayDate.getFullYear();
				const sundayMonth = String(sundayDate.getMonth() + 1).padStart(2, "0");
				const sundayDay = String(sundayDate.getDate()).padStart(2, "0");
				sundayId = `sunday-${sundayYear}-${sundayMonth}-${sundayDay}`;

				const wednesdayYear = wednesdayDate.getFullYear();
				const wednesdayMonth = String(wednesdayDate.getMonth() + 1).padStart(2, "0");
				const wednesdayDay = String(wednesdayDate.getDate()).padStart(2, "0");
				wednesdayId = `wednesday-${wednesdayYear}-${wednesdayMonth}-${wednesdayDay}`;
			}
		}

		console.log(`Calculated IDs - Sunday: ${sundayId}, Wednesday: ${wednesdayId}`);

		let sundayTotal = 0;
		let wednesdayTotal = 0;

		console.log(
			`Looking for saved data - Sunday: ${sundayId}, Wednesday: ${wednesdayId}`
		);
		console.log(
			"Available weeklySelections keys:",
			Object.keys(this.weeklySelections)
		);

		if (
			this.weeklySelections[sundayId] &&
			this.weeklySelections[sundayId].meals
		) {
			sundayTotal = this.weeklySelections[sundayId].meals.reduce(
				(sum, meal) => sum + meal.quantity,
				0
			);
			console.log(`Found Sunday data: ${sundayTotal} meals`);
		} else {
			console.log(`No Sunday data found for ${sundayId}`);
		}

		if (
			this.weeklySelections[wednesdayId] &&
			this.weeklySelections[wednesdayId].meals
		) {
			wednesdayTotal = this.weeklySelections[wednesdayId].meals.reduce(
				(sum, meal) => sum + meal.quantity,
				0
			);
			console.log(`Found Wednesday data: ${wednesdayTotal} meals`);
		} else {
			console.log(`No Wednesday data found for ${wednesdayId}`);
		}

		console.log(
			`Final totals - Sunday: ${sundayTotal}, Wednesday: ${wednesdayTotal}, Total: ${
				sundayTotal + wednesdayTotal
			}`
		);

		return {
			sunday: sundayTotal,
			wednesday: wednesdayTotal,
			total: sundayTotal + wednesdayTotal
		};
	}

	updateSavedMealBreakdown() {
		const breakdownEl = document.getElementById("saved-meal-breakdown");
		const sundayCountEl = document.getElementById("sunday-count");
		const wednesdayCountEl = document.getElementById("wednesday-count");
		const totalSavedEl = document.getElementById("total-saved-count");

		if (!breakdownEl || !sundayCountEl || !wednesdayCountEl || !totalSavedEl)
			return;

		// Count saved meals by day
		let sundayTotal = 0;
		let wednesdayTotal = 0;

		// Check all weeks for saved selections
		Object.keys(this.weeklySelections).forEach((weekId) => {
			const weekData = this.weeklySelections[weekId];
			if (weekData && weekData.meals) {
				const mealCount = weekData.meals.reduce(
					(sum, meal) => sum + meal.quantity,
					0
				);

				if (weekId.includes("sunday")) {
					sundayTotal += mealCount;
				} else if (weekId.includes("wednesday")) {
					wednesdayTotal += mealCount;
				}
			}
		});

		const totalSaved = sundayTotal + wednesdayTotal;

		// Update display
		sundayCountEl.textContent = sundayTotal;
		wednesdayCountEl.textContent = wednesdayTotal;
		totalSavedEl.textContent = totalSaved;

		// Show/hide breakdown based on whether there are saved meals
		if (totalSaved > 0) {
			breakdownEl.style.display = "block";
		} else {
			breakdownEl.style.display = "none";
		}
	}

	displayMealBreakdown(planAnalysis) {
		const totalSection = document.querySelector("[data-order-total]");
		if (!totalSection) return;

		// Remove existing breakdown if present
		const existingBreakdown = document.getElementById("meal-breakdown-display");
		if (existingBreakdown) {
			existingBreakdown.remove();
		}

		// Create breakdown display
		const breakdownHtml = `
			<div id="meal-breakdown-display" style="
				display: flex;
				justify-content: space-between;
				margin-top: 1rem;
				padding: 1rem;
				background: #f8f9fa;
				border-radius: 5px;
				font-size: 1.3rem;
			">
				<div style="text-align: left;">
					<strong>Sunday:</strong> ${planAnalysis.weekBreakdown.sunday} meals
				</div>
				<div style="text-align: right;">
					<strong>Wednesday:</strong> ${planAnalysis.weekBreakdown.wednesday} meals
				</div>
			</div>
		`;

		totalSection.insertAdjacentHTML('afterend', breakdownHtml);
	}

	renderPlanAnalysis(analysis, addOnCost) {
		let html = '<div class="plan-analysis">';

		// Check if no subscription
		if (analysis.noSubscription) {
			html += '<div class="plan-status">';
			html += '<h4 style="color: #856404;">No Active Subscription</h4>';
			html +=
				'<p style="color: #856404; font-size: 1.3rem;">Sign up for a meal plan or log in to start ordering</p>';
			html += "</div>";
			html += "</div>";
			return html;
		}

		html += '<div class="plan-status">';
		html += `<h4>Your ${this.mealPlan.planName}</h4>`;
		html += '<div class="weekly-breakdown">';
		html += `<div class="week-summary">`;
		html += `<span class="day-total">Sunday: ${analysis.weekBreakdown.sunday} meals</span>`;
		html += `<span class="day-total">Wednesday: ${analysis.weekBreakdown.wednesday} meals</span>`;
		html += `<span class="week-total"><strong>Week Total: ${analysis.weeklyTotal} meals</strong></span>`;
		html += `</div>`;
		html += "</div>";
		html += "</div>";

		html += "</div>";
		return html;
	}

	// SAVE BUTTON RENDERING
	renderSaveButtons(
		totalMeals,
		hasExisting,
		planAnalysis,
		hasProteinBalls = false
	) {
		const saveBtn = document.querySelector("[data-save-order]");
		if (!saveBtn) {
			console.error("Save button not found!");
			return;
		}

		const buttonContainer = saveBtn.parentElement;

		// Remove any existing add button
		const existingAddBtn = buttonContainer.querySelector("[data-add-to-meals]");
		if (existingAddBtn) {
			existingAddBtn.remove();
		}

		// Check if user has no subscription
		if (!this.mealPlan) {
			this.renderNoSubscriptionButtons(saveBtn);
			return;
		}

		// Don't show any buttons for past deadline days
		if (this.selectedWeek && this.selectedWeek.isDeadlinePassed) {
			saveBtn.style.display = "none";
			return;
		}

		// Check if we have any selection (meals OR protein balls)
		const hasAnySelection = totalMeals > 0 || hasProteinBalls;

		if (!hasAnySelection) {
			this.renderEmptySaveButton(saveBtn);
			return;
		}

		// Check if button should be enabled
		const belowMinimum =
			totalMeals < this.planPricing.minimumOrderWarning && totalMeals > 0;
		const canSave = !planAnalysis.blockSave && (!belowMinimum || hasExisting);

		// Update button state
		saveBtn.style.display = "block";
		saveBtn.disabled = !canSave;

		if (!canSave) {
			if (planAnalysis.blockSave) {
				saveBtn.textContent = "⚠️ " + planAnalysis.blockReason;
			} else if (belowMinimum && !hasExisting) {
				const needed = this.planPricing.minimumOrderWarning - totalMeals;
				saveBtn.textContent = `⚠️ Add ${needed} more meal${
					needed === 1 ? "" : "s"
				} (minimum 4 required)`;
			}
		} else {
			if (totalMeals === 0 && hasProteinBalls) {
				saveBtn.textContent = "💾 Save Protein Ball Selection";
			} else {
				saveBtn.textContent = "💾 Save My Weekly Selection";
			}
		}

		// Show "Add to Meals" button for existing selections
		if (
			hasExisting &&
			!planAnalysis.blockSave &&
			hasAnySelection &&
			!this.selectedWeek.isDeadlinePassed
		) {
			this.renderAddToMealsButton(saveBtn, totalMeals, hasProteinBalls);
		}
	}

	renderPlanAnalysisAfterButton(planAnalysis) {
		const saveBtn = document.querySelector("[data-save-order]");
		const buttonContainer = saveBtn.parentElement;

		const existingAnalysis = buttonContainer.querySelector(
			".plan-analysis-after-button"
		);
		if (existingAnalysis) {
			existingAnalysis.remove();
		}

		if (!planAnalysis || planAnalysis.noSubscription) {
			return;
		}

		const selectedWeek = this.selectedWeek;
		if (!selectedWeek) return;

		// Get the week identifier from the selected week
		const weekId = selectedWeek.id; // e.g., "monday-2025-09-15"
		const parts = weekId.split("-");
		if (parts.length !== 4) return;

		const baseDate = `${parts[1]}-${parts[2]}-${parts[3]}`;

		// Build the Sunday and Wednesday IDs for this week
		let sundayId, wednesdayId;

		if (parts[0] === "sunday") {
			sundayId = weekId; // Already the Sunday ID
			// Calculate Wednesday (3 days later)
			const date = new Date(baseDate);
			date.setDate(date.getDate() + 3);
			const wednesdayDate = date.toISOString().split("T")[0];
			wednesdayId = `wednesday-${wednesdayDate}`;
		} else if (parts[0] === "wednesday") {
			wednesdayId = weekId; // Already the Wednesday ID
			// Calculate Sunday (3 days earlier)
			const date = new Date(baseDate);
			date.setDate(date.getDate() - 3);
			const sundayDate = date.toISOString().split("T")[0];
			sundayId = `sunday-${sundayDate}`;
		}

		// Count actual saved meals
		let sundayTotal = 0;
		let wednesdayTotal = 0;

		if (
			this.weeklySelections[sundayId] &&
			this.weeklySelections[sundayId].meals
		) {
			sundayTotal = this.weeklySelections[sundayId].meals.reduce(
				(sum, meal) => sum + meal.quantity,
				0
			);
		}

		if (
			this.weeklySelections[wednesdayId] &&
			this.weeklySelections[wednesdayId].meals
		) {
			wednesdayTotal = this.weeklySelections[wednesdayId].meals.reduce(
				(sum, meal) => sum + meal.quantity,
				0
			);
		}

		console.log(
			`Calculated totals - Sunday (${sundayId}): ${sundayTotal}, Wednesday (${wednesdayId}): ${wednesdayTotal}`
		);

		// Create the analysis HTML
		let html = '<div class="plan-analysis-after-button saved-meal-breakdown">';
		html += "<h4>Saved Meal Summary</h4>";
		html += '<div class="week-summary">';
		html += `<span class="day-total">Sunday: ${sundayTotal} meals</span>`;
		html += `<span class="day-total">Wednesday: ${wednesdayTotal} meals</span>`;
		html += `<span class="week-total"><strong>Total Saved: ${
			sundayTotal + wednesdayTotal
		} meals</strong></span>`;
		html += "</div>";
		html += "</div>";

		// Insert after save button
		const analysisDiv = document.createElement("div");
		analysisDiv.innerHTML = html;
		buttonContainer.appendChild(analysisDiv.firstElementChild);
	}

	renderNoSubscriptionButtons(saveBtn) {
		// Disable and gray out save button
		saveBtn.style.display = "block";
		saveBtn.disabled = true;
		saveBtn.textContent = "💾 Save My Weekly Selection";
		saveBtn.style.opacity = "0.5";

		// Create container for message and signup button
		const container = document.createElement("div");
		container.className = "no-subscription-container";
		container.style.cssText = `
			text-align: center;
			margin-top: 1.5rem;
			padding: 1.5rem;
			background: #fff3cd;
			border: 2px solid #ffeaa7;
			border-radius: 8px;`;

		// Add message
		const message = document.createElement("p");
		message.style.cssText = `
			color: #856404;
			font-size: 1.4rem;
			margin-bottom: 1.5rem;
			font-weight: 500;`;
		message.textContent = "You need an active meal plan to order";

		// Add signup button
		const signupBtn = document.createElement("a");
		signupBtn.href = "https://www.primalbalancenutrition.com/pages/subscribe";
		signupBtn.className = "button button--primary";

		signupBtn.textContent = "View Meal Plans";

		// Add hover effect
		signupBtn.onmouseover = function () {
			this.style.transform = "translateY(-2px)";
			this.style.boxShadow = "0 0.5rem 1.5rem rgba(61, 8, 27, 0.3)";
		};
		signupBtn.onmouseout = function () {
			this.style.transform = "translateY(0)";
			this.style.boxShadow = "none";
		};

		container.appendChild(message);
		container.appendChild(signupBtn);

		// Insert after save button
		saveBtn.parentElement.appendChild(container);
	}

	renderEmptySaveButton(saveBtn) {
		saveBtn.style.display = "block";
		saveBtn.disabled = true;
		saveBtn.textContent = "💾 Save My Weekly Selection";
	}

	renderActiveSaveButton(
		saveBtn,
		totalMeals,
		planAnalysis,
		hasProteinBalls = false
	) {
		saveBtn.style.display = "block";

		// Check minimum order requirement for initial save
		const hasExistingSave = this.hasExistingSelection(this.selectedWeek.id);
		const belowMinimum =
			totalMeals < this.planPricing.minimumOrderWarning && totalMeals > 0;

		const canSave = !planAnalysis.blockSave && (!belowMinimum || hasExistingSave);
		saveBtn.disabled = !canSave;

		if (!canSave) {
			if (planAnalysis.blockSave) {
				saveBtn.textContent = "⚠️ " + planAnalysis.blockReason;
			} else if (belowMinimum && !hasExistingSave) {
				const needed = this.planPricing.minimumOrderWarning - totalMeals;
				saveBtn.textContent = `⚠️ Add ${needed} more meal${
					needed === 1 ? "" : "s"
				} (minimum 4 required)`;
			}
		} else {
			if (totalMeals === 0 && hasProteinBalls) {
				// Only protein balls selected
				saveBtn.textContent = "💾 Save Protein Ball Selection";
			} else if (
				totalMeals < this.planPricing.minimumOrderWarning &&
				hasExistingSave
			) {
				saveBtn.textContent = `💾 Save Selection (${totalMeals} meal${
					totalMeals > 1 ? "s" : ""
				})`;
			} else {
				saveBtn.textContent = "💾 Save My Weekly Selection";
			}
		}
	}

	renderAddToMealsButton(saveBtn, totalMeals, hasProteinBalls = false) {
		const addBtn = document.createElement("button");
		addBtn.type = "button";
		addBtn.className = "button button--secondary";
		addBtn.setAttribute("data-add-to-meals", "");
		addBtn.style.marginTop = "1rem";
		addBtn.style.display = "block";
		addBtn.style.margin = "1rem auto 0 auto";

		if (totalMeals === 0 && hasProteinBalls) {
			addBtn.textContent = "➕ Add Protein Balls to Existing Selection";
		} else if (totalMeals > 0 && hasProteinBalls) {
			addBtn.textContent = `➕ Add ${totalMeals} Meal${
				totalMeals > 1 ? "s" : ""
			} + Protein Balls to Existing Selection`;
		} else {
			addBtn.textContent = `➕ Add ${totalMeals} Meal${
				totalMeals > 1 ? "s" : ""
			} to Existing Selection`;
		}

		addBtn.addEventListener("click", async () => {
			await this.addToExistingMeals();
		});

		saveBtn.insertAdjacentElement("afterend", addBtn);
	}

	async saveWeeklyOrder(isAddition = false) {
		console.log(`=== SAVE WEEKLY ORDER START (${isAddition ? 'ADDITION' : 'REPLACEMENT'}) ===`);

		// Check for subscription first
		if (!this.mealPlan) {
			alert(
				"You need an active meal plan to save and order meals.\n\nPlease sign up for a subscription at primalbalancenutrition.com/pages/subscribe"
			);
			return;
		}

		const weekId = this.selectedWeek.id;
		const selectedMeals = this.mealQuantities[weekId];

		// UPDATED - supports multiple protein ball types
		const proteinBallMeals = (this.weeklyMenus[weekId] || [])
			.filter(m => this.isProteinBallMeal(m.id));
		const hasProteinBalls = proteinBallMeals.some(m => {
			const sel = this.proteinBallSelections[weekId]?.[m.id];
			return sel && sel !== "none";
		});

		const hasMeals =
			selectedMeals && Object.values(selectedMeals).some((qty) => qty > 0);

		if (!hasMeals && !hasProteinBalls) {
			alert(
				"Please select at least one meal or protein ball option before saving."
			);
			return;
		}

		// THURSDAY RESTRICTION CHECK
		if (
			weekId.includes("wednesday") &&
			this.isRestrictedPlan() &&
			!this.hasVIPTag() &&
			!this.hasWednesdayOnlyTag()
		) {
			const parts = weekId.split("-");
			const baseDate = `${parts[1]}-${parts[2]}-${parts[3]}`;
			const thursdayCheck = this.canSaveWednesday(baseDate);

			if (!thursdayCheck.allowed) {
				alert(thursdayCheck.detailedReason);
				return;
			}
		}

		const totalMeals = hasMeals
			? Object.values(selectedMeals).reduce((sum, qty) => sum + qty, 0)
			: 0;

		// Validation
		const validationResult = this.validateSubscriptionRequirements(
			weekId,
			totalMeals
		);
		if (!validationResult.canSave) {
			alert(validationResult.message);
			return;
		}

		const planAnalysis = this.analyzeMealPlan(totalMeals, weekId);

		// Check minimum order requirement
		const hasExistingSave = this.hasExistingSelection(weekId);
		if (
			!hasExistingSave &&
			totalMeals < this.planPricing.minimumOrderWarning &&
			totalMeals > 0 &&
			!this.hasVIPTag()
		) {
			alert(
				`Cannot save: Minimum 4 meals required for initial order.\n\nYou currently have ${totalMeals} meal${
					totalMeals === 1 ? "" : "s"
				} selected.\n\nPlease add ${3 - totalMeals} more meal${
					3 - totalMeals === 1 ? "" : "s"
				} to continue.`
			);
			return;
		}

		if (planAnalysis.blockSave) {
			alert(`Cannot save: ${planAnalysis.blockReason}`);
			return;
		}

		// Build confirmation message
		const parts = weekId.split("-");
		const baseDate = `${parts[1]}-${parts[2]}-${parts[3]}`;
		const weeklyTotal = this.calculateWeeklyTotal(baseDate);

		let projectedSunday = weeklyTotal.sunday;
		let projectedWednesday = weeklyTotal.wednesday;

		if (weekId.includes("sunday")) {
			projectedSunday = totalMeals;
		} else if (weekId.includes("wednesday")) {
			projectedWednesday = totalMeals;
		}

		const projectedWeeklyTotal = projectedSunday + projectedWednesday;

		// Build confirmation message
		let confirmMessage = "";
		if (this.hasVIPTag()) {
			confirmMessage =
				`✨ VIP Order Summary ✨\n\n` +
				`Total meals selected: ${totalMeals}\n` +
				`Week Total: ${projectedWeeklyTotal} meals\n` +
				`• Sunday: ${projectedSunday} meals\n` +
				`• Wednesday: ${projectedWednesday} meals\n`;
		} else if (totalMeals === 0 && hasProteinBalls) {
			confirmMessage = `You've selected only protein balls for ${this.selectedWeek.display}.\n\nContinue saving this selection?`;
		} else {
			confirmMessage =
				`📋 MEAL SELECTION SUMMARY\n\n` +
				`Your Subscription: ${this.mealPlan.planName}\n` +
				`Your Week Total: ${projectedWeeklyTotal} meals\n` +
				`• Sunday: ${projectedSunday} meals\n` +
				`• Wednesday: ${projectedWednesday} meals\n\n` +
				`Would you like to continue saving this selection?`;
		}

		// Add protein ball info if applicable
		if (hasProteinBalls) {
			proteinBallMeals.forEach(meal => {
				const sel = this.proteinBallSelections[weekId]?.[meal.id];
				if (!sel || sel === "none") return;
				const option = meal.options?.[sel];
				if (!option) return;
				confirmMessage += `\n+ ${meal.name}: ${option.label} ($${option.price.toFixed(2)})`;
			});
		}

		
		// Add addition/replacement context
		if (isAddition) {
			confirmMessage = `➕ ADD TO EXISTING SELECTION\n\n${confirmMessage}\n\nThese meals will be ADDED to your existing order.`;
		}

		const confirmed = confirm(confirmMessage);
		if (!confirmed) return;

		// GET BUTTON REFERENCES BEFORE DISABLING
		const saveBtn = document.querySelector("[data-save-order]");
		const addBtn = document.querySelector("[data-add-to-meals]");

		if (!saveBtn) {
			console.error("Save button not found!");
			alert("Error: Save button not found. Please refresh the page.");
			return;
		}

		// Store original button states
		const originalSaveText = saveBtn.textContent;
		const originalSaveDisabled = saveBtn.disabled;
		const originalAddText = addBtn ? addBtn.textContent : "";
		const originalAddDisabled = addBtn ? addBtn.disabled : false;

		try {
			// Disable buttons
			saveBtn.textContent = "💾 Saving...";
			saveBtn.disabled = true;

			if (addBtn) {
				addBtn.textContent = "➕ Please Wait...";
				addBtn.disabled = true;
			}

			this.syncStatus.showSyncing();

			const saveId = `save_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
			const orderData = this.buildOrderData(weekId, selectedMeals, saveId);
			orderData.isReplacement = !isAddition;  
			orderData.isAddition = isAddition;       
			orderData.deadlineTime = this.calculateDeadline(weekId);

			let localStorageSuccess = false;
			let railwaySuccess = false;
			let googleSheetsSuccess = false;

			// 1. Save to localStorage first (instant)
			try {
				localStorageSuccess = await this.saveToLocalStorage(orderData);
				console.log("✅ localStorage save:", localStorageSuccess ? "SUCCESS" : "FAILED");
			} catch (localError) {
				console.error("❌ localStorage error:", localError);
			}

			// 2. Save to Railway (primary cloud storage)
			try {
				const railwayResult = await this.railwayAPI.saveSelection(orderData);
				if (railwayResult.success) {
					railwaySuccess = true;
					console.log("✅ Railway save: SUCCESS");
					this.syncStatus.showSuccess(
						isAddition ? "Meals added to order!" : "Meals saved to cloud!"
					);
				} else {
					throw new Error("Railway save failed");
				}
			} catch (railwayError) {
				console.error("❌ Railway error:", railwayError);
				this.syncStatus.showOffline();
			}

			// 3. Save to Google Sheets (backup)
			try {
				const sheetsResult = await this.saveToGoogleSheetsClean(orderData);
				if (sheetsResult.success) {
					googleSheetsSuccess = true;
					console.log("✅ Google Sheets backup: SUCCESS");
				}
			} catch (sheetsError) {
				console.error("❌ Google Sheets error:", sheetsError);
			}

			// Update local state if at least one cloud save succeeded
			if (localStorageSuccess && (railwaySuccess || googleSheetsSuccess)) {
				this.updateLocalState(weekId, orderData);

				if (this.customerPortal) {
					this.customerPortal.loadPortalData();
				}

				this.handleSuccessfulSave(totalMeals, true);
				
				// Show which systems saved successfully
				let saveMessage = "Saved to: ";
				if (railwaySuccess) saveMessage += "Railway ✓ ";
				if (googleSheetsSuccess) saveMessage += "Sheets ✓";
				console.log(saveMessage);
				
			} else {
				throw new Error("All save operations failed");
			}
		} catch (error) {
			console.error("❌ Save error:", error);
			this.syncStatus.showError("Save failed");
			alert("Error saving your meal selection. Please try again.");
		} finally {
			// Always re-enable buttons
			if (saveBtn) {
				saveBtn.textContent = originalSaveText;
				saveBtn.disabled = originalSaveDisabled;
			}
			if (addBtn) {
				addBtn.textContent = originalAddText;
				addBtn.disabled = originalAddDisabled;
			}
			
			setTimeout(() => {
				this.updateOrderSummary();
			}, 100);
		}
	}

	async clearAllSelections() {
		const weekId = this.selectedWeek?.id;
		if (!weekId) {
			alert('Please select a week first');
			return;
		}
		
		const weekInfo = this.getWeekInfo(weekId);
		const displayDate = weekInfo.display;
		
		const confirmed = confirm(
			`⚠️ This will permanently delete your saved meal selections for ${displayDate}.\n\n` +
			`This cannot be undone. Continue?`
		);
		
		if (!confirmed) {
			return;
		}
		
		const clearBtn = document.querySelector('[data-clear-selections]');
		
		try {
			if (clearBtn) {
				clearBtn.disabled = true;
				clearBtn.textContent = 'Clearing...';
			}
			
			this.syncStatus.showSyncing();
			
			console.log(`🗑️ Clearing selections for ${weekId}`);
			
			// Delete from Railway
			const railwayResult = await this.railwayAPI.deleteSelection(this.customer.id, weekId);
			
			if (railwayResult.success) {
				console.log('✅ Railway delete successful');
				
				// Also try to delete from Google Sheets backup
				try {
					await this.googleSheets.deleteSelections(this.customer.id, weekId);
					console.log('✅ Google Sheets backup deleted');
				} catch (sheetsError) {
					console.warn('⚠️ Google Sheets delete failed (Railway deleted successfully):', sheetsError);
				}
				
				// Clear from frontend
				delete this.weeklySelections[weekId];
				delete this.mealQuantities[weekId];
				delete this.mealOptions[weekId];
				delete this.proteinBallSelections[weekId];
				
				// Clear from localStorage
				await this.saveToLocalStorage();
				
				// Refresh display
				this.showMealSelection();
				
				this.syncStatus.showSuccess("Selections cleared!");
				alert(`✅ Your meal selections for ${displayDate} have been deleted.`);
				
			} else {
				throw new Error(railwayResult.error || 'Failed to delete selections');
			}
			
		} catch (error) {
			console.error('❌ Clear error:', error);
			this.syncStatus.showError("Clear failed");
			alert('❌ Failed to delete selections. Please try again.');
		} finally {
			if (clearBtn) {
				clearBtn.disabled = false;
				clearBtn.textContent = 'Clear Selections';
			}
		}
	}

	validateSubscriptionRequirements(weekId, totalMeals) {
		if (!this.mealPlan) {
			return {
				canSave: false,
				message: "You need an active meal subscription to save meals."
			};
		}

		// VIP and Special tag users have full freedom
		if (this.mealPlan.isVIP || this.mealPlan.hasSpecialTag) {
			if (totalMeals < 3) {
				return {
					canSave: false,
					message: `Minimum ${this.planPricing.minimumOrderWarning} meals required for any delivery day.\n\nYou currently have ${totalMeals} meal${totalMeals === 1 ? "" : "s"} selected.`
				};
			}
			return { canSave: true };
		}

		// **NEW: Thursday-only customers get special handling**
		if (this.hasWednesdayOnlyTag()) {
			// Wednesday-only customers must meet their subscription minimum on Wednesday
			if (weekId.includes("wednesday")) {
				if (totalMeals < this.mealPlan.mealsPerWeek) {
					const needed = this.mealPlan.mealsPerWeek - totalMeals;
					return {
						canSave: false,
						message: `Your ${this.mealPlan.planName} requires ${
							this.mealPlan.mealsPerWeek
						} meals.\n\nYou currently have ${totalMeals} meal${
							totalMeals === 1 ? "" : "s"
						} selected.\n\nPlease add ${needed} more meal${
							needed === 1 ? "" : "s"
						} to continue.`
					};
				}
			}
			// Thursday-only customers shouldn't see Monday, but just in case
			if (weekId.includes("sunday")) {
				return {
					canSave: false,
					message:
						"Your account is set up for Wednesday deliveries only. Please select Wednesday meals."
				};
			}
			return { canSave: true };
		}

		// Get current meal counts
		const parts = weekId.split("-");
		const baseDate = `${parts[1]}-${parts[2]}-${parts[3]}`;
		const savedTotals = this.calculateWeeklyTotal(baseDate);

		// For this validation, we only care about saved data (not working selections)
		const currentSunday = savedTotals.sunday;
		const currentWednesday = savedTotals.wednesday;

		// Calculate projected totals after this save
		let projectedSunday = currentSunday;
		let projectedWednesday = currentWednesday;

		if (weekId.includes("sunday")) {
			projectedSunday = totalMeals;
		} else if (weekId.includes("wednesday")) {
			projectedWednesday = totalMeals;
		}

		const projectedTotal = projectedSunday + projectedWednesday;

		console.log(`Validation check:
        Plan: ${this.mealPlan.planName} (${this.mealPlan.mealsPerWeek} meals)
        Current: Sunday=${currentSunday}, Wednesday=${currentWednesday}
        Saving ${totalMeals} to ${weekId}
        Projected: Sunday=${projectedSunday}, Wednesday=${projectedWednesday}, Total=${projectedTotal}`);

		// RULE 1: Plans of 8 meals or less - Sunday must match subscription exactly
		if (this.mealPlan.mealsPerWeek <= 8) {
			console.log("=== 8 MEAL OR LESS PLAN VALIDATION ===");
			console.log("Plan meals per week:", this.mealPlan.mealsPerWeek);
			console.log("Current Sunday total:", currentSunday);

			if (weekId.includes("sunday")) {
				if (totalMeals < this.mealPlan.mealsPerWeek) {
					const needed = this.mealPlan.mealsPerWeek - totalMeals;
					return {
						canSave: false,
						message: `Your ${this.mealPlan.planName} requires at least ${
							this.mealPlan.mealsPerWeek
						} meals from Sunday.\n\nYou currently have ${totalMeals} meal${
							totalMeals === 1 ? "" : "s"
						} selected.\n\nPlease add ${needed} more meal${
							needed === 1 ? "" : "s"
						} to continue.`
					};
				}
			} else if (weekId.includes("wednesday")) {
				if (currentSunday < this.mealPlan.mealsPerWeek) {
					return {
						canSave: false,
						message: `Your ${this.mealPlan.planName} requires ${
							this.mealPlan.mealsPerWeek
						} meals from Sunday before adding Wednesday meals.\n\nSunday currently has: ${currentSunday} meals\nYou need: ${
							this.mealPlan.mealsPerWeek - currentSunday
						} more meals from Sunday first.\n\nWednesday meals are available as add-ons after meeting your Sunday requirement.`
					};
				}
			}
			return { canSave: true };
		}

		// RULE 2: Plans of 10+ meals
		if (this.mealPlan.mealsPerWeek >= 10) {
			if (totalMeals < 3) {
				return {
					canSave: false,
					message: `Minimum ${this.planPricing.minimumOrderWarning} meals required for any delivery day.\n\nYou currently have ${totalMeals} meal${
    					totalMeals === 1 ? "" : "s"
					} selected.`
				};
			}

			const otherDayMeals = weekId.includes("sunday")
				? currentWednesday
				: currentSunday;

			if (otherDayMeals > 0 && projectedTotal < this.mealPlan.mealsPerWeek) {
				const needed = this.mealPlan.mealsPerWeek - projectedTotal;
				return {
					canSave: false,
					message: `Your ${this.mealPlan.planName} requires ${
						this.mealPlan.mealsPerWeek
					} meals total when ordering from both days.\n\nCurrent week total would be: ${projectedTotal} meals\n• Sunday: ${projectedSunday} meals\n• Wednesday: ${projectedWednesday} meals\n\nYou need ${needed} more meal${
						needed > 1 ? "s" : ""
					} to meet your subscription requirement.`
				};
			}
		}

		return { canSave: true };
	}

	calculateDeadline(weekId) {
		// Parse weekId: "sunday-2026-01-05" or "wednesday-2026-01-08"
		const parts = weekId.split('-');
		if (parts.length === 4) {
			const year = parseInt(parts[1]);
			const month = parseInt(parts[2]) - 1; // JS months are 0-indexed
			const day = parseInt(parts[3]);
			
			// Delivery date
			const deliveryDate = new Date(year, month, day);
			
			// Deadline is always Tuesday before at 4 PM
			const deadline = new Date(deliveryDate);
			deadline.setDate(deliveryDate.getDate() - (deliveryDate.getDay() === 0 ? 5 : 8)); // Sunday: -5 days, Wednesday: -8 days
			deadline.setHours(16, 0, 0, 0); // 4 PM
			
			return deadline.toISOString();
		}
		
		// Fallback
		return new Date().toISOString();
	}

	buildOrderData(weekId, selectedMeals, saveId) {
		console.log("🏗️ === BUILDING ORDER DATA ===");
		console.log("🏗️ Week ID:", weekId);
		console.log("🏗️ Selected meals from UI:", selectedMeals);

		// Derive delivery day from weekId
		const deliveryDay = weekId.startsWith('sunday') ? 'Sunday' : 'Wednesday';

		const orderData = {
			customerId: this.customer.id,
			customerEmail: this.customer.email,
			customerName: this.customer.name.trim(),
			weekId: weekId,
			deliveryDay: deliveryDay, 
			deliveryDate: this.selectedWeek.deliveryDate.toISOString(),
			deliveryDisplay: this.selectedWeek.display,
			submissionTime: new Date().toISOString(),
			meals: [],
			proteinBalls: null,
			saveAttemptId: saveId
		};

		const meals = this.weeklyMenus[weekId] || [];
		console.log(
			"🏗️ Menu for this week has",
			meals.length,
			"meals with IDs:",
			meals.map((m) => m.id)
		);

		// Build regular meals array (excluding protein balls)
		for (const [mealId, quantity] of Object.entries(selectedMeals)) {
			if (quantity > 0 && !this.isProteinBallMeal(mealId)) {
				const meal = meals.find((m) => m.id === mealId);
				if (meal) {
					console.log("🏗️ Adding meal:", meal.id, meal.name, "qty:", quantity);
					const selectedOptions =
						(this.mealOptions[weekId] && this.mealOptions[weekId][mealId]) || {};

					let totalAddOnCost = 0;
					const optionDetails = {};

					if (meal.options) {
						Object.entries(selectedOptions).forEach(([optionKey, isSelected]) => {
							if (isSelected && meal.options[optionKey]) {
								const option = meal.options[optionKey];
								optionDetails[optionKey] = {
									label: option.label,
									price: option.price || 0,
									isSelected: true,
									type: option.type || 'addon',  
									value: option.label  
								};
								totalAddOnCost += (option.price || 0) * quantity;
							}
						});
					}

					orderData.meals.push({
						id: meal.id,
						name: meal.name.replace(/<[^>]*>/g, '').trim(),  
						description: meal.description,
						quantity: quantity,
						imageUrl: meal.image || "",  
						shopifyHandle: meal.shopifyHandle,
						selectedOptions: selectedOptions,
						optionDetails: optionDetails,
						totalAddOnCost: totalAddOnCost
					});
				}
			}
		}

		// Add protein ball selections - supports multiple protein ball types
		const proteinBallMeals = meals.filter(m => this.isProteinBallMeal(m.id));
		const proteinBallsData = [];

		proteinBallMeals.forEach(meal => {
			const sel = this.proteinBallSelections?.[weekId]?.[meal.id];
			if (!sel || sel === "none") return;
			if (!meal.options?.[sel]) return;
			const selectedOption = meal.options[sel];
			proteinBallsData.push({
				id: meal.id,
				name: meal.name,
				selectedOption: sel,
				optionLabel: selectedOption.label,
				price: selectedOption.price || 0,
				shopifyHandle: meal.shopifyHandle
			});
		});

		// Keep backwards compatible single proteinBalls field, store all in proteinBallsArray
		if (proteinBallsData.length > 0) {
			orderData.proteinBalls = proteinBallsData[0];
			orderData.proteinBallsArray = proteinBallsData;
		}
		
		console.log(
			"🏗️ Final orderData.meals:",
			orderData.meals.map((m) => ({ id: m.id, name: m.name }))
		);
		return orderData;
	}

	async saveToLocalStorage(orderData) {
		try {
			console.log("💾 === SAVING TO LOCALSTORAGE ===");
			console.log("💾 Week ID:", orderData.weekId);
			
			const storageKey = `meal_selections_${this.customer.id}`;
			let existingData = {};

			const existing = localStorage.getItem(storageKey);
			if (existing) {
				try {
					existingData = JSON.parse(existing);
				} catch (e) {
					console.warn("Could not parse existing data");
				}
			}

			// Build the selection data matching Railway's format
			const selectionData = {
				weekId: orderData.weekId,
				deliveryDate: orderData.deliveryDate,
				deliveryDay: orderData.deliveryDay,  // ✅ Added
				deliveryDisplay: orderData.deliveryDisplay,
				submissionTime: orderData.submissionTime,
				deadlineTime: orderData.deadlineTime || this.calculateDeadline(orderData.weekId),
				isAddition: orderData.isAddition || false,
				isReplacement: orderData.isReplacement || false,  // ✅ Added
				mealCount: orderData.meals.reduce((sum, m) => sum + m.quantity, 0),
				meals: orderData.meals.map(meal => ({  // ✅ Fixed: no nested "meals.meals"
					id: meal.id,
					name: meal.name,
					description: meal.description,
					imageUrl: meal.imageUrl || meal.image,  // ✅ Added imageUrl
					quantity: meal.quantity,
					shopifyHandle: meal.shopifyHandle,
					selectedOptions: meal.selectedOptions || {},
					optionDetails: meal.optionDetails || {},
					totalAddOnCost: meal.totalAddOnCost || 0
				})),
				proteinBalls: orderData.proteinBalls || null,
				savedAt: new Date().toISOString()
			};

			existingData[orderData.weekId] = selectionData;
			existingData.dataVersion = this.dataVersion;
			existingData.lastUpdated = new Date().toISOString();
			existingData.customerInfo = {
				id: this.customer.id,
				name: this.customer.name,
				email: this.customer.email
			};

			localStorage.setItem(storageKey, JSON.stringify(existingData));

			console.log(`✅ Saved to localStorage for ${orderData.weekId}`);
			return true;
		} catch (error) {
			console.error("❌ localStorage save failed:", error);
			return false;
		}
	}
	async manualRefresh() {
		console.log("🔄 Manual refresh requested...");

		// Force sync from cloud
		await this.syncFromCloud();

		// Refresh UI
		this.renderWeeks();
		if (this.selectedWeek) {
			this.showMealSelection();
		}
		if (this.customerPortal) {
			this.customerPortal.loadPortalData();
		}

		console.log("✅ Manual refresh complete");
	}

	handlePageVisibilityChange() {
		if (!document.hidden) {
			// Page became visible again
			console.log("📄 Page became visible");

			// DON'T clear if we're viewing a past deadline week with selections
			if (this.selectedWeek && this.selectedWeek.isDeadlinePassed) {
				const hasSelection = this.hasExistingSelection(this.selectedWeek.id);
				if (hasSelection) {
					console.log("📄 Viewing past deadline with selection - NOT clearing data");
					return; // Don't clear anything
				}
			}

			// Otherwise, clear working selections
			console.log("📄 Clearing working selections");
			this.clearAllWorkingSelections();

			// If a week is selected, refresh its display
			if (this.selectedWeek) {
				setTimeout(() => {
					this.showMealSelection();
				}, 100);
			}
		}
	}

	handleStorageQuotaExceeded() {
		alert("Storage limit reached. Old meal selections will be cleaned up.");

		// Clean up old selections (keep only last 8 weeks)
		const storageKey = `meal_selections_${this.customer.id}`;
		const data = JSON.parse(localStorage.getItem(storageKey) || "{}");

		const weekIds = Object.keys(data).filter(
			(k) => k !== "lastUpdated" && k !== "customerInfo" && k !== "dataVersion"
		);

		// Sort by date
		weekIds.sort((a, b) => {
			const dateA = data[a].savedAt || data[a].submissionTime;
			const dateB = data[b].savedAt || data[b].submissionTime;
			return new Date(dateB) - new Date(dateA);
		});

		// Keep only last 8 weeks
		const toKeep = weekIds.slice(0, 8);
		const cleanData = {
			dataVersion: this.dataVersion,
			lastUpdated: new Date().toISOString(),
			customerInfo: data.customerInfo
		};

		toKeep.forEach((weekId) => {
			cleanData[weekId] = data[weekId];
		});

		localStorage.setItem(storageKey, JSON.stringify(cleanData));

		this.syncLogger.log("storage_quota_exceeded", {
			originalCount: weekIds.length,
			keptCount: toKeep.length,
			removedCount: weekIds.length - toKeep.length
		});
	}

	async saveToGoogleSheetsClean(orderData) {
		return new Promise((resolve) => {
			try {
				console.log(`📊 Saving to Google Sheets via form submission:`, orderData);

				const form = document.createElement("form");
				form.method = "POST";
				form.action = this.googleSheets.webAppUrl;
				form.target = "meal_iframe_" + Date.now();
				form.style.display = "none";

				const actionField = document.createElement("input");
				actionField.type = "hidden";
				actionField.name = "action";
				actionField.value = "saveOrder";
				form.appendChild(actionField);

				const dataField = document.createElement("input");
				dataField.type = "hidden";
				dataField.name = "data";
				dataField.value = JSON.stringify(orderData);
				form.appendChild(dataField);

				// Create iframe
				const iframe = document.createElement("iframe");
				iframe.name = form.target;
				iframe.style.display = "none";
				document.body.appendChild(iframe);
				document.body.appendChild(form);

				// Submit
				form.submit();

				// Cleanup and resolve
				setTimeout(() => {
					if (document.body.contains(form)) document.body.removeChild(form);
					if (document.body.contains(iframe)) document.body.removeChild(iframe);
					resolve({ success: true });
				}, 2000);

				console.log("✅ Meal order form submitted");
			} catch (error) {
				console.error("❌ Form submission failed:", error);
				resolve({ success: false, error: error.message });
			}
		});
	}

	async fallbackFormSubmissionClean(orderData) {
		return new Promise((resolve) => {
			try {
				console.log("📝 Using form submission fallback");

				// Create form
				const form = document.createElement("form");
				form.method = "POST";
				form.action = this.googleSheets.webAppUrl;
				form.target = "hidden_iframe_" + Date.now(); // Unique iframe name
				form.style.display = "none";

				// Add data fields
				const actionField = document.createElement("input");
				actionField.type = "hidden";
				actionField.name = "action";
				actionField.value = "saveOrder";
				form.appendChild(actionField);

				const dataField = document.createElement("input");
				dataField.type = "hidden";
				dataField.name = "data";
				dataField.value = JSON.stringify(orderData);
				form.appendChild(dataField);

				// Create unique iframe
				const iframe = document.createElement("iframe");
				iframe.name = form.target;
				iframe.style.display = "none";
				iframe.style.width = "0";
				iframe.style.height = "0";
				iframe.style.border = "none";

				// Handle iframe load (success or failure)
				let resolved = false;
				const resolveOnce = (result) => {
					if (!resolved) {
						resolved = true;
						// Cleanup
						if (document.body.contains(form)) document.body.removeChild(form);
						if (document.body.contains(iframe)) document.body.removeChild(iframe);
						resolve(result);
					}
				};

				iframe.onload = () => {
					console.log("✅ Form submission completed");
					resolveOnce({ success: true });
				};

				iframe.onerror = (error) => {
					console.log("❌ Form submission failed:", error);
					resolveOnce({ success: false, error: "Form submission failed" });
				};

				// Timeout after 10 seconds
				setTimeout(() => {
					console.log("⏰ Form submission timeout");
					resolveOnce({ success: false, error: "Timeout" });
				}, 10000);

				// Execute submission
				document.body.appendChild(iframe);
				document.body.appendChild(form);
				form.submit();
			} catch (error) {
				console.error("❌ Form submission setup failed:", error);
				resolve({ success: false, error: error.message });
			}
		});
	}

	// ADD TO EXISTING MEALS FUNCTIONALITY
	async addToExistingMeals() {
		console.log("Adding to existing meals...");

		const weekId = this.selectedWeek.id;
		const currentMeals = this.mealQuantities[weekId] || {};
		const currentOptions = this.mealOptions[weekId] || {};

		// Get existing saved data
		const existingSelection = this.weeklySelections[weekId];
		if (
			!existingSelection ||
			(!existingSelection.meals && !existingSelection.proteinBalls)
		) {
			alert("No existing selection found to add to.");
			return;
		}

		// Convert current selector state to meal data format
		const meals = this.weeklyMenus[weekId] || this.weeklyMenus["monday-0"];
		const newMeals = this.buildNewMealsArray(currentMeals, currentOptions, meals);
		const hasNewMeals = newMeals.length > 0;

		// Check for any protein ball selections across all protein ball meals
		const proteinBallMeals = meals.filter(m => this.isProteinBallMeal(m.id));
		const hasNewProteinBalls = proteinBallMeals.some(m => {
			const sel = this.proteinBallSelections[weekId]?.[m.id];
			return sel && sel !== "none";
		});

		// Check if we have ANYTHING to add (meals OR protein balls)
		if (!hasNewMeals && !hasNewProteinBalls) {
			alert("Please select at least one meal or protein ball option to add.");
			return;
		}

		// Combine with existing meals
		const combinedMeals = [...(existingSelection.meals || []), ...newMeals];

		// Handle protein balls - combine existing + new into array
		const existingPBArray = existingSelection.proteinBallsArray ||
			(existingSelection.proteinBalls ? [existingSelection.proteinBalls] : []);

		const newPBArray = [];
		if (hasNewProteinBalls) {
			proteinBallMeals.forEach(meal => {
				const sel = this.proteinBallSelections[weekId]?.[meal.id];
				if (!sel || sel === "none" || !meal.options?.[sel]) return;
				const selectedOption = meal.options[sel];
				newPBArray.push({
					id: meal.id,
					name: meal.name,
					selectedOption: sel,
					optionLabel: selectedOption.label,
					price: selectedOption.price || 0,
					shopifyHandle: meal.shopifyHandle
				});
			});
		}

		// Merge: keep existing entries not being replaced, add new ones
		const mergedPBArray = [...existingPBArray];
		newPBArray.forEach(newPB => {
			const existingIdx = mergedPBArray.findIndex(pb => pb.id === newPB.id);
			if (existingIdx >= 0) {
				mergedPBArray[existingIdx] = newPB;
			} else {
				mergedPBArray.push(newPB);
			}
		});

		const finalProteinBalls = mergedPBArray.length > 0 ? mergedPBArray[0] : null;
		const finalProteinBallsArray = mergedPBArray;

		// Show confirmation
		const totalNewMeals = newMeals.reduce((sum, meal) => sum + meal.quantity, 0);
		const totalExistingMeals = (existingSelection.meals || []).reduce(
			(sum, meal) => sum + meal.quantity,
			0
		);
		const totalCombinedMeals = totalNewMeals + totalExistingMeals;

		let confirmMessage = "";
		if (hasNewMeals && hasNewProteinBalls) {
			confirmMessage = `Add ${totalNewMeals} meal${
				totalNewMeals > 1 ? "s" : ""
			} + protein balls to your existing selection?\n\n`;
		} else if (hasNewMeals) {
			confirmMessage = `Add ${totalNewMeals} meal${
				totalNewMeals > 1 ? "s" : ""
			} to your existing ${totalExistingMeals} meal${
				totalExistingMeals > 1 ? "s" : ""
			}?\n\n`;
		} else {
			confirmMessage = `Add protein balls to your existing selection?\n\n`;
		}

		confirmMessage += `New meal total: ${totalCombinedMeals} meals for ${this.selectedWeek.display}\n\nContinue?`;

		const confirmed = confirm(confirmMessage);
		if (!confirmed) return;

		// DISABLE BUTTONS DURING SAVE
		const addBtn = document.querySelector("[data-add-to-meals]");
		const saveBtn = document.querySelector("[data-save-order]");

		let originalAddText = "";
		let originalSaveText = "";

		if (addBtn) {
			originalAddText = addBtn.textContent;
			addBtn.textContent = "➕ Adding...";
			addBtn.disabled = true;
		}

		if (saveBtn) {
			originalSaveText = saveBtn.textContent;
			saveBtn.disabled = true;
		}

		try {
			// Save to Google Sheets and localStorage
			await this.saveAddOnMeals(
				weekId,
				newMeals,
				combinedMeals,
				finalProteinBalls,
				finalProteinBallsArray,
				hasNewProteinBalls
			);
		} catch (error) {
			console.error("Error adding meals:", error);
			alert("Error adding meals. Please try again.");
		} finally {
			// RE-ENABLE BUTTONS
			if (addBtn) {
				addBtn.textContent = originalAddText;
				addBtn.disabled = false;
			}

			if (saveBtn) {
				saveBtn.disabled = false;
			}
		}
	}

	buildNewMealsArray(currentMeals, currentOptions, meals) {
		const newMeals = [];

		for (const [mealId, quantity] of Object.entries(currentMeals)) {
			if (quantity > 0) {
				const meal = meals.find((m) => m.id === mealId);
				if (meal) {
					const selectedOptions = currentOptions[mealId] || {};

					let totalAddOnCost = 0;
					const optionDetails = {};

					if (meal.options) {
						Object.entries(selectedOptions).forEach(([optionKey, isSelected]) => {
							if (isSelected && meal.options[optionKey]) {
								const option = meal.options[optionKey];
								optionDetails[optionKey] = {
									label: option.label,
									price: option.price || 0,
									isSelected: true
								};
								totalAddOnCost += (option.price || 0) * quantity;
							}
						});
					}

					newMeals.push({
						id: meal.id,
						name: meal.name,
						description: meal.description,
						quantity: quantity,
						shopifyHandle: meal.shopifyHandle,
						selectedOptions: selectedOptions,
						optionDetails: optionDetails,
						totalAddOnCost: totalAddOnCost
					});
				}
			}
		}
		return newMeals;
	}

	async saveAddOnMeals(
		weekId,
		newMeals,
		combinedMeals,
		finalProteinBalls,
		finalProteinBallsArray,
		hasNewProteinBalls) {
			
		const orderDataForSheets = {
			customerId: this.customer.id,
			customerEmail: this.customer.email,
			customerName: this.customer.name.trim(),
			weekId: weekId,
			deliveryDay: weekId.startsWith('sunday') ? 'Sunday' : 'Wednesday', 
			deliveryDate: this.selectedWeek.deliveryDate.toISOString(),
			deliveryDisplay: this.selectedWeek.display,
			submissionTime: new Date().toISOString(),
			meals: newMeals,
			proteinBalls: hasNewProteinBalls ? finalProteinBalls : null,
			proteinBallsArray: finalProteinBallsArray.length > 0 ? finalProteinBallsArray : null,
			saveAttemptId: `addon_${Date.now()}_${Math.random()
				.toString(36)
				.substr(2, 5)}`,
			isAddition: true,
			isReplacement: false
		};
		console.log("📝 Saving as ADDITION (will add to existing)");

		try {
			// Save to Google Sheets
			if (!this.googleSheets) {
				this.googleSheets = new GoogleSheetsIntegration();
			}

			const sheetsResult = await this.saveToGoogleSheetsClean(orderDataForSheets);
			if (sheetsResult.success) {
				console.log("✅ Successfully saved addition to Google Sheets");
			} else {
				console.error("❌ Google Sheets save failed:", sheetsResult.error);
			}
		} catch (error) {
			console.error("❌ Google Sheets save failed:", error);
		}

		// Save combined data to localStorage
		const combinedOrderData = {
			...orderDataForSheets,
			meals: combinedMeals, 
			proteinBalls: finalProteinBalls, 
			proteinBallsArray: finalProteinBallsArray.length > 0 ? finalProteinBallsArray : null,
			isReplacement: true 
		};

		await this.saveToLocalStorage(combinedOrderData);
		
		try {
			console.log('💾 Saving combined meals to Railway...');
			const railwayResult = await this.railwayAPI.saveSelection(combinedOrderData);
			if (railwayResult.success) {
				console.log('✅ Railway addition save: SUCCESS');
			} else {
				console.error('❌ Railway addition save failed');
			}
		} catch (error) {
			console.error('❌ Railway addition error:', error);
		}
		
		this.updateLocalState(weekId, combinedOrderData);

		// Clear current selection
		this.mealQuantities[weekId] = {};
		this.mealOptions[weekId] = {};
		this.proteinBallSelections[weekId] = {};

		const totalNewMeals = newMeals.reduce((sum, meal) => sum + meal.quantity, 0);

		let successMessage = "";
		if (totalNewMeals > 0 && hasNewProteinBalls) {
			successMessage = `${totalNewMeals} meals + protein balls added`;
		} else if (totalNewMeals > 0) {
			successMessage = `${totalNewMeals} meals added`;
		} else {
			successMessage = "Protein balls added";
		}

		this.handleSuccessfulSave(successMessage, false);
	}

	// ERROR HANDLING AND USER FEEDBACK
	handleGoogleSheetsFailure(saveId, orderData, error) {
		try {
			console.log(`🚨 [${saveId}] Handling Google Sheets failure`);

			// Store failure for admin review
			const alertData = {
				type: "GOOGLE_SHEETS_FAILURE",
				saveAttemptId: saveId,
				customer: {
					id: orderData.customerId,
					email: orderData.customerEmail,
					name: orderData.customerName
				},
				weekId: orderData.weekId,
				deliveryDisplay: orderData.deliveryDisplay,
				totalMeals: orderData.meals.reduce((sum, meal) => sum + meal.quantity, 0),
				error: error.message,
				timestamp: new Date().toISOString(),
				mealDetails: orderData.meals.map((meal) => ({
					name: meal.name,
					quantity: meal.quantity,
					addOnCost: meal.totalAddOnCost || 0
				}))
			};

			// Store alert in localStorage for admin review
			const alertKey = `critical_alerts`;
			let alerts = [];
			try {
				const existing = localStorage.getItem(alertKey);
				alerts = existing ? JSON.parse(existing) : [];
			} catch (e) {
				alerts = [];
			}

			alerts.push(alertData);
			if (alerts.length > 50) {
				alerts = alerts.slice(-50);
			}

			localStorage.setItem(alertKey, JSON.stringify(alerts));
			console.log(`📧 [${saveId}] Alert stored for admin review`);
		} catch (alertError) {
			console.error(`❌ [${saveId}] Failed to create alert:`, alertError);
		}
	}

	showUserWarning() {
		try {
			// Remove any existing warning
			const existingWarning = document.getElementById("save-warning");
			if (existingWarning) {
				existingWarning.remove();
			}

			// Show a subtle warning to the user
			const warningHtml = `
			<div id="save-warning" style="
			  background: #fff3cd; 
			  color: #856404; 
			  padding: 15px; 
			  border-radius: 8px; 
			  margin: 15px 0;
			  border: 2px solid #ffeaa7;
			  font-size: 14px;
			  line-height: 1.4;
			">
			  <strong>⚠️ Important:</strong> Your meal selection has been saved to your device. We're experiencing a temporary technical issue with our main system, but your order is secure. Our team will ensure your selections are processed correctly for delivery.
			</div>`;

			// Add warning after the order summary
			const summarySection = document.querySelector("[data-order-summary]");
			if (summarySection) {
				summarySection.insertAdjacentHTML("afterend", warningHtml);

				// Remove warning after 15 seconds
				setTimeout(() => {
					const warning = document.getElementById("save-warning");
					if (warning) warning.remove();
				}, 15000);
			}

			console.log("⚠️ User warning displayed");
		} catch (error) {
			console.error("Failed to show user warning:", error);
		}
	}

	// STATE MANAGEMENT HELPERS
	updateLocalState(weekId, orderData) {
		this.weeklySelections[weekId] = {
			hasSelection: true,
			meals: orderData.meals,
			submissionTime: orderData.submissionTime,
			totals: this.calculateOrderTotals(orderData.meals),
			proteinBalls: orderData.proteinBalls || null,
			proteinBallsArray: orderData.proteinBallsArray || null
		};

		// Update protein ball selections in memory
		if (orderData.proteinBalls) {
			if (!this.proteinBallSelections[weekId]) {
				this.proteinBallSelections[weekId] = {};
			}
			// Use saved meal ID as key (supports both old meal-30 and new prb### IDs)
			const pbId = orderData.proteinBalls.id || "meal-30";
			this.proteinBallSelections[weekId][pbId] = orderData.proteinBalls.selectedOption;
		}
		// Also handle proteinBallsArray for multiple protein ball types
		if (orderData.proteinBallsArray && orderData.proteinBallsArray.length > 0) {
			if (!this.proteinBallSelections[weekId]) {
				this.proteinBallSelections[weekId] = {};
			}
			orderData.proteinBallsArray.forEach(pb => {
				const pbId = pb.id || "meal-30";
				this.proteinBallSelections[weekId][pbId] = pb.selectedOption;
			});
		}
	}

	calculateOrderTotals(meals) {
		let baseMeals = 0;
		let totalAddOnCost = 0;
		let addOnDetails = [];

		meals.forEach((meal) => {
			baseMeals += meal.quantity;

			if (meal.totalAddOnCost > 0) {
				totalAddOnCost += meal.totalAddOnCost;

				Object.values(meal.optionDetails || {}).forEach((option) => {
					if (option.isSelected && option.price > 0) {
						addOnDetails.push({
							mealName: meal.name.replace(/<[^>]*>/g, '').trim(),
							optionName: option.label,
							quantity: meal.quantity,
							unitPrice: option.price,
							totalPrice: option.price * meal.quantity
						});
					}
				});
			}
		});

		return {
			baseMeals,
			totalAddOnCost,
			addOnDetails,
			grandTotal: totalAddOnCost
		};
	}

	handleSuccessfulSave(successMessage, isNewSave = true) {
		if (isNewSave) {
			alert(
				"✅ Your meal selection has been saved!\n\n" +
					successMessage +
					" for " +
					this.selectedWeek.display
			);
		} else {
			alert("✅ Meals added successfully!");
		}

		// CLEAR THE CURRENT SELECTIONS - Fresh start after save
		this.clearAllWorkingSelections();
		this.renderWeeks();
		this.updateOrderSummary();

		if (this.customerPortal) {
			this.customerPortal.loadPortalData();
		}

		setTimeout(() => {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		}, 500);
	}
	// CLEAR CURRENT SELECTIONS - Reset UI to clean state
	clearAllWorkingSelections() {
		// DON'T clear if viewing a past deadline week
		if (this.selectedWeek && this.selectedWeek.isDeadlinePassed) {
			const hasSelection = this.hasExistingSelection(this.selectedWeek.id);
			if (hasSelection) {
				console.log(
					"🛡️ Protected: Not clearing while viewing past deadline with selection"
				);
				return;
			}
		}

		// Clear ALL working selections across all weeks
		this.mealQuantities = {};
		this.mealOptions = {};
		this.proteinBallSelections = {};

		if (Math.random() < 0.1) {
			this.domCache = null;
		}

		// If there's a selected week, ensure its working state is clean
		if (this.selectedWeek) {
			const weekId = this.selectedWeek.id;
			this.mealQuantities[weekId] = {};
			this.mealOptions[weekId] = {};
			this.proteinBallSelections[weekId] = {};
		}

		// Force UI to reflect clean state
		this.enforceCleanUIState();

		console.log("🧹 Cleared ALL working selections - complete clean slate");
	}
	handlePageVisibilityChange() {
		if (!document.hidden) {
			// Page became visible again - ensure clean state
			console.log("📄 Page became visible - ensuring clean state");
			this.clearAllWorkingSelections();

			// If a week is selected, refresh its display
			if (this.selectedWeek) {
				setTimeout(() => {
					this.showMealSelection();
				}, 100);
			}
		}
	}
	async loadExistingSelections() {
		try {
			console.log("🔄 Loading meal selections...");

			// Check if we should sync from cloud
			const shouldSync = this.shouldSyncFromCloud();

			if (shouldSync) {
				console.log("☁️ Syncing from cloud...");
				await this.syncFromCloud();
			} else {
				console.log("📂 Loading from localStorage (cached)...");
				this.loadFromLocalStorage();
			}

			// ⚠️ ADD THIS DEBUGGING
			console.log("📊 After loading, weeklySelections:", this.weeklySelections);
			Object.keys(this.weeklySelections).forEach((weekId) => {
				if (
					weekId !== "lastUpdated" &&
					weekId !== "customerInfo" &&
					weekId !== "dataVersion"
				) {
					const weekData = this.weeklySelections[weekId];
					console.log(`  ${weekId}:`, {
						hasMeals: weekData.meals?.length > 0,
						mealCount: weekData.meals?.length || 0,
						hasProteinBalls: !!weekData.proteinBalls,
						proteinBallOption: weekData.proteinBalls?.selectedOption
					});
				}
			});

			// Always start with clean working state
			this.mealQuantities = {};
			this.mealOptions = {};
			this.proteinBallSelections = {};

			console.log("✅ Loaded", Object.keys(this.weeklySelections).length, "weeks");
			this.renderWeeks();
		} catch (error) {
			console.error("❌ Load error:", error);
			// Fallback to localStorage
			this.loadFromLocalStorage();
		}
	}
	shouldSyncFromCloud() {
		const storageKey = `meal_selections_${this.customer.id}`;
		const lastSyncKey = `last_sync_${this.customer.id}`;

		// Always sync if no local data
		const hasLocalData = localStorage.getItem(storageKey);
		if (!hasLocalData) {
			console.log("No local data found, will sync from cloud");
			return true;
		}

		// Check last sync time
		const lastSync = localStorage.getItem(lastSyncKey);
		if (!lastSync) {
			console.log("Never synced before, will sync from cloud");
			return true;
		}

		// Sync if last sync was more than 5 minutes ago
		const lastSyncTime = new Date(lastSync);
		const now = new Date();
		const minutesSinceSync = (now - lastSyncTime) / (1000 * 60);

		if (minutesSinceSync > 5) {
			console.log(
				`Last sync was ${minutesSinceSync.toFixed(
					1
				)} minutes ago, will sync from cloud`
			);
			return true;
		}

		console.log(
			`Last sync was ${minutesSinceSync.toFixed(1)} minutes ago, using cache`
		);
		return false;
	}
	loadFromLocalStorage() {
		try {
			const storageKey = `meal_selections_${this.customer.id}`;
			const stored = localStorage.getItem(storageKey);

			if (!stored) {
				console.log("📂 No localStorage data");
				this.weeklySelections = {};
				this.mealQuantities = {};
				this.mealOptions = {};
				this.proteinBallSelections = {};
				return;
			}

			const data = JSON.parse(stored);
			console.log("📂 Raw localStorage data:", data);

			// Reset state
			this.weeklySelections = {};
			this.mealQuantities = {};
			this.mealOptions = {};
			this.proteinBallSelections = {};

			Object.entries(data).forEach(([weekId, weekData]) => {
				if (["lastUpdated", "customerInfo", "dataVersion"].includes(weekId)) return;

				console.log(`📂 Processing ${weekId}:`, {
					hasMeals: weekData.meals?.length > 0,
					mealCount: weekData.meals?.length || 0,
					meals: weekData.meals,
					hasProteinBalls: !!weekData.proteinBalls
				});

				// Store basic selection data
				this.weeklySelections[weekId] = {
					hasSelection: true,
					meals: weekData.meals || [],
					submissionTime: weekData.submissionTime,
					proteinBalls: weekData.proteinBalls || null,
					deliveryDate: weekData.deliveryDate,
					deliveryDisplay: weekData.deliveryDisplay,
					savedAt: weekData.savedAt
				};

				// Reconstruct mealQuantities
				if (weekData.meals && weekData.meals.length > 0) {
					this.mealQuantities[weekId] = {};
					weekData.meals.forEach(meal => {
						this.mealQuantities[weekId][meal.id] = meal.quantity;
					});
				}

				// Reconstruct mealOptions
				if (weekData.meals && weekData.meals.length > 0) {
					this.mealOptions[weekId] = {};
					weekData.meals.forEach(meal => {
						if (meal.optionDetails && Object.keys(meal.optionDetails).length > 0) {
							this.mealOptions[weekId][meal.id] = {};
							Object.entries(meal.optionDetails).forEach(([optionKey, optionData]) => {
								this.mealOptions[weekId][meal.id][optionKey] = optionData.isSelected;
							});
						}
					});
				}

				// Reconstruct protein ball selections
				if (weekData.proteinBalls) {
					if (!this.proteinBallSelections[weekId]) {
						this.proteinBallSelections[weekId] = {};
					}
					const pbId = weekData.proteinBalls.id || "meal-30";
					this.proteinBallSelections[weekId][pbId] = weekData.proteinBalls.selectedOption;
				}
				// Also handle proteinBallsArray for multiple protein ball types
				if (weekData.proteinBallsArray && weekData.proteinBallsArray.length > 0) {
					if (!this.proteinBallSelections[weekId]) {
						this.proteinBallSelections[weekId] = {};
					}
					weekData.proteinBallsArray.forEach(pb => {
						const pbId = pb.id || "meal-30";
						this.proteinBallSelections[weekId][pbId] = pb.selectedOption;
					});
				}
			});

			console.log(
				"✅ Loaded from localStorage:",
				Object.keys(this.weeklySelections).length,
				"weeks"
			);
			console.log("   mealQuantities:", this.mealQuantities);
			console.log("   mealOptions:", this.mealOptions);
			console.log("   proteinBallSelections:", this.proteinBallSelections);
			
		} catch (error) {
			console.error("❌ localStorage load error:", error);
			this.weeklySelections = {};
			this.mealQuantities = {};
			this.mealOptions = {};
			this.proteinBallSelections = {};
		}
	}
	async loadFromRailway() {
		try {
			console.log('📥 Loading selections from Railway...');
			
			const response = await fetch(
				`${this.railwayAPI.baseUrl}/meal-selection/${this.customer.id}`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					}
				}
			);
			
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			
			const data = await response.json();
			console.log('✅ Railway load successful:', data);
			
			// Check if Railway has any data
			const hasRailwayData = data.success && 
								data.selections && 
								Object.keys(data.selections).length > 0;
			
			if (hasRailwayData) {
				// Railway has data - use it
				console.log(`✅ Found ${Object.keys(data.selections).length} weeks in Railway`);
				this.reconstructStateFromRailway(data.selections);
				return { success: true, source: 'railway', selections: data.selections };
			} else {
				// No Railway data - try Google Sheets fallback
				console.log('⚠️ No Railway data found, checking Google Sheets...');
				return await this.loadFromGoogleSheetsFallback();
			}
			
		} catch (error) {
			console.error('❌ Railway load failed:', error);
			// Railway failed - try Google Sheets fallback
			console.log('⚠️ Railway error, checking Google Sheets...');
			return await this.loadFromGoogleSheetsFallback();
		}
	}
	async loadFromGoogleSheetsFallback() {
		try {
			console.log('📥 Loading from Google Sheets (fallback)...');
			
			// Load from localStorage (which was populated from Google Sheets previously)
			const storedData = localStorage.getItem('mealSelections');
			if (!storedData) {
				console.log('ℹ️ No Google Sheets data found');
				return { success: true, source: 'none', selections: {} };
			}
			
			const parsed = JSON.parse(storedData);
			console.log('✅ Loaded from Google Sheets:', Object.keys(parsed).length, 'weeks');
			
			// Reconstruct state from Google Sheets data
			this.reconstructStateFromGoogleSheets(parsed);
			
			// OPTIONAL: Auto-migrate to Railway
			if (this.autoMigrateToRailway) {
				await this.migrateGoogleSheetsToRailway(parsed);
			}
			
			return { success: true, source: 'google-sheets', selections: parsed };
			
		} catch (error) {
			console.error('❌ Google Sheets fallback failed:', error);
			return { success: false, source: 'none', selections: {} };
		}
	}
	async syncFromCloud() {
		try {
			console.log("☁️ Fetching from Railway...");
			this.syncStatus.showSyncing();

			const result = await this.railwayAPI.loadSelections(this.customer.id, 4);

			if (result.success && result.selections) {
				// Apply Railway data
				this.weeklySelections = {};

				Object.entries(result.selections).forEach(([weekId, weekData]) => {
					if (["lastUpdated", "customerInfo", "dataVersion"].includes(weekId)) return;

					this.weeklySelections[weekId] = {
						hasSelection: weekData.hasSelections || false,
						meals: weekData.meals?.meals || [],
						submissionTime: weekData.submissionTime,
						proteinBalls: null, // Parse from meals if needed
						deliveryDate: weekData.deliveryDate,
						deliveryDisplay: weekData.deliveryDisplay || this.getDisplayForDate(weekData.deliveryDate),
						savedAt: weekData.createdAt,
						deadlinePassed: weekData.deadlinePassed || false,
						isEditable: weekData.isEditable !== false
					};
				});

				// Save to localStorage
				this.saveAllToLocalStorage(result.selections);

				// Update last sync time
				const lastSyncKey = `last_sync_${this.customer.id}`;
				localStorage.setItem(lastSyncKey, new Date().toISOString());

				this.syncStatus.showSuccess("Synced from Railway!");
				console.log("✅ Synced from Railway:", Object.keys(this.weeklySelections).length, "weeks");
			} else {
				// Fallback to localStorage
				console.log("No Railway data, using localStorage");
				this.loadFromLocalStorage();
				this.syncStatus.hide();
			}
		} catch (error) {
			console.error("❌ Railway sync failed:", error);
			// Fallback to localStorage
			this.loadFromLocalStorage();
			this.syncStatus.showOffline();
		}
	}
	async migrateGoogleSheetsToRailway(googleSheetsData) {
		console.log('🔄 Auto-migrating Google Sheets data to Railway...');
		
		let migrated = 0;
		let failed = 0;
		
		for (const [weekId, selection] of Object.entries(googleSheetsData)) {
			try {
				// Convert Google Sheets format to Railway format
				const orderData = {
					customerId: this.customer.id,
					customerEmail: this.customer.email,
					customerName: this.customer.name,
					weekId: weekId,
					deliveryDay: weekId.startsWith('sunday') ? 'Sunday' : 'Wednesday',
					deliveryDate: selection.deliveryDate,
					deliveryDisplay: selection.deliveryDisplay,
					submissionTime: selection.submissionTime || new Date().toISOString(),
					meals: selection.meals || [],
					proteinBalls: selection.proteinBalls || null,
					isReplacement: true
				};
				
				// Save to Railway
				const result = await this.railwayAPI.saveSelection(orderData);
				
				if (result.success) {
					migrated++;
					console.log(`✅ Migrated ${weekId} to Railway`);
				} else {
					failed++;
					console.error(`❌ Failed to migrate ${weekId}`);
				}
				
			} catch (error) {
				failed++;
				console.error(`❌ Error migrating ${weekId}:`, error);
			}
		}
		
		console.log(`🔄 Migration complete: ${migrated} succeeded, ${failed} failed`);
	}

	reconstructStateFromRailway(selections) {
		for (const [weekId, selection] of Object.entries(selections)) {
			// Initialize nested objects
			if (!this.mealQuantities[weekId]) this.mealQuantities[weekId] = {};
			if (!this.mealOptions[weekId]) this.mealOptions[weekId] = {};
			if (!this.proteinBallSelections[weekId]) this.proteinBallSelections[weekId] = {};
			
			// Reconstruct mealQuantities and mealOptions
			if (selection.meals && Array.isArray(selection.meals)) {
				selection.meals.forEach(meal => {
					this.mealQuantities[weekId][meal.id] = meal.quantity;
					
					const optionDetails = meal.optionDetails || meal.OptionDetails;
					if (optionDetails && Object.keys(optionDetails).length > 0) {
						this.mealOptions[weekId][meal.id] = {};
						for (const [optionKey, optionData] of Object.entries(optionDetails)) {
							// Handle both isSelected and IsSelected
							const isSelected = optionData.isSelected ?? optionData.IsSelected ?? false;
							this.mealOptions[weekId][meal.id][optionKey] = isSelected;
						}
					}
				});
			}
			
			// Reconstruct protein balls
			if (selection.proteinBalls && selection.proteinBalls.selectedOption !== 'none') {
				if (!this.proteinBallSelections[weekId]) {
					this.proteinBallSelections[weekId] = {};
				}
				const pbId = selection.proteinBalls.id || "meal-30";
				this.proteinBallSelections[weekId][pbId] = selection.proteinBalls.selectedOption;
			}
			// Also handle proteinBallsArray
			if (selection.proteinBallsArray && selection.proteinBallsArray.length > 0) {
				if (!this.proteinBallSelections[weekId]) {
					this.proteinBallSelections[weekId] = {};
				}
				selection.proteinBallsArray.forEach(pb => {
					const pbId = pb.id || "meal-30";
					this.proteinBallSelections[weekId][pbId] = pb.selectedOption;
				});
			}
			
			// Store in weeklySelections
			this.weeklySelections[weekId] = {
				hasSelection: selection.hasSelections,
				submissionTime: selection.submissionTime,
				meals: selection.meals || [],
				proteinBalls: selection.proteinBalls,
				deliveryDate: selection.deliveryDate,
				deliveryDay: selection.deliveryDay,
				mealCount: selection.mealCount
			};
		}
		
		console.log('✅ State reconstructed from Railway');
	}

	reconstructStateFromGoogleSheets(data) {
		// This is similar to your existing loadExistingSelections logic
		for (const [weekId, selection] of Object.entries(data)) {
			if (!this.mealQuantities[weekId]) this.mealQuantities[weekId] = {};
			if (!this.mealOptions[weekId]) this.mealOptions[weekId] = {};
			if (!this.proteinBallSelections[weekId]) this.proteinBallSelections[weekId] = {};
			
			// Reconstruct from Google Sheets format
			if (selection.meals && Array.isArray(selection.meals)) {
				selection.meals.forEach(meal => {
					this.mealQuantities[weekId][meal.id] = meal.quantity;
					
					if (meal.optionDetails) {
						this.mealOptions[weekId][meal.id] = {};
						for (const [optionKey, isSelected] of Object.entries(meal.optionDetails)) {
							this.mealOptions[weekId][meal.id][optionKey] = isSelected;
						}
					}
				});
			}
			
			if (selection.proteinBalls) {
				const pbId = selection.proteinBalls.id || "meal-30";
				this.proteinBallSelections[weekId][pbId] = selection.proteinBalls.selectedOption;
			}
			if (selection.proteinBallsArray && selection.proteinBallsArray.length > 0) {
				selection.proteinBallsArray.forEach(pb => {
					const pbId = pb.id || "meal-30";
					this.proteinBallSelections[weekId][pbId] = pb.selectedOption;
				});
			}
			
			this.weeklySelections[weekId] = selection;
		}
		
		console.log('✅ State reconstructed from Google Sheets');
	}

	saveAllToLocalStorage(selections) {
		try {
			const storageKey = `meal_selections_${this.customer.id}`;

			const saveData = {
				...selections,
				dataVersion: this.dataVersion,
				lastUpdated: new Date().toISOString(),
				customerInfo: {
					id: this.customer.id,
					name: this.customer.name,
					email: this.customer.email
				}
			};

			localStorage.setItem(storageKey, JSON.stringify(saveData));
			console.log("✅ Saved to localStorage");
		} catch (error) {
			console.error("❌ localStorage save error:", error);
		}
	}

	loadFromLocal() {
		try {
			const storageKey = `meal_selections_${this.customer.id}`;
			const stored = localStorage.getItem(storageKey);

			if (!stored) {
				console.log("📂 No local data found");
				return null;
			}

			const data = JSON.parse(stored);
			console.log("📂 Loaded local data:", Object.keys(data).length, "entries");

			return data;
		} catch (error) {
			console.error("❌ Error loading from local:", error);
			return null;
		}
	}

	async loadFromCloud() {
		try {
			console.log("☁️ Fetching data from Google Sheets...");

			// Use POST to avoid CORS
			const response = await fetch(this.googleSheets.webAppUrl, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded"
				},
				body: new URLSearchParams({
					action: "getSelections",
					data: JSON.stringify({
						customerId: this.customer.id,
						customerEmail: this.customer.email
					})
				})
			});

			const result = await response.json();
			console.log("☁️ Cloud data received:", result);

			return result;
		} catch (error) {
			console.warn("☁️ Could not load from cloud:", error.message);
			throw error;
		}
	}

	mergeSelectionData(localData, cloudData) {
		console.log("🔀 === MERGE START ===");

		if (!cloudData || Object.keys(cloudData).length === 0) {
			return { selections: localData, hasChanges: false };
		}

		// ✅ CLOUD IS SOURCE OF TRUTH (it already has base + additions combined)
		const merged = {};
		let hasChanges = false;

		Object.keys(cloudData).forEach((weekId) => {
			if (
				weekId === "lastUpdated" ||
				weekId === "customerInfo" ||
				weekId === "dataVersion"
			) {
				return;
			}

			const cloudWeek = cloudData[weekId];
			const localWeek = localData ? localData[weekId] : null;

			// Always use cloud data (it's already the final reconstructed state)
			merged[weekId] = cloudWeek;

			if (!localWeek) {
				console.log(`  ✨ ${weekId}: New from cloud`);
				hasChanges = true;
			} else {
				// Check if different
				const cloudTime = new Date(
					cloudWeek.savedAt || cloudWeek.submissionTime
				).getTime();
				const localTime = new Date(
					localWeek.savedAt || localWeek.submissionTime
				).getTime();

				const cloudMealCount = cloudWeek.meals ? cloudWeek.meals.length : 0;
				const localMealCount = localWeek.meals ? localWeek.meals.length : 0;

				if (cloudTime !== localTime || cloudMealCount !== localMealCount) {
					console.log(
						`  🔄 ${weekId}: Updated from cloud (cloud: ${cloudMealCount} meals at ${new Date(
							cloudTime
						).toISOString()})`
					);
					hasChanges = true;
				}
			}
		});

		console.log("🔀 === MERGE END ===", {
			hasChanges: hasChanges,
			totalWeeks: Object.keys(merged).length
		});

		return {
			selections: merged,
			hasChanges: hasChanges
		};
	}

	detectStaleWeekData(data) {
		// Check if stored data has week dates that don't match current config
		const currentWeekDate = this.weekConfig.currentWeek.sunday.date;

		if (data["sunday-0"]) {
			const storedDate = data["sunday-0"].deliveryDate;
			if (storedDate && !storedDate.includes(currentWeekDate)) {
				return true; // Data is from old week structure
			}
		}
		return false;
	}
}
/*
function addNextWeek() {
	const newWeek = {
		id: "2025-09-22", // Change this to the next Monday's date
		mondayDate: "2025-09-22",
		thursdayDate: "2025-09-25",
		mondayDisplay: "Monday September 22",
		thursdayDisplay: "Thursday September 25",
		deadline: "2025-09-17T16:00:00",
		deadlineDisplay: "Wed 9/17 at 4:00 PM"
	};

	if (window.mealSelector) {
		return window.mealSelector.addNewWeek(newWeek);
	}
	return false;
}

// NEW: Utility to convert old data format (run once if needed)
function convertLegacyData() {
	const customers = ["customer1", "customer2"]; // Add actual customer IDs

	customers.forEach((customerId) => {
		const storageKey = `meal_selections_${customerId}`;
		const data = localStorage.getItem(storageKey);

		if (data) {
			try {
				const parsed = JSON.parse(data);
				const converted = {};

				// Convert old keys to new date-based keys
				Object.entries(parsed).forEach(([key, value]) => {
					if (key === "monday-0") {
						converted["monday-2025-09-08"] = value;
					} else if (key === "thursday-0") {
						converted["thursday-2025-09-11"] = value;
					} else if (key === "monday-1") {
						converted["monday-2025-09-15"] = value;
					} else if (key === "thursday-1") {
						converted["thursday-2025-09-18"] = value;
					} else {
						converted[key] = value; // Keep metadata
					}
				});

				localStorage.setItem(storageKey, JSON.stringify(converted));
				console.log(`Converted data for ${customerId}`);
			} catch (e) {
				console.error(`Failed to convert data for ${customerId}:`, e);
			}
		}
	});
}

function debugWeekConfiguration() {
	const selector = window.mealSelector;

	console.log("=== WEEK CONFIGURATION DEBUG ===");

	// Check available weeks
	const availableWeeks = selector.getAvailableWeeks();
	console.log(
		"Available weeks:",
		availableWeeks.map((w) => ({
			id: w.id,
			display: w.display
		}))
	);

	// Check menu keys
	console.log("Menu data keys:", Object.keys(selector.weeklyMenus));

	// Check for mismatches
	availableWeeks.forEach((week) => {
		const hasMenu = selector.weeklyMenus[week.id];
		console.log(
			`Week ${week.id} (${week.display}): ${
				hasMenu ? "✅ HAS MENU" : "❌ MISSING MENU"
			}`
		);

		if (hasMenu) {
			console.log(`  - ${hasMenu.length} meals available`);
		}
	});

	return {
		availableWeeks: availableWeeks.length,
		menuKeys: Object.keys(selector.weeklyMenus).length,
		mismatches: availableWeeks.filter((w) => !selector.weeklyMenus[w.id]).length
	};
}
*/
function verifyWeekIdFix() {
	const selector = window.mealSelector;

	console.log("=== VERIFYING WEEK ID FIX ===");

	const availableWeeks = selector.getAvailableWeeks();
	console.log("Generated week IDs:");
	availableWeeks.forEach((week) => {
		const hasMenu = selector.weeklyMenus[week.id] ? "✅" : "❌";
		console.log(`${hasMenu} ${week.id} (${week.display})`);
	});

	console.log("\nMenu keys:");
	Object.keys(selector.weeklyMenus).forEach((key) => {
		console.log(`📋 ${key}`);
	});

	const mismatches = availableWeeks.filter((w) => !selector.weeklyMenus[w.id]);
	console.log(
		`\n${
			mismatches.length === 0
				? "✅ ALL WEEK IDS MATCH MENU KEYS!"
				: "❌ Still have mismatches:"
		}`
	);

	if (mismatches.length > 0) {
		mismatches.forEach((week) => {
			console.log(`❌ Missing menu for: ${week.id}`);
		});
	}

	return mismatches.length === 0;
}
function debugEmailData() {
	const selector = window.mealSelector;
	const portal = selector.customerPortal;

	console.log("=== EMAIL DATA DEBUG ===");
	console.log("weeklySelections keys:", Object.keys(selector.weeklySelections));

	// Check for duplicates
	Object.entries(selector.weeklySelections).forEach(([weekId, data]) => {
		if (weekId !== "lastUpdated" && weekId !== "customerInfo") {
			console.log(`${weekId}:`, {
				hasSelection: data.hasSelection,
				mealsCount: data.meals ? data.meals.length : 0,
				submissionTime: data.submissionTime,
				proteinBalls: !!data.proteinBalls
			});
		}
	});

	return selector.weeklySelections;
}
/*
function cleanupLegacyDuplicates() {
	const selector = window.mealSelector;
	const storageKey = `meal_selections_${selector.customer.id}`;

	console.log("🧹 Starting legacy data cleanup...");

	// Get current data
	const data = JSON.parse(localStorage.getItem(storageKey) || "{}");
	console.log("Before cleanup keys:", Object.keys(data));

	// Create clean data object
	const cleanData = {};

	// Keep metadata
	if (data.lastUpdated) cleanData.lastUpdated = data.lastUpdated;
	if (data.customerInfo) cleanData.customerInfo = data.customerInfo;

	// Handle the conflicting entries by keeping the newer format and newer timestamp
	
    const conflicts = [
        {
            old: 'monday-1',
            new: 'monday-2025-09-15',
            deliveryDate: '2025-09-15'
        },
        {
            old: 'thursday-1', 
            new: 'thursday-2025-09-18',
            deliveryDate: '2025-09-18'
        }
    ];
    conflicts.forEach(conflict => {
        const oldEntry = data[conflict.old];
        const newEntry = data[conflict.new];
        
        console.log(`\n--- Processing conflict: ${conflict.old} vs ${conflict.new} ---`);
        
        if (oldEntry && newEntry) {
            // Both exist - keep the one with the newer timestamp
            const oldTime = new Date(oldEntry.submissionTime || 0);
            const newTime = new Date(newEntry.submissionTime || 0);
            
            if (newTime > oldTime) {
                console.log(`✅ Keeping newer entry: ${conflict.new} (${newEntry.submissionTime})`);
                console.log(`❌ Removing older entry: ${conflict.old} (${oldEntry.submissionTime})`);
                cleanData[conflict.new] = newEntry;
            } else {
                console.log(`✅ Keeping newer entry: ${conflict.old} (${oldEntry.submissionTime})`);
                console.log(`❌ Removing older entry: ${conflict.new} (${newEntry.submissionTime})`);
                // Convert old format to new format
                cleanData[conflict.new] = {
                    ...oldEntry,
                    deliveryDate: `${conflict.deliveryDate}T00:00:00.000Z`
                };
            }
        } else if (oldEntry) {
            console.log(`📋 Converting old format ${conflict.old} to new format ${conflict.new}`);
            cleanData[conflict.new] = {
                ...oldEntry,
                deliveryDate: `${conflict.deliveryDate}T00:00:00.000Z`
            };
        } else if (newEntry) {
            console.log(`✅ Keeping new format entry: ${conflict.new}`);
            cleanData[conflict.new] = newEntry;
        }
    });

	// Remove the problematic migrationTimestamp entry
	console.log("🗑️ Removing migrationTimestamp entry");

	// Add any other entries that don't conflict
	Object.entries(data).forEach(([key, value]) => {
		if (
			key !== "lastUpdated" &&
			key !== "customerInfo" &&
			key !== "migrationTimestamp" &&
			key !== "monday-1" &&
			key !== "thursday-1" &&
			key !== "monday-2025-09-15" &&
			key !== "thursday-2025-09-18"
		) {
			cleanData[key] = value;
		}
	});

	console.log("\n=== CLEANUP SUMMARY ===");
	console.log("Before:", Object.keys(data));
	console.log("After:", Object.keys(cleanData));
	console.log("Removed duplicates for Monday Sep 15 and Thursday Sep 18");

	// Save cleaned data
	cleanData.lastUpdated = new Date().toISOString();
	localStorage.setItem(storageKey, JSON.stringify(cleanData));

	// Reload the meal selector data
	selector.loadExistingSelections();

	// Refresh the portal
	if (selector.customerPortal) {
		selector.customerPortal.loadPortalData();
	}

	console.log("✅ Cleanup complete! Email should now show correct data.");

	return {
		before: Object.keys(data).length,
		after: Object.keys(cleanData).length,
		cleanData: cleanData
	};
}
*/
// Debug functions for admin/developer use
window.mealSelectorDebug = {
	// View sync logs
	viewLogs: () => {
		if (window.mealSelector && window.mealSelector.syncLogger) {
			const logs = window.mealSelector.syncLogger.getLogs();
			console.table(logs);
			return logs;
		}
	},

	// Export logs to file
	exportLogs: () => {
		if (window.mealSelector && window.mealSelector.syncLogger) {
			window.mealSelector.syncLogger.exportLogs();
		}
	},

	// View recent errors
	viewErrors: () => {
		if (window.mealSelector && window.mealSelector.syncLogger) {
			const logs = window.mealSelector.syncLogger.getLogs();
			const errors = logs.filter((log) => log.event.includes("error"));
			console.table(errors);
			return errors;
		}
	},

	// Clear logs
	clearLogs: () => {
		if (window.mealSelector && window.mealSelector.syncLogger) {
			window.mealSelector.syncLogger.clearLogs();
			console.log("✅ Logs cleared");
		}
	},

	// Force sync
	forceSync: async () => {
		if (window.mealSelector) {
			console.log("🔄 Forcing sync...");
			await window.mealSelector.loadExistingSelections();
			console.log("✅ Sync complete");
		}
	},

	// View current sync status
	status: () => {
		if (window.mealSelector && window.mealSelector.syncStatus) {
			return window.mealSelector.syncStatus.getCurrentStatus();
		}
	}
};

console.log("💡 Debug tools available: window.mealSelectorDebug");

// Migrate any old monday-/thursday- localStorage keys to sunday-/wednesday-
function migrateDayNamesToSundayWednesday() {
	const storageKeys = Object.keys(localStorage).filter(k => k.startsWith('meal_selections_'));
	if (storageKeys.length === 0) return;

	storageKeys.forEach(storageKey => {
		try {
			const data = JSON.parse(localStorage.getItem(storageKey) || '{}');
			let changed = false;
			const migrated = {};

			Object.keys(data).forEach(key => {
				if (key.startsWith('monday-') && key.length > 7) {
					// monday-YYYY-MM-DD → sunday-YYYY-MM-DD (subtract 1 day)
					const datePart = key.replace('monday-', '');
					const d = new Date(datePart);
					d.setDate(d.getDate() - 1);
					const newKey = 'sunday-' + d.toISOString().split('T')[0];
					migrated[newKey] = { ...data[key], deliveryDay: 'Sunday' };
					console.log(`🔄 Migrated ${key} → ${newKey}`);
					changed = true;
				} else if (key.startsWith('thursday-') && key.length > 9) {
					// thursday-YYYY-MM-DD → wednesday-YYYY-MM-DD (subtract 1 day)
					const datePart = key.replace('thursday-', '');
					const d = new Date(datePart);
					d.setDate(d.getDate() - 1);
					const newKey = 'wednesday-' + d.toISOString().split('T')[0];
					migrated[newKey] = { ...data[key], deliveryDay: 'Wednesday' };
					console.log(`🔄 Migrated ${key} → ${newKey}`);
					changed = true;
				} else {
					migrated[key] = data[key];
				}
			});

			if (changed) {
				localStorage.setItem(storageKey, JSON.stringify(migrated));
				console.log(`✅ localStorage migration complete for ${storageKey}`);
			}
		} catch(e) {
			console.error('Migration error:', e);
		}
	});
}

// INITIALIZATION
document.addEventListener("DOMContentLoaded", () => {
	const customerData = window.customerData || {};

	// Simple check - you can expand this logic
	const isNonSubscriber =
		!customerData.tags ||
		!customerData.tags.some(
			(tag) =>
				tag.toLowerCase().includes("meals per week") ||
				tag.toLowerCase().includes("vip")
		);

	if (isNonSubscriber) {
		console.log("Non-subscriber view activated");
	}
	// Only initialize if we're showing the meal selector (not login screen)
	if (document.querySelector(".weekly-meal-selector")) {
		window.mealSelector = new WeeklyMealSelector(); // Store on window
	} else {
		console.log("Login screen detected - not initializing meal selector");
	}
});
